(function () {
  if (window.PersonalizePilotWidgetLoaded) {
    if (typeof window.PersonalizePilotAttachAllWidgets === "function") {
      window.PersonalizePilotAttachAllWidgets();
    }
    return;
  }

  window.PersonalizePilotWidgetLoaded = true;
  document.documentElement.dataset.personalizePilotRuntimeLoaded = "true";

  var MAX_FILE_SIZE_BYTES = 10 * 1024 * 1024;
  var WHITE_PREVIEW_MAX_DIMENSION = 1800;
  var transparentTemplatePreviewCache = {};
  var product3dRuntimePromise = null;
  var personalizationGeometry = window.PersonalizePilotGeometry || null;
  var ALLOWED_FILE_EXTENSIONS = [
    ".jpg",
    ".jpeg",
    ".png",
    ".webp",
    ".gif",
    ".svg",
    ".pdf",
  ];

  function rebaseCustomerTemplateTextGeometry(state, resolvedLayout) {
    if (!state || state.kind !== "template-text" || !resolvedLayout) return;
    var previousBase = state.base || resolvedLayout;
    var offsetX = Number(state.x) - Number(previousBase.x);
    var offsetY = Number(state.y) - Number(previousBase.y);
    state.base = resolvedLayout;
    state.x =
      Number(resolvedLayout.x) + (Number.isFinite(offsetX) ? offsetX : 0);
    state.y =
      Number(resolvedLayout.y) + (Number.isFinite(offsetY) ? offsetY : 0);
  }

  function loadProduct3dRuntime(scriptUrl) {
    if (window.PersonalizePilot3D) {
      return Promise.resolve(window.PersonalizePilot3D);
    }
    if (product3dRuntimePromise) return product3dRuntimePromise;
    product3dRuntimePromise = new Promise(function (resolve, reject) {
      if (!scriptUrl) {
        reject(new Error("Die 3D-Datei ist nicht konfiguriert."));
        return;
      }
      var script = document.createElement("script");
      script.src = scriptUrl;
      script.async = true;
      script.dataset.personalizePilot3dRuntime = "true";
      script.onload = function () {
        if (window.PersonalizePilot3D) resolve(window.PersonalizePilot3D);
        else reject(new Error("Die 3D-Laufzeit wurde nicht initialisiert."));
      };
      script.onerror = function () {
        product3dRuntimePromise = null;
        reject(new Error("Die 3D-Datei konnte nicht geladen werden."));
      };
      document.head.appendChild(script);
    });
    return product3dRuntimePromise;
  }

  function getMessage(widget, key, fallback) {
    return (widget && widget.dataset && widget.dataset[key]) || fallback;
  }

  async function readProxyJson(response) {
    var contentType = String(
      response.headers.get("content-type") || "",
    ).toLowerCase();

    if (contentType.indexOf("application/json") === -1) {
      return null;
    }

    try {
      return JSON.parse(await response.text());
    } catch (error) {
      return null;
    }
  }

  function getFileExtension(fileName) {
    var normalizedName = String(fileName || "").toLowerCase();
    var dotIndex = normalizedName.lastIndexOf(".");

    return dotIndex >= 0 ? normalizedName.slice(dotIndex) : "";
  }

  function getAllowedFileExtensions(input) {
    var mode = (input && input.dataset.fileMode) || "all_supported";

    if (mode === "images") {
      return [".jpg", ".jpeg", ".png", ".webp", ".gif", ".svg"];
    }
    if (mode === "images_pdf") {
      return [".jpg", ".jpeg", ".png", ".webp", ".gif", ".pdf"];
    }

    return ALLOWED_FILE_EXTENSIONS;
  }

  function getFileError(widget, file, input) {
    if (!file) {
      return "";
    }

    var configuredLimitMb = Number(
      (input && input.dataset.maxFileSizeMb) || 10,
    );
    var limitMb = Math.max(
      1,
      Math.min(10, Number.isFinite(configuredLimitMb) ? configuredLimitMb : 10),
    );
    var maxFileSizeBytes = Math.min(MAX_FILE_SIZE_BYTES, limitMb * 1024 * 1024);

    if (file.size > maxFileSizeBytes) {
      return getMessage(
        widget,
        "messageFileTooLarge",
        "The file is larger than 10 MB.",
      ).replace("10", String(limitMb));
    }

    if (
      getAllowedFileExtensions(input).indexOf(getFileExtension(file.name)) ===
      -1
    ) {
      return input && input.dataset.fileMode
        ? getMessage(
            widget,
            "messageFileNotAllowed",
            "This file type is not allowed for this field.",
          )
        : getMessage(
            widget,
            "messageFileUnsupported",
            "Please upload an image, SVG file or PDF file.",
          );
    }

    return "";
  }

  function inspectRasterImage(widget, file, input) {
    if (!file || !/\.(jpe?g|png|webp|gif)$/i.test(file.name)) {
      return Promise.resolve({ error: "", width: 0, height: 0 });
    }

    return new Promise(function (resolve) {
      var image = new Image();
      var objectUrl = URL.createObjectURL(file);

      image.onload = function () {
        var minimumWidth = Math.max(
          0,
          Number(input.dataset.minImageWidthPx || 0),
        );
        var minimumHeight = Math.max(
          0,
          Number(input.dataset.minImageHeightPx || 0),
        );
        var width = image.naturalWidth;
        var height = image.naturalHeight;
        var error = "";

        URL.revokeObjectURL(objectUrl);
        if (minimumWidth > 0 && width < minimumWidth) {
          error = getMessage(
            widget,
            "messageImageTooNarrow",
            "The image must be at least {min} px wide (currently {actual} px).",
          )
            .replace("{min}", String(minimumWidth))
            .replace("{actual}", String(width));
        } else if (minimumHeight > 0 && height < minimumHeight) {
          error = getMessage(
            widget,
            "messageImageTooShort",
            "The image must be at least {min} px high (currently {actual} px).",
          )
            .replace("{min}", String(minimumHeight))
            .replace("{actual}", String(height));
        }
        resolve({ error: error, width: width, height: height });
      };
      image.onerror = function () {
        URL.revokeObjectURL(objectUrl);
        resolve({ error: "", width: 0, height: 0 });
      };
      image.src = objectUrl;
    });
  }

  function isNearWhitePixel(pixels, index) {
    return (
      pixels[index] >= 235 &&
      pixels[index + 1] >= 235 &&
      pixels[index + 2] >= 235 &&
      pixels[index + 3] > 8
    );
  }

  function hasWhiteImageBackground(pixels, width, height) {
    var sampleStep = Math.max(1, Math.floor(Math.min(width, height) / 180));
    var whiteBorderPixels = 0;
    var sampledBorderPixels = 0;
    var x;
    var y;

    function sample(pixelX, pixelY) {
      var index = (pixelY * width + pixelX) * 4;
      sampledBorderPixels += 1;
      if (isNearWhitePixel(pixels, index)) whiteBorderPixels += 1;
    }

    for (x = 0; x < width; x += sampleStep) {
      sample(x, 0);
      if (height > 1) sample(x, height - 1);
    }
    for (y = sampleStep; y < height - 1; y += sampleStep) {
      sample(0, y);
      if (width > 1) sample(width - 1, y);
    }

    return (
      sampledBorderPixels > 0 && whiteBorderPixels / sampledBorderPixels >= 0.55
    );
  }

  function removeWhiteImageBackground(pixels, width, height) {
    var minimumX = width;
    var minimumY = height;
    var maximumX = -1;
    var maximumY = -1;
    var index;

    for (index = 0; index < pixels.length; index += 4) {
      var distanceFromWhite = Math.max(
        255 - pixels[index],
        255 - pixels[index + 1],
        255 - pixels[index + 2],
      );
      var retainedOpacity = Math.max(
        0,
        Math.min(1, (distanceFromWhite - 30) / 60),
      );
      var alpha = Math.round(pixels[index + 3] * retainedOpacity);

      pixels[index + 3] = alpha;
      if (alpha <= 8) continue;

      var pixelIndex = index / 4;
      var x = pixelIndex % width;
      var y = Math.floor(pixelIndex / width);
      minimumX = Math.min(minimumX, x);
      minimumY = Math.min(minimumY, y);
      maximumX = Math.max(maximumX, x);
      maximumY = Math.max(maximumY, y);
    }

    if (maximumX < minimumX || maximumY < minimumY) return null;
    return {
      minimumX: minimumX,
      minimumY: minimumY,
      maximumX: maximumX,
      maximumY: maximumY,
    };
  }

  function getVisibleImageBounds(pixels, width, height) {
    var minimumX = width;
    var minimumY = height;
    var maximumX = -1;
    var maximumY = -1;
    var index;

    for (index = 0; index < pixels.length; index += 4) {
      if (pixels[index + 3] <= 8) continue;
      var pixelIndex = index / 4;
      var x = pixelIndex % width;
      var y = Math.floor(pixelIndex / width);
      minimumX = Math.min(minimumX, x);
      minimumY = Math.min(minimumY, y);
      maximumX = Math.max(maximumX, x);
      maximumY = Math.max(maximumY, y);
    }

    if (maximumX < minimumX || maximumY < minimumY) return null;
    return {
      minimumX: minimumX,
      minimumY: minimumY,
      maximumX: maximumX,
      maximumY: maximumY,
    };
  }

  function canvasToPreviewObjectUrl(canvas) {
    return new Promise(function (resolve, reject) {
      canvas.toBlob(function (blob) {
        if (!blob) {
          reject(new Error("Transparent preview could not be created."));
          return;
        }
        resolve(URL.createObjectURL(blob));
      }, "image/png");
    });
  }

  function createTransparentWhitePreviewObjectUrl(source, cropToContent) {
    return new Promise(function (resolve, reject) {
      var image = new Image();
      var isRemoteSource = typeof source === "string";
      var sourceUrl = isRemoteSource ? source : URL.createObjectURL(source);

      if (isRemoteSource && !/^(data:|blob:)/i.test(sourceUrl)) {
        image.crossOrigin = "anonymous";
      }

      function releaseSourceUrl() {
        if (!isRemoteSource) URL.revokeObjectURL(sourceUrl);
      }

      image.onload = function () {
        var scale = Math.min(
          1,
          WHITE_PREVIEW_MAX_DIMENSION /
            Math.max(image.naturalWidth, image.naturalHeight, 1),
        );
        var width = Math.max(1, Math.round(image.naturalWidth * scale));
        var height = Math.max(1, Math.round(image.naturalHeight * scale));
        var canvas = document.createElement("canvas");
        var context = canvas.getContext("2d", { willReadFrequently: true });

        releaseSourceUrl();
        if (!context) {
          reject(new Error("Transparent preview is not supported."));
          return;
        }

        canvas.width = width;
        canvas.height = height;
        context.clearRect(0, 0, width, height);
        context.drawImage(image, 0, 0, width, height);

        try {
          var imageData = context.getImageData(0, 0, width, height);
          var removesWhite = hasWhiteImageBackground(
            imageData.data,
            width,
            height,
          );
          var bounds = removesWhite
            ? removeWhiteImageBackground(imageData.data, width, height)
            : getVisibleImageBounds(imageData.data, width, height);
          if (!bounds) {
            resolve("");
            return;
          }

          var alreadyTight =
            bounds.minimumX === 0 &&
            bounds.minimumY === 0 &&
            bounds.maximumX === width - 1 &&
            bounds.maximumY === height - 1;
          if (!removesWhite && (cropToContent === false || alreadyTight)) {
            resolve("");
            return;
          }

          if (removesWhite) context.putImageData(imageData, 0, 0);
          if (cropToContent === false) {
            canvasToPreviewObjectUrl(canvas).then(resolve, reject);
            return;
          }

          var cropX = bounds.minimumX;
          var cropY = bounds.minimumY;
          var cropWidth = bounds.maximumX - bounds.minimumX + 1;
          var cropHeight = bounds.maximumY - bounds.minimumY + 1;
          var croppedCanvas = document.createElement("canvas");
          var croppedContext = croppedCanvas.getContext("2d");

          if (!croppedContext) {
            reject(new Error("Transparent preview could not be cropped."));
            return;
          }

          croppedCanvas.width = cropWidth;
          croppedCanvas.height = cropHeight;
          croppedContext.drawImage(
            canvas,
            cropX,
            cropY,
            cropWidth,
            cropHeight,
            0,
            0,
            cropWidth,
            cropHeight,
          );
          canvasToPreviewObjectUrl(croppedCanvas).then(resolve, reject);
        } catch (error) {
          reject(error);
        }
      };
      image.onerror = function () {
        releaseSourceUrl();
        reject(new Error("Image could not be prepared."));
      };
      image.src = sourceUrl;
    });
  }

  function getTransparentTemplatePreviewUrl(sourceUrl) {
    if (!sourceUrl) return Promise.resolve("");
    if (!transparentTemplatePreviewCache[sourceUrl]) {
      transparentTemplatePreviewCache[sourceUrl] =
        // A template's complete pixel canvas is part of its saved geometry.
        // Cropping transparent margins here would enlarge the visible artwork
        // a second time when it is placed into the configured product area.
        // White backgrounds may still be removed, but the original canvas and
        // therefore the editor/storefront coordinate contract must remain.
        createTransparentWhitePreviewObjectUrl(sourceUrl, false)
          .then(function (transparentUrl) {
            return transparentUrl || sourceUrl;
          })
          .catch(function () {
            return sourceUrl;
          });
    }
    return transparentTemplatePreviewCache[sourceUrl];
  }

  async function uploadFileToPrivateStorage(widget, file, label, input) {
    var prepareResponse = await fetch("/apps/personalize-pilot/upload", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        intent: "prepare",
        fileName: file.name,
        mimeType: file.type || "application/octet-stream",
        fileSize: file.size,
        label: label || "Kundendatei",
        templateId: widget.dataset.templateId || "",
        slotId: (input && input.dataset.personalizationSlotId) || "",
        productId: widget.dataset.productId || "",
      }),
    });

    if (prepareResponse.status === 503) {
      return null;
    }

    var prepared = await readProxyJson(prepareResponse);
    if (!prepared) {
      return null;
    }
    if (!prepareResponse.ok || !prepared.ok) {
      throw new Error(
        prepared.error ||
          getMessage(
            widget,
            "messageUploadPreparing",
            "The secure upload could not be prepared.",
          ),
      );
    }

    var uploadResponse;
    if (prepared.uploadMethod === "proxy-form") {
      var localUploadForm = new FormData();
      localUploadForm.append("intent", "store-local");
      localUploadForm.append("assetId", prepared.assetId || "");
      localUploadForm.append(
        "verificationToken",
        prepared.verificationToken || "",
      );
      localUploadForm.append("file", file, file.name || "upload.bin");
      uploadResponse = await fetch(prepared.uploadUrl, {
        method: "POST",
        body: localUploadForm,
      });
    } else {
      uploadResponse = await fetch(prepared.uploadUrl, {
        method: "PUT",
        headers: { "Content-Type": file.type || "application/octet-stream" },
        body: file,
      });
    }

    if (!uploadResponse.ok) {
      var uploadFailure = await readProxyJson(uploadResponse);
      throw new Error(
        (uploadFailure && uploadFailure.error) ||
          getMessage(
            widget,
            "messageUploadFailed",
            "The secure upload failed.",
          ),
      );
    }

    var completeResponse = await fetch("/apps/personalize-pilot/upload", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        intent: "complete",
        assetId: prepared.assetId,
        verificationToken: prepared.verificationToken || "",
      }),
    });
    var completed = await readProxyJson(completeResponse);

    if (!completed || !completeResponse.ok || !completed.ok) {
      throw new Error(
        (completed && completed.error) ||
          getMessage(
            widget,
            "messageUploadVerifyFailed",
            "The file could not be verified.",
          ),
      );
    }

    return completed;
  }

  function getPreviewFontFamily(font) {
    var normalizedFont = String(font || "").toLowerCase();

    if (normalizedFont.indexOf("dancing script") >= 0) {
      return "'PersonalizePilot Dancing Script', cursive";
    }

    if (normalizedFont.indexOf("playfair display") >= 0) {
      return "'PersonalizePilot Playfair Display', serif";
    }

    if (
      normalizedFont.indexOf("great vibes") >= 0 ||
      normalizedFont === "script"
    ) {
      return "'PersonalizePilot Great Vibes', cursive";
    }

    if (normalizedFont.indexOf("bebas") >= 0 || normalizedFont === "bold") {
      return "'PersonalizePilot Bebas Neue', sans-serif";
    }

    if (
      normalizedFont.indexOf("montserrat") >= 0 ||
      normalizedFont === "modern"
    ) {
      return "'PersonalizePilot Montserrat', sans-serif";
    }

    if (normalizedFont.indexOf("roboto slab") >= 0) {
      return "'PersonalizePilot Roboto Slab', serif";
    }

    if (normalizedFont.indexOf("arvo") >= 0 || normalizedFont === "serif") {
      return "'PersonalizePilot Arvo', serif";
    }

    if (normalizedFont.indexOf("cinzel") >= 0 || normalizedFont === "elegant") {
      return "'PersonalizePilot Cinzel', serif";
    }

    if (
      normalizedFont.indexOf("pacifico") >= 0 ||
      normalizedFont === "rund" ||
      normalizedFont.indexOf("kinder") >= 0 ||
      normalizedFont.indexOf("comic") >= 0
    ) {
      return "'PersonalizePilot Pacifico', cursive";
    }

    if (
      normalizedFont.indexOf("caveat") >= 0 ||
      normalizedFont.indexOf("handschrift") >= 0 ||
      normalizedFont.indexOf("signature") >= 0 ||
      normalizedFont.indexOf("hochzeit") >= 0 ||
      normalizedFont.indexOf("floral") >= 0
    ) {
      return "'PersonalizePilot Caveat', cursive";
    }

    if (
      normalizedFont.indexOf("libre baskerville") >= 0 ||
      normalizedFont.indexOf("klassisch") >= 0 ||
      normalizedFont.indexOf("luxury") >= 0 ||
      normalizedFont.indexOf("vintage") >= 0 ||
      normalizedFont.indexOf("altdeutsch") >= 0
    ) {
      return "'PersonalizePilot Libre Baskerville', serif";
    }

    if (
      normalizedFont.indexOf("oswald") >= 0 ||
      normalizedFont.indexOf("rustikal") >= 0 ||
      normalizedFont.indexOf("industrial") >= 0 ||
      normalizedFont.indexOf("block") >= 0 ||
      normalizedFont.indexOf("feuerwehr") >= 0 ||
      normalizedFont.indexOf("stencil") >= 0 ||
      normalizedFont.indexOf("sport") >= 0 ||
      normalizedFont.indexOf("tech") >= 0 ||
      normalizedFont.indexOf("gravur breit") >= 0
    ) {
      return "'PersonalizePilot Oswald', sans-serif";
    }

    return "'PersonalizePilot Poppins', sans-serif";
  }

  function getPreviewFontWeight(font) {
    void font;
    return "400";
  }

  var textMeasurementCanvas = null;

  function measureTextMetrics(styles, text, fontSize) {
    if (!textMeasurementCanvas) {
      textMeasurementCanvas = document.createElement("canvas");
    }

    var context = textMeasurementCanvas.getContext("2d");
    var fontFamily = styles.fontFamily || "Arial, sans-serif";
    var fontWeight = styles.fontWeight || "800";
    var fontStyle = styles.fontStyle || "normal";

    context.font =
      fontStyle + " " + fontWeight + " " + fontSize + "px " + fontFamily;

    var normalizedText = String(text || " ");
    var metrics = context.measureText(normalizedText);
    var letterSpacing = Math.max(
      0,
      parseFloat(styles.letterSpacing || "0") || 0,
    );
    var width =
      metrics.width +
      Math.max(0, Array.from(normalizedText).length - 1) * letterSpacing;
    var ascent = Number.isFinite(metrics.actualBoundingBoxAscent)
      ? metrics.actualBoundingBoxAscent
      : fontSize * 0.78;
    var descent = Number.isFinite(metrics.actualBoundingBoxDescent)
      ? metrics.actualBoundingBoxDescent
      : fontSize * 0.22;
    var left = Number(metrics.actualBoundingBoxLeft) || 0;
    var right = Number.isFinite(metrics.actualBoundingBoxRight)
      ? metrics.actualBoundingBoxRight
      : width;

    return {
      width: Math.max(width, left + right),
      height: Math.max(fontSize * 0.72, ascent + descent),
      ascent: ascent,
      descent: descent,
      left: left,
      right: right,
    };
  }

  function measureTextWidth(styles, text, fontSize) {
    return measureTextMetrics(styles, text, fontSize).width;
  }

  function measureWrappedText(styles, text, fontSize, maxWidth) {
    var paragraphs = String(text || " ").split(/\r?\n/);
    var lineCount = 0;
    var widestLine = 0;

    paragraphs.forEach(function (paragraph) {
      var words = paragraph.split(/\s+/).filter(Boolean);
      var currentLine = "";

      if (words.length === 0) {
        lineCount += 1;
        return;
      }

      words.forEach(function (word) {
        var nextLine = currentLine ? currentLine + " " + word : word;
        var nextWidth = measureTextWidth(styles, nextLine, fontSize);

        if (currentLine && nextWidth > maxWidth) {
          widestLine = Math.max(
            widestLine,
            measureTextWidth(styles, currentLine, fontSize),
          );
          lineCount += 1;
          currentLine = word;
        } else {
          currentLine = nextLine;
        }
      });

      widestLine = Math.max(
        widestLine,
        measureTextWidth(styles, currentLine, fontSize),
      );
      lineCount += 1;
    });

    return { lineCount: lineCount, width: widestLine };
  }

  function getAutoFitFontSize(widget, text, target) {
    var styles = window.getComputedStyle(target || widget);
    var widgetStyles = window.getComputedStyle(widget);
    var baseSize =
      parseFloat(styles.getPropertyValue("--slot-size")) ||
      parseFloat(
        widgetStyles.getPropertyValue("--personalize-pilot-text-size"),
      ) ||
      28;
    var autoFit =
      target && target.dataset.autoFitText
        ? target.dataset.autoFitText === "true"
        : widget.dataset.autoFitText === "true";

    if (!autoFit) {
      return baseSize;
    }

    var targetRect =
      target && target.getBoundingClientRect
        ? target.getBoundingClientRect()
        : null;
    var textValue = String(text || "Dein Text").trim() || "Dein Text";
    var allowLineBreaks = Boolean(
      target && target.dataset && target.dataset.allowLineBreaks === "true",
    );

    if (targetRect && targetRect.width > 0 && targetRect.height > 0) {
      var paddingX =
        (parseFloat(styles.paddingLeft) || 0) +
        (parseFloat(styles.paddingRight) || 0);
      var paddingY =
        (parseFloat(styles.paddingTop) || 0) +
        (parseFloat(styles.paddingBottom) || 0);
      var availableWidth = Math.max(0.1, targetRect.width - paddingX);
      var availableHeight = Math.max(0.1, targetRect.height - paddingY);
      var lineHeightRatio = 1.08;
      var curveHeightRatio =
        Math.abs(Number(target.dataset.textCurve || 0)) / 100;
      // A hard 7px floor can still clip a long but valid customer name. The
      // production renderer is allowed to shrink down to 1mm, so the browser
      // preview must also keep fitting until the complete text is visible.
      var minSize = Math.min(2, baseSize);
      var low = minSize;
      var opticalStraight = isOpticalStraightText(target);
      // The configured font size is the design maximum. Auto-fit may shrink a
      // long customer text, but must never enlarge a short name beyond the
      // merchant-approved layout; otherwise storefront and production drift.
      var high = Math.min(180, Math.max(minSize, baseSize));
      var index = 0;

      while (index < 14) {
        var mid = (low + high) / 2;
        var wrappedMeasurement = allowLineBreaks
          ? measureWrappedText(styles, textValue, mid, availableWidth)
          : null;
        var measuredWidth = wrappedMeasurement
          ? wrappedMeasurement.width
          : measureTextMetrics(styles, textValue.replace(/\s+/g, " "), mid)
              .width;
        var lineCount = wrappedMeasurement ? wrappedMeasurement.lineCount : 1;
        var opticalHeight = measureTextMetrics(styles, textValue, mid).height;
        // CSS font boxes can be taller than the canvas' optical glyph bounds,
        // especially for serif descenders such as g, j, p, q and y. Reserve a
        // small deterministic line-box margin so overflow clipping never cuts
        // off the lower strokes in the product, mobile or follower preview.
        var measuredHeight =
          (opticalStraight
            ? opticalHeight
            : Math.max(opticalHeight, mid * 1.12)) +
          Math.max(0, lineCount - 1) * mid * lineHeightRatio +
          mid * curveHeightRatio * 0.35;

        if (
          measuredWidth <= availableWidth * 0.94 &&
          measuredHeight <= availableHeight * 0.94
        ) {
          low = mid;
        } else {
          high = mid;
        }

        index += 1;
      }

      return Math.max(minSize, Number(low.toFixed(3)));
    }

    return Math.round(Math.max(10, baseSize));
  }

  function isOpticalStraightText(target) {
    return Boolean(
      target &&
      target.dataset.autoFitText === "true" &&
      target.dataset.allowLineBreaks !== "true" &&
      Math.abs(Number(target.dataset.textCurve || 0)) <= 1 &&
      !isCurvedSurface(target) &&
      !target.hasAttribute("data-freeform-preview"),
    );
  }

  // Use visible glyph bounds, not an invisible CSS line box. SVG keeps the
  // alphabetic baseline and descenders inside the unchanged engraving slot.
  function renderOpticalStraightText(target, value) {
    if (!isOpticalStraightText(target)) return;
    var width = target.clientWidth;
    var height = target.clientHeight;
    var styles = window.getComputedStyle(target);
    var definitionName = (target.dataset.mainPreviewTextSlot || target.dataset.previewTextSlot) === "definition-name";
    if (definitionName) {
      // Integer client sizes add different SVG letterboxing to each text row.
      width = parseFloat(styles.width) || width;
      height = parseFloat(styles.height) || height;
    }
    if (!(width > 0 && height > 0)) return;
    var fontSize = parseFloat(styles.fontSize) || 16;
    var text = String(value || "Dein Text").replace(/\s+/g, " ");
    var metrics = measureTextMetrics(styles, text, fontSize);
    var x = width / 2 + (metrics.left - metrics.right) / 2;
    if (styles.textAlign === "left") x = width * 0.03 + metrics.left;
    if (styles.textAlign === "right") x = width * 0.97 - metrics.right;
    var svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    svg.dataset.opticalTextSvg = "true";
    svg.setAttribute("viewBox", "0 0 " + width + " " + height);
    svg.setAttribute("preserveAspectRatio", definitionName ? "xMinYMid meet" : "xMidYMid meet");
    svg.setAttribute("width", "100%");
    svg.setAttribute("height", "100%");
    svg.style.cssText =
      "position:absolute;inset:0;width:100%;height:100%;overflow:hidden;pointer-events:none";
    var label = document.createElementNS("http://www.w3.org/2000/svg", "text");
    label.setAttribute("x", String(x));
    label.setAttribute(
      "y",
      String(height / 2 + (metrics.ascent - metrics.descent) / 2),
    );
    label.setAttribute("fill", "currentColor");
    label.setAttribute("font-size", String(fontSize));
    label.setAttribute("dominant-baseline", "alphabetic");
    label.textContent = text;
    svg.appendChild(label);
    target.replaceChildren(svg);
  }

  function getSurfaceMode(target) {
    return (target && target.dataset && target.dataset.surfaceMode) || "flat";
  }

  function getSurfaceIntensity(target) {
    var rawIntensity =
      target && target.dataset
        ? Number(target.dataset.surfaceIntensity || "0")
        : 0;

    if (!Number.isFinite(rawIntensity)) {
      return 0;
    }

    return Math.max(0, Math.min(100, rawIntensity));
  }

  function isCurvedSurface(target) {
    return getSurfaceMode(target) !== "flat" && getSurfaceIntensity(target) > 0;
  }

  function getWarpCanvas(target) {
    var canvas = target.querySelector(".personalize-pilot-warp-canvas");

    if (!canvas) {
      canvas = document.createElement("canvas");
      canvas.className = "personalize-pilot-warp-canvas";
      canvas.setAttribute("aria-hidden", "true");
      target.appendChild(canvas);
    }

    return canvas;
  }

  function clearWarpCanvas(target) {
    var canvas =
      target && target.querySelector
        ? target.querySelector(".personalize-pilot-warp-canvas")
        : null;

    if (canvas) {
      canvas.remove();
    }

    if (target) {
      target.classList.remove("is-canvas-warped");
    }
  }

  function wrapCanvasText(context, text, maxWidth) {
    var words = String(text || "")
      .split(/\s+/)
      .filter(Boolean);
    var lines = [];
    var currentLine = "";

    if (words.length === 0) {
      return [""];
    }

    words.forEach(function (word) {
      var testLine = currentLine ? currentLine + " " + word : word;

      if (context.measureText(testLine).width <= maxWidth || !currentLine) {
        currentLine = testLine;
        return;
      }

      lines.push(currentLine);
      currentLine = word;
    });

    if (currentLine) {
      lines.push(currentLine);
    }

    return lines.slice(0, 4);
  }

  function getProjectedWarpX(mode, normalizedX, curve) {
    var t = (normalizedX + 1) / 2;
    var power = 1 + curve * 0.58;
    var angle = 0.22 + curve * 0.82;

    if (mode === "slight_curve") {
      return normalizedX - Math.pow(normalizedX, 3) * curve * 0.08;
    }

    if (mode === "cylinder_left") {
      return -1 + 2 * Math.pow(t, power);
    }

    if (mode === "cylinder_right") {
      return 1 - 2 * Math.pow(1 - t, power);
    }

    return Math.sin(normalizedX * angle) / Math.sin(angle);
  }

  function drawWarpedCanvas(sourceCanvas, targetCanvas, mode, intensity) {
    var context = targetCanvas.getContext("2d");
    var width = targetCanvas.width;
    var height = targetCanvas.height;
    var curve = Math.max(0, Math.min(1, intensity / 100));
    var step = Math.max(1, Math.round(width / 260));
    var sourceX = 0;

    context.clearRect(0, 0, width, height);

    while (sourceX < width) {
      var nextSourceX = Math.min(width, sourceX + step);
      var normalizedX = (sourceX / width) * 2 - 1;
      var nextNormalizedX = (nextSourceX / width) * 2 - 1;
      var projectedX = getProjectedWarpX(mode, normalizedX, curve);
      var nextProjectedX = getProjectedWarpX(mode, nextNormalizedX, curve);
      var destinationX = ((projectedX + 1) / 2) * width;
      var nextDestinationX = ((nextProjectedX + 1) / 2) * width;
      var stripWidth = Math.max(1, nextDestinationX - destinationX + 0.75);
      var midX = (normalizedX + nextNormalizedX) / 2;
      var edgeAmount = Math.pow(
        Math.abs(midX),
        mode === "slight_curve" ? 1.25 : 1.7,
      );
      var verticalInset =
        height * curve * edgeAmount * (mode === "slight_curve" ? 0.018 : 0.045);
      var destinationHeight = height - verticalInset * 2;

      context.drawImage(
        sourceCanvas,
        sourceX,
        0,
        nextSourceX - sourceX,
        height,
        destinationX,
        verticalInset,
        stripWidth,
        destinationHeight,
      );
      sourceX = nextSourceX;
    }
  }

  function prepareWarpCanvas(target) {
    var rect = target.getBoundingClientRect();
    var canvas = getWarpCanvas(target);
    var ratio = Math.min(2, window.devicePixelRatio || 1);
    var width = Math.max(1, Math.round(rect.width));
    var height = Math.max(1, Math.round(rect.height));
    var pixelWidth = Math.max(1, Math.round(width * ratio));
    var pixelHeight = Math.max(1, Math.round(height * ratio));
    var sourceCanvas = document.createElement("canvas");
    var sourceContext = sourceCanvas.getContext("2d");

    canvas.width = pixelWidth;
    canvas.height = pixelHeight;
    sourceCanvas.width = pixelWidth;
    sourceCanvas.height = pixelHeight;
    sourceContext.scale(ratio, ratio);

    return {
      canvas: canvas,
      sourceCanvas: sourceCanvas,
      sourceContext: sourceContext,
      width: width,
      height: height,
      ratio: ratio,
    };
  }

  function drawCurvedCanvasLine(
    context,
    text,
    centerX,
    centerY,
    maxWidth,
    maxHeight,
    curve,
  ) {
    var characters = Array.from(String(text || ""));
    var widths = characters.map(function (character) {
      return context.measureText(character).width;
    });
    var textWidth = widths.reduce(function (total, width) {
      return total + width;
    }, 0);
    var normalizedCurve = getEasedCurveStrength(curve);

    if (
      characters.length === 0 ||
      Math.abs(normalizedCurve) <= 0.01 ||
      textWidth <= 1
    ) {
      context.fillText(text, centerX, centerY, maxWidth);
      return;
    }

    var scale = Math.min(1, maxWidth / textWidth);
    var renderedWidth = textWidth * scale;
    var amplitude =
      normalizedCurve * Math.min(maxHeight * 0.35, renderedWidth * 0.18);
    var cursor = centerX - renderedWidth / 2;
    var previousAlign = context.textAlign;
    context.textAlign = "center";

    characters.forEach(function (character, index) {
      var characterWidth = widths[index] * scale;
      var x = cursor + characterWidth / 2;
      var normalizedX = (x - centerX) / Math.max(renderedWidth / 2, 1);
      var y = centerY + amplitude * (normalizedX * normalizedX - 0.5);
      var slope = (4 * amplitude * normalizedX) / Math.max(renderedWidth, 1);

      context.save();
      context.translate(x, y);
      context.rotate(Math.atan(slope));
      context.scale(scale, scale);
      context.fillText(character, 0, 0);
      context.restore();
      cursor += characterWidth;
    });

    context.textAlign = previousAlign;
  }

  function getEasedCurveStrength(curve) {
    var normalized = Math.max(-1, Math.min(1, Number(curve || 0) / 100));
    var direction = normalized < 0 ? -1 : 1;

    return direction * Math.pow(Math.abs(normalized), 0.82);
  }

  function renderWarpedTextTarget(target, text) {
    if (!isCurvedSurface(target)) {
      clearWarpCanvas(target);
      renderOpticalStraightText(target, text);
      return;
    }

    var prepared = prepareWarpCanvas(target);
    var styles = window.getComputedStyle(target);
    var fontSize = parseFloat(styles.fontSize) || 24;
    var fontFamily = styles.fontFamily || "Arial, sans-serif";
    var fontWeight = styles.fontWeight || "800";
    var textAlign = styles.textAlign || "center";
    var color = styles.color === "rgba(0, 0, 0, 0)" ? "#3f2f25" : styles.color;
    var lines = [];
    var lineHeight = fontSize * 1.15;
    var startY = 0;
    var x = prepared.width / 2;
    var textCurve = Math.max(
      -100,
      Math.min(100, Number(target.dataset.textCurve || 0)),
    );

    // updatePreviewText writes a normal text node before the physical surface
    // warp is rendered. Remove that node so the customer never sees a flat and
    // a curved version on top of each other.
    Array.from(target.childNodes).forEach(function (node) {
      if (node.nodeType === 3) node.remove();
    });

    prepared.sourceContext.clearRect(0, 0, prepared.width, prepared.height);
    prepared.sourceContext.fillStyle = color;
    prepared.sourceContext.font =
      fontWeight + " " + fontSize + "px " + fontFamily;
    prepared.sourceContext.textAlign = textAlign;
    prepared.sourceContext.textBaseline = "middle";

    if (textAlign === "left" || textAlign === "start") {
      x = prepared.width * 0.08;
      prepared.sourceContext.textAlign = "left";
    } else if (textAlign === "right" || textAlign === "end") {
      x = prepared.width * 0.92;
      prepared.sourceContext.textAlign = "right";
    }

    lines =
      target.dataset.allowLineBreaks === "true"
        ? wrapCanvasText(
            prepared.sourceContext,
            text || "Dein Text",
            prepared.width * 0.88,
          )
        : [
            String(text || "Dein Text")
              .replace(/\s+/g, " ")
              .trim(),
          ];
    startY = prepared.height / 2 - ((lines.length - 1) * lineHeight) / 2;
    lines.forEach(function (line, index) {
      if (Math.abs(textCurve) > 1 && lines.length === 1) {
        drawCurvedCanvasLine(
          prepared.sourceContext,
          line,
          prepared.width / 2,
          startY + index * lineHeight,
          prepared.width * 0.88,
          prepared.height,
          textCurve,
        );
      } else {
        prepared.sourceContext.fillText(line, x, startY + index * lineHeight);
      }
    });

    drawWarpedCanvas(
      prepared.sourceCanvas,
      prepared.canvas,
      getSurfaceMode(target),
      getSurfaceIntensity(target),
    );
    target.classList.add("is-canvas-warped");
  }

  function drawFitImage(context, image, width, height, fit, scalePercent) {
    var normalizedScale = Math.max(
      0.1,
      Math.min(1, Number(scalePercent || 92) / 100),
    );
    var targetWidth = width * normalizedScale;
    var targetHeight = height * normalizedScale;
    var imageRatio = image.naturalWidth / Math.max(image.naturalHeight, 1);
    var boxRatio = targetWidth / Math.max(targetHeight, 1);
    var drawWidth = targetWidth;
    var drawHeight = targetHeight;
    var drawX = (width - targetWidth) / 2;
    var drawY = (height - targetHeight) / 2;

    if (fit === "stretch") {
      context.drawImage(image, drawX, drawY, targetWidth, targetHeight);
      return;
    }

    if (
      (fit !== "cover" && imageRatio > boxRatio) ||
      (fit === "cover" && imageRatio < boxRatio)
    ) {
      drawHeight = targetWidth / imageRatio;
      drawY = (height - drawHeight) / 2;
    } else {
      drawWidth = targetHeight * imageRatio;
      drawX = (width - drawWidth) / 2;
    }

    context.drawImage(image, drawX, drawY, drawWidth, drawHeight);
  }

  function isPhotoEngravingPreviewTarget(target) {
    return Boolean(target && target.dataset.photoEngravingPreview === "true");
  }

  function isCoverCropPreviewTarget(target) {
    return Boolean(
      target &&
      (target.dataset.imagePlacementVersion === "2" ||
        isPhotoEngravingPreviewTarget(target) ||
        target.dataset.coverCropPreview === "true" ||
        target.dataset.imageFit === "cover"),
    );
  }

  function normalizeImageScalePercent(value, maximum) {
    var number = Number(value);
    var safeMaximum = Number.isFinite(Number(maximum))
      ? Math.max(100, Number(maximum))
      : 100;

    return Math.max(
      safeMaximum === 300 ? 25 : safeMaximum > 100 ? 100 : 25,
      Math.min(
        safeMaximum,
        Number.isFinite(number)
          ? Math.round(number)
          : safeMaximum > 100
            ? 100
            : 92,
      ),
    );
  }

  function getEffectiveImageScalePercent(target, value) {
    var maximum = target && target.dataset.imagePlacementVersion === "2"
      ? 300 : isCoverCropPreviewTarget(target) ? 250 : 100;
    var safeFactor = isCoverCropPreviewTarget(target)
      ? 1
      : Math.max(
          0.1,
          Math.min(
            1,
            Number((target && target.dataset.imageShapeSafeFactor) || 100) /
              100,
          ),
        );

    return (
      Math.round(
        normalizeImageScalePercent(value, maximum) * safeFactor * 100,
      ) / 100
    );
  }

  function applyImageScaleToTarget(target, value) {
    if (!target) return;

    applyConfiguredImageFit(target);
    var imageScalePercent = normalizeImageScalePercent(
      value,
      target.dataset.imagePlacementVersion === "2" ? 300 : isCoverCropPreviewTarget(target) ? 250 : 100,
    );
    var effectiveScalePercent = getEffectiveImageScalePercent(
      target,
      imageScalePercent,
    );
    target.dataset.imageScalePercent = String(imageScalePercent);
    target.style.setProperty("--slot-image-scale", effectiveScalePercent + "%");
    target.style.setProperty(
      "--slot-image-scale-factor",
      String(effectiveScalePercent / 100),
    );
    applyCustomerImagePlacement(target);
    renderWarpedPreviewTarget(target);
  }

  // Keep this v2 contract in sync with resolvePhotoEngravingCropGeometry.
  // Percent positions always move visually left/right and up/down, even when cropped.
  function resolveCustomerImagePlacement(width, height, sourceWidth, sourceHeight, fit, zoom, x, y) {
    var scale = (fit === "contain"
      ? Math.min(width / sourceWidth, height / sourceHeight)
      : Math.max(width / sourceWidth, height / sourceHeight)) * normalizeImageScalePercent(zoom, 300) / 100;
    var imageWidth = sourceWidth * scale;
    var imageHeight = sourceHeight * scale;
    return {
      x: (width - imageWidth) / 2 + Math.abs(width - imageWidth) * (x - 50) / 100,
      y: (height - imageHeight) / 2 + Math.abs(height - imageHeight) * (y - 50) / 100,
      width: imageWidth, height: imageHeight,
    };
  }

  var customerPlacementImages = new WeakSet();
  function applyCustomerImagePlacement(target) {
    if (!target || target.dataset.imagePlacementVersion !== "2") return;
    var img = target.querySelector("img");
    if (!img) return;
    if (!customerPlacementImages.has(img)) {
      customerPlacementImages.add(img);
      img.addEventListener("load", function () { applyCustomerImagePlacement(target); });
    }
    if (!img.naturalWidth || !img.naturalHeight) return;
    var targetStyle = window.getComputedStyle(target);
    var width = parseFloat(targetStyle.width) || target.clientWidth;
    var height = parseFloat(targetStyle.height) || target.clientHeight;
    if (!width || !height) return;
    var geometry = resolveCustomerImagePlacement(width, height, img.naturalWidth, img.naturalHeight,
      target.dataset.imageFit, target.dataset.imageScalePercent || 100,
      Number(target.dataset.imagePositionXPercent || 50), Number(target.dataset.imagePositionYPercent || 50));
    target.style.setProperty("--customer-image-x", geometry.x / width * 100 + "%");
    target.style.setProperty("--customer-image-y", geometry.y / height * 100 + "%");
    target.style.setProperty("--customer-image-width", geometry.width / width * 100 + "%");
    target.style.setProperty("--customer-image-height", geometry.height / height * 100 + "%");
  }

  function applyConfiguredImageFit(target) {
    if (!target) return;

    var imageFit = isPhotoEngravingPreviewTarget(target) && target.dataset.imagePlacementVersion !== "2"
      ? "cover"
      : target.dataset.imageFit === "cover" ||
          target.dataset.imageFit === "stretch"
        ? target.dataset.imageFit
        : "contain";
    var cssImageFit = imageFit === "stretch" ? "fill" : imageFit;
    target.dataset.imageFit = imageFit;
    target.style.setProperty("--slot-image-fit", cssImageFit);
    var image = target.querySelector("img");
    if (image) {
      image.style.setProperty("object-fit", cssImageFit, "important");
      image.style.setProperty(
        "object-position",
        "var(--slot-image-position-x, 50%) var(--slot-image-position-y, 50%)",
        "important",
      );
    }
    applyCustomerImagePlacement(target);
  }

  function getTemplateArtworkStageAspectRatio(target) {
    var overlay = target
      ? target.closest(".personalize-pilot-main-preview")
      : null;
    var overlayRatio = Number(
      overlay && overlay.dataset.personalizePilotStageRatio,
    );

    if (Number.isFinite(overlayRatio) && overlayRatio > 0) {
      return overlayRatio;
    }

    var stage = target && target.parentElement;
    var stageRect =
      stage && stage.getBoundingClientRect
        ? stage.getBoundingClientRect()
        : null;

    if (stageRect && stageRect.width > 1 && stageRect.height > 1) {
      return stageRect.width / stageRect.height;
    }

    return 1;
  }

  function syncTemplateArtworkGeometry(target) {
    var image = target ? target.querySelector("img") : null;

    if (
      !target ||
      target.dataset.templateArtworkPreview !== "true" ||
      !image ||
      !image.complete ||
      !image.naturalWidth ||
      !image.naturalHeight
    ) {
      return;
    }

    var baseX = Number(target.dataset.templateBaseX || 50);
    var baseY = Number(target.dataset.templateBaseY || 50);
    var baseWidth = Math.max(
      0.01,
      Number(target.dataset.templateBaseWidth || 48),
    );
    var baseHeight = Math.max(
      0.01,
      Number(target.dataset.templateBaseHeight || 48),
    );
    var canonicalStageAspectRatio = Number(
      target.dataset.templateCanonicalStageAspectRatio,
    );
    var stageAspectRatio =
      Number.isFinite(canonicalStageAspectRatio) &&
      canonicalStageAspectRatio > 0
        ? canonicalStageAspectRatio
        : getTemplateArtworkStageAspectRatio(target);
    var artworkAspectRatio = Number(
      target.dataset.templateArtworkAspectRatio || 0,
    );
    var frameAspectRatio =
      (baseWidth * stageAspectRatio) / Math.max(baseHeight, 0.01);
    var width = baseWidth;
    var height = baseHeight;
    var fitMode = target.dataset.templateProductionFitMode || "contain";
    var usesLegacyAspectGeometry =
      target.dataset.templateLockAspectRatio === "legacy";

    // The generated preview files can contain a portrait canvas around a
    // wide engraving motif. Their raw pixel ratio must not shrink the saved
    // product layout a second time. Only normalize when the editor supplied
    // an explicit visible-artwork ratio.
    if (
      usesLegacyAspectGeometry &&
      fitMode !== "stretch" &&
      Number.isFinite(artworkAspectRatio) &&
      artworkAspectRatio > 0
    ) {
      if (artworkAspectRatio >= frameAspectRatio) {
        height = (baseWidth * stageAspectRatio) / artworkAspectRatio;
      } else {
        width = (baseHeight * artworkAspectRatio) / stageAspectRatio;
      }
    }

    target.style.setProperty("--slot-x", baseX + "%");
    target.style.setProperty("--slot-y", baseY + "%");
    target.style.setProperty("--slot-width", width + "%");
    target.style.setProperty("--slot-height", height + "%");
  }

  function renderWarpedImageTarget(target) {
    var image = target ? target.querySelector("img") : null;
    var label = target ? target.querySelector("span") : null;

    if (!target || !isCurvedSurface(target)) {
      clearWarpCanvas(target);
      return;
    }

    if (!image || image.hidden || !image.getAttribute("src")) {
      renderWarpedTextTarget(target, label ? label.textContent : "Bild");
      return;
    }

    if (!image.complete || !image.naturalWidth) {
      image.addEventListener(
        "load",
        function () {
          renderWarpedImageTarget(target);
        },
        { once: true },
      );
      return;
    }

    var prepared = prepareWarpCanvas(target);
    prepared.sourceContext.clearRect(0, 0, prepared.width, prepared.height);
    if (target.dataset.imagePlacementVersion === "2") {
      var placement = resolveCustomerImagePlacement(prepared.width, prepared.height,
        image.naturalWidth, image.naturalHeight, target.dataset.imageFit,
        target.dataset.imageScalePercent || 100, Number(target.dataset.imagePositionXPercent || 50), Number(target.dataset.imagePositionYPercent || 50));
      prepared.sourceContext.drawImage(image, placement.x, placement.y, placement.width, placement.height);
    } else drawFitImage(
      prepared.sourceContext,
      image,
      prepared.width,
      prepared.height,
      target.dataset.imageFit || "contain",
      getEffectiveImageScalePercent(
        target,
        target.dataset.imageScalePercent || "92",
      ),
    );
    drawWarpedCanvas(
      prepared.sourceCanvas,
      prepared.canvas,
      getSurfaceMode(target),
      getSurfaceIntensity(target),
    );
    target.classList.add("is-canvas-warped");
  }

  function renderWarpedPreviewTarget(target) {
    if (!target) {
      return;
    }

    if (!isCurvedSurface(target)) {
      clearWarpCanvas(target);
      return;
    }

    if (
      target.classList.contains("personalize-pilot-widget__preview-item--image")
    ) {
      renderWarpedImageTarget(target);
      return;
    }

    renderWarpedTextTarget(
      target,
      target.dataset.previewTextValue || target.textContent || "Dein Text",
    );
  }

  function isVisibleBox(element) {
    var rect =
      element && element.getBoundingClientRect
        ? element.getBoundingClientRect()
        : null;

    return Boolean(rect && rect.width >= 80 && rect.height >= 80);
  }

  function isUsefulProductImage(image, widget) {
    if (
      !image ||
      image.closest(".personalize-pilot-widget") ||
      image.closest(".personalize-pilot-main-preview")
    ) {
      return false;
    }

    if (!isVisibleBox(image)) {
      return false;
    }

    var altText = String(image.getAttribute("alt") || "").toLowerCase();
    var src = String(
      image.currentSrc || image.getAttribute("src") || "",
    ).toLowerCase();

    if (
      altText.indexOf("payment") >= 0 ||
      altText.indexOf("icon") >= 0 ||
      src.indexOf("icon") >= 0 ||
      src.indexOf("logo") >= 0
    ) {
      return false;
    }

    return !widget || !image.contains(widget);
  }

  function getBestImageSurface(image) {
    return (
      image.closest("[data-personalize-pilot-product-media]") ||
      image.closest(".product__media") ||
      image.closest(".product-media") ||
      image.closest(".product-media-container") ||
      image.closest(".product__media-item") ||
      image.closest("[data-media-id]") ||
      image.closest("media-gallery") ||
      image.parentElement
    );
  }

  function getProductImageScore(image) {
    var rect =
      image && image.getBoundingClientRect
        ? image.getBoundingClientRect()
        : null;
    var className = String((image && image.className) || "").toLowerCase();
    var parentClassName = String(
      (image && image.parentElement && image.parentElement.className) || "",
    ).toLowerCase();
    var score = rect ? rect.width * rect.height : 0;

    if (!rect) {
      return 0;
    }

    if (
      className.indexOf("thumbnail") >= 0 ||
      parentClassName.indexOf("thumbnail") >= 0
    ) {
      score *= 0.2;
    }

    if (
      className.indexOf("thumb") >= 0 ||
      parentClassName.indexOf("thumb") >= 0
    ) {
      score *= 0.35;
    }

    return score;
  }

  function getLargestVisibleProductImage(container, widget) {
    var images = container ? container.querySelectorAll("img") : [];
    var bestImage = null;
    var bestScore = 0;

    for (var index = 0; index < images.length; index += 1) {
      var image = images[index];
      var score = getProductImageScore(image);

      if (isUsefulProductImage(image, widget) && score > bestScore) {
        bestImage = image;
        bestScore = score;
      }
    }

    return bestImage;
  }

  function findProductMediaSurface(widget) {
    var productRoot =
      widget.closest('[id*="MainProduct"]') ||
      widget.closest('[id*="main-product"]') ||
      widget.closest('[data-section*="product"]') ||
      widget.closest(".shopify-section") ||
      widget.closest("section") ||
      document;
    var roots = productRoot === document ? [document] : [productRoot, document];
    var selectors = [
      "[data-personalize-pilot-product-media]",
      ".product-gallery [data-product-gallery-stage]",
      ".product-gallery .product-gallery__stage-media",
      "media-gallery .product__media-item.is-active .product__media",
      "media-gallery .product__media-item:first-child .product__media",
      ".product__media-list .product__media-item.is-active .product__media",
      ".product__media-list .product__media-item:first-child .product__media",
      ".product__media-wrapper .product__media",
      ".product__media-wrapper [data-media-id]",
      ".product__media-wrapper",
      "media-gallery",
    ];
    var imageSelectors = [
      "[data-personalize-pilot-product-media] img",
      ".product-gallery .product-gallery__stage-image",
      ".product-gallery__stage .product-media__image",
      "media-gallery img",
      ".product__media img",
      ".product__media-wrapper img",
      ".product__media-list img",
      ".product img",
    ];
    var bestImage = null;
    var bestSurface = null;
    var bestScore = 0;

    for (var rootIndex = 0; rootIndex < roots.length; rootIndex += 1) {
      var declaredSurface = roots[rootIndex].querySelector(
        "[data-personalize-pilot-product-media]",
      );

      if (
        declaredSurface &&
        !declaredSurface.contains(widget) &&
        isVisibleBox(declaredSurface)
      ) {
        return declaredSurface;
      }

      for (
        var imageSelectorIndex = 0;
        imageSelectorIndex < imageSelectors.length;
        imageSelectorIndex += 1
      ) {
        var images = roots[rootIndex].querySelectorAll(
          imageSelectors[imageSelectorIndex],
        );

        for (var imageIndex = 0; imageIndex < images.length; imageIndex += 1) {
          var image = images[imageIndex];
          var imageSurface = getBestImageSurface(image);

          if (
            isUsefulProductImage(image, widget) &&
            imageSurface &&
            !imageSurface.contains(widget) &&
            isVisibleBox(imageSurface) &&
            getProductImageScore(image) > bestScore
          ) {
            bestImage = image;
            bestSurface = imageSurface;
            bestScore = getProductImageScore(image);
          }
        }
      }

      if (bestImage && bestSurface) {
        return bestSurface;
      }

      for (var index = 0; index < selectors.length; index += 1) {
        var surface = roots[rootIndex].querySelector(selectors[index]);

        if (surface && !surface.contains(widget) && isVisibleBox(surface)) {
          return surface;
        }
      }
    }

    return null;
  }

  function getMaterialEngravingAppearance(profile) {
    var kind = profile.kind || "other";
    var effect = profile.engravingEffect || (kind === "wood" ? "engraved" : "none");
    var enabled = (kind === "wood" || kind === "leather") && effect !== "none";
    var color = /^#[0-9a-f]{6}$/i.test(profile.engravingColor || "")
      ? profile.engravingColor
      : kind === "leather" ? "#23150f" : "#52301b";
    var rgb = [1, 3, 5].map(function (offset) {
      return parseInt(color.slice(offset, offset + 2), 16) / 255;
    });
    // Black becomes the configured engraving colour; white remains white and
    // transparent pixels stay transparent. Sepia alone cannot colour black.
    var matrix = [
      1 - rgb[0], 0, 0, 0, rgb[0],
      0, 1 - rgb[1], 0, 0, rgb[1],
      0, 0, 1 - rgb[2], 0, rgb[2],
      0, 0, 0, 1, 0,
    ].join(" ");
    return {
      enabled: enabled,
      color: color,
      opacity: effect === "subtle" ? 0.60 : kind === "wood" ? 0.78 : 0.9,
      matrix: matrix,
    };
  }

  function ensureMaterialEngravingFilter(widget, appearance) {
    var svg = widget.querySelector("[data-material-preview-filters]");
    if (!svg) {
      var namespace = "http://www.w3.org/2000/svg";
      svg = document.createElementNS(namespace, "svg");
      svg.dataset.materialPreviewFilters = "true";
      svg.setAttribute("width", "0");
      svg.setAttribute("height", "0");
      svg.setAttribute("aria-hidden", "true");
      svg.setAttribute("focusable", "false");
      svg.style.position = "absolute";
      svg.style.pointerEvents = "none";
      var filter = document.createElementNS(namespace, "filter");
      filter.id = "pp-material-" + (widget.id || "widget").replace(/[^a-z0-9_-]/gi, "-") +
        "-" + document.querySelectorAll("[data-material-preview-filters]").length;
      filter.setAttribute("color-interpolation-filters", "sRGB");
      var matrix = document.createElementNS(namespace, "feColorMatrix");
      matrix.setAttribute("type", "matrix");
      filter.appendChild(matrix);
      svg.appendChild(filter);
      widget.prepend(svg);
    }
    svg.querySelector("feColorMatrix").setAttribute("values", appearance.matrix);
    return 'url("#' + svg.querySelector("filter").id + '")';
  }

  function clonePreviewTarget(target, slotAttribute, slotId) {
    var clone = target.cloneNode(true);
    var existingCanvas = clone.querySelector(".personalize-pilot-warp-canvas");

    if (existingCanvas) {
      existingCanvas.remove();
    }

    clone.classList.remove("is-canvas-warped");
    clone.classList.add("personalize-pilot-main-preview__item");
    clone.setAttribute(slotAttribute, slotId);

    return clone;
  }

  function hasActiveConditionalMirroredArtwork(widget) {
    return Array.prototype.some.call(
      widget.querySelectorAll('[data-template-picker][data-template-mirror]'),
      function (picker) {
        if (picker.hidden || !picker.dataset.templateMirror ||
            picker.dataset.templateExclusiveSuppressed === "true") return false;
        var hasCondition = Boolean(picker.dataset.conditionalDependsOn);
        try {
          var group = JSON.parse(picker.dataset.conditionalRules || "null");
          hasCondition = hasCondition || Boolean(group && Array.isArray(group.rules) && group.rules.length);
        } catch (_error) {
          return false;
        }
        // An unconditional front-side reference belongs to the untouched sales
        // image. A conditionally enabled mirror is an actual customer choice:
        // render both sides even when the alternative name field is empty.
        var selected = picker.querySelector('[data-template-option][aria-pressed="true"]');
        return Boolean(hasCondition && selected && selected.dataset.templateImage);
      },
    );
  }

  function hasActivePersonalizationInput(widget) {
    var textInputs = widget.querySelectorAll(
      '[data-preview-slot], [data-preview-source="primary-text"]',
    );
    var fileInputs = widget.querySelectorAll('input[type="file"]');
    var symbolInputs = widget.querySelectorAll("[data-symbol-input]");
    var touchedTemplatePicker = widget.querySelector(
      '[data-template-picker][data-template-user-selected="true"]',
    );
    var hasText = Array.prototype.some.call(textInputs, function (input) {
      return !input.disabled && String(input.value || "").trim().length > 0;
    });
    var hasFile = Array.prototype.some.call(fileInputs, function (input) {
      return Boolean(
        !input.disabled &&
        (input.dataset.previewObjectUrl ||
          (input.files && input.files.length > 0)),
      );
    });
    var hasSymbol = Array.prototype.some.call(symbolInputs, function (input) {
      return !input.disabled && String(input.value || "").trim().length > 0;
    });
    var hasFreeform = Array.prototype.some.call(
      widget.querySelectorAll("[data-freeform-property]"),
      function (input) {
        return !input.disabled && String(input.value || "").trim().length > 0;
      },
    );
    return (
      hasText ||
      hasFile ||
      hasSymbol ||
      hasFreeform ||
      hasActiveConditionalMirroredArtwork(widget) ||
      Boolean(touchedTemplatePicker)
    );
  }

  function isWidgetPersonalizationEnabled(widget) {
    if (widget && widget.dataset.personalizationRequired === "true") {
      return true;
    }
    var selected = widget.querySelector(
      "[data-personalization-choice-input]:checked",
    );
    return !selected || selected.value !== "standard";
  }

  function hasUnpersonalizedTemplateArtwork(widget) {
    return Array.from(
      widget.querySelectorAll('[data-template-option][aria-pressed="true"]'),
    ).some(function (button) {
      return Boolean(button.dataset.templateUnpersonalizedImage);
    });
  }

  function shouldShowComposedProductPreview(widget) {
    return isWidgetPersonalizationEnabled(widget)
      ? hasActivePersonalizationInput(widget)
      : hasUnpersonalizedTemplateArtwork(widget);
  }

  function normalizeConfiguredImageUrl(value) {
    var source = String(value || "").trim();

    if (!source) return "";

    try {
      var url = new URL(source, window.location.href);
      url.search = "";
      url.hash = "";
      return url.href.toLowerCase();
    } catch (error) {
      return source.split("?")[0].split("#")[0].toLowerCase();
    }
  }

  function usesFinishedFixedArtworkBase(widget) {
    var configuredMode = String(
      (widget && widget.dataset.fixedArtworkBaseMode) || "blank-overlay",
    )
      .trim()
      .toLowerCase();
    var fixedTemplateValue = String(
      (widget && widget.dataset.fixedTemplateValue) || "",
    ).trim();
    var finishedImageUrl = String(
      (widget &&
        (widget.dataset.finishedImageUrl || widget.dataset.mainImageUrl)) ||
        "",
    ).trim();
    var blankImageUrl = String(
      (widget && widget.dataset.blankImageUrl) || "",
    ).trim();

    return Boolean(
      configuredMode === "finished" &&
      fixedTemplateValue &&
      finishedImageUrl &&
      blankImageUrl &&
      normalizeConfiguredImageUrl(finishedImageUrl) !==
        normalizeConfiguredImageUrl(blankImageUrl),
    );
  }

  function getProductMediaImageUrl(widget, showPersonalizedBlank) {
    var blankImageUrl = widget.dataset.blankImageUrl || "";
    var finishedImageUrl =
      widget.dataset.finishedImageUrl || widget.dataset.mainImageUrl || "";

    // A fixed catalog product already contains its immutable artwork in the
    // finished sales image. Keep that exact product image as the coordinate
    // base and add only customer-editable text. Switching to a separately
    // photographed blank and re-rendering the complete motif is what made an
    // otherwise correct product image jump, shrink or appear distorted.
    if (showPersonalizedBlank && !usesFinishedFixedArtworkBase(widget)) {
      return blankImageUrl || finishedImageUrl;
    }

    return finishedImageUrl || blankImageUrl;
  }

  function preloadConfiguredProductImages(widget) {
    var urls = [
      widget.dataset.finishedImageUrl || widget.dataset.mainImageUrl || "",
      widget.dataset.blankImageUrl || "",
    ].filter(Boolean);

    urls.forEach(function (url) {
      if (
        document.querySelector(
          'link[data-personalize-pilot-preload="' +
            encodeURIComponent(url) +
            '"]',
        )
      ) {
        return;
      }

      var preload = document.createElement("link");
      preload.rel = "preload";
      preload.as = "image";
      preload.href = url;
      preload.dataset.personalizePilotPreload = encodeURIComponent(url);
      document.head.appendChild(preload);
    });
  }

  function applyMainImageToProductMedia(
    widget,
    surface,
    showPersonalizedBlank,
  ) {
    var mainImageUrl = getProductMediaImageUrl(widget, showPersonalizedBlank);
    var image = null;
    var picture = null;

    if (!mainImageUrl || !surface) {
      return;
    }

    image = getProductPreviewImage(surface);

    if (!image) {
      return;
    }

    if (!image.dataset.personalizePilotOriginalSrc) {
      image.dataset.personalizePilotOriginalSrc =
        image.getAttribute("src") || "";
      image.dataset.personalizePilotOriginalSrcset =
        image.getAttribute("srcset") || "";
      image.dataset.personalizePilotOriginalAlt =
        image.getAttribute("alt") || "";
      image.dataset.personalizePilotOriginalObjectFit =
        image.style.getPropertyValue("object-fit") || "";
      image.dataset.personalizePilotOriginalObjectPosition =
        image.style.getPropertyValue("object-position") || "";
    }

    if (image.getAttribute("src") !== mainImageUrl) {
      image.src = mainImageUrl;
    }
    image.removeAttribute("srcset");
    if (showPersonalizedBlank) {
      image.style.setProperty("object-fit", "contain", "important");
      image.style.setProperty("object-position", "center", "important");
    } else {
      var originalObjectFit =
        image.dataset.personalizePilotOriginalObjectFit || "";
      var originalObjectPosition =
        image.dataset.personalizePilotOriginalObjectPosition || "";
      if (originalObjectFit) {
        image.style.setProperty("object-fit", originalObjectFit);
      } else {
        image.style.removeProperty("object-fit");
      }
      if (originalObjectPosition) {
        image.style.setProperty("object-position", originalObjectPosition);
      } else {
        image.style.removeProperty("object-position");
      }
    }
    image.dataset.personalizePilotImageMode = showPersonalizedBlank
      ? "blank"
      : "finished";
    image.alt = showPersonalizedBlank
      ? (widget.dataset.productTitle || "Produkt") +
        " – deine Personalisierungsvorschau"
      : image.dataset.personalizePilotOriginalAlt ||
        widget.dataset.productTitle ||
        "Produkt";

    picture = image.closest("picture");
    if (picture) {
      picture.querySelectorAll("source").forEach(function (source) {
        if (!source.dataset.personalizePilotOriginalSrcset) {
          source.dataset.personalizePilotOriginalSrcset =
            source.getAttribute("srcset") || "";
        }
        source.removeAttribute("srcset");
      });
    }
  }

  function getProductPreviewImage(surface) {
    var bestImage = null;

    if (!surface) {
      return null;
    }

    if (surface.matches && surface.matches("img")) {
      return surface;
    }

    bestImage = getLargestVisibleProductImage(surface, null);
    if (bestImage) {
      return bestImage;
    }

    return surface.querySelector("img");
  }

  function getImageContentRect(image) {
    var rect =
      image && image.getBoundingClientRect
        ? image.getBoundingClientRect()
        : null;
    var styles = image ? window.getComputedStyle(image) : null;
    var objectFit = styles ? styles.objectFit : "";
    var naturalWidth = image ? image.naturalWidth : 0;
    var naturalHeight = image ? image.naturalHeight : 0;
    var boxRatio = 0;
    var imageRatio = 0;
    var width = rect ? rect.width : 0;
    var height = rect ? rect.height : 0;
    var left = rect ? rect.left : 0;
    var top = rect ? rect.top : 0;

    function getObjectPositionOffset(value, remainingSpace) {
      var normalized = String(value || "center").toLowerCase();
      var numeric = parseFloat(normalized);

      if (normalized === "left" || normalized === "top") return 0;
      if (normalized === "right" || normalized === "bottom") {
        return remainingSpace;
      }
      if (normalized === "center") return remainingSpace / 2;
      if (normalized.indexOf("%") >= 0 && Number.isFinite(numeric)) {
        return remainingSpace * (numeric / 100);
      }
      if (normalized.indexOf("px") >= 0 && Number.isFinite(numeric)) {
        return numeric;
      }
      return remainingSpace / 2;
    }

    if (!rect || rect.width <= 1 || rect.height <= 1) {
      return null;
    }

    if (naturalWidth > 0 && naturalHeight > 0) {
      boxRatio = rect.width / Math.max(rect.height, 1);
      imageRatio = naturalWidth / Math.max(naturalHeight, 1);

      if (objectFit === "contain" || objectFit === "scale-down") {
        if (
          objectFit === "scale-down" &&
          naturalWidth <= rect.width &&
          naturalHeight <= rect.height
        ) {
          width = naturalWidth;
          height = naturalHeight;
        } else if (imageRatio > boxRatio) {
          height = rect.width / imageRatio;
        } else {
          width = rect.height * imageRatio;
        }
      } else if (objectFit === "cover") {
        if (imageRatio > boxRatio) {
          width = rect.height * imageRatio;
        } else {
          height = rect.width / imageRatio;
        }
      } else if (objectFit === "none") {
        width = naturalWidth;
        height = naturalHeight;
      }

      var objectPosition = String(styles.objectPosition || "center center")
        .trim()
        .split(/\s+/);
      var positionX = objectPosition[0] || "center";
      var positionY = objectPosition[1] || objectPosition[0] || "center";

      left = rect.left + getObjectPositionOffset(positionX, rect.width - width);
      top = rect.top + getObjectPositionOffset(positionY, rect.height - height);
    }

    return {
      left: left,
      top: top,
      width: width,
      height: height,
    };
  }

  function getTemplateAspectRatio(widget) {
    var coordinateWidth = Number(
      widget && widget.dataset.previewCoordinateWidthPx,
    );
    var coordinateHeight = Number(
      widget && widget.dataset.previewCoordinateHeightPx,
    );
    var width = Number(widget && widget.dataset.previewWidthMm);
    var height = Number(widget && widget.dataset.previewHeightMm);
    var styles = widget ? window.getComputedStyle(widget) : null;
    var ratioValue = styles
      ? String(
          styles.getPropertyValue("--personalize-pilot-aspect-ratio") || "",
        )
      : "";
    var ratioParts = ratioValue.split("/");
    var parsedWidth = Number(ratioParts[0]);
    var parsedHeight = Number(ratioParts[1]);

    if (coordinateWidth > 0 && coordinateHeight > 0) {
      return coordinateWidth / coordinateHeight;
    }

    if (parsedWidth > 0 && parsedHeight > 0) {
      return parsedWidth / parsedHeight;
    }

    if (width > 0 && height > 0) {
      return width / height;
    }

    return 1;
  }

  function getImageElementRect(image) {
    var rect =
      image && image.getBoundingClientRect
        ? image.getBoundingClientRect()
        : null;

    if (!rect || rect.width <= 1 || rect.height <= 1) {
      return null;
    }

    return {
      left: rect.left,
      top: rect.top,
      width: rect.width,
      height: rect.height,
    };
  }

  function positionMainImagePreviewOverlay(surface, overlay, widget) {
    var surfaceRect =
      surface && surface.getBoundingClientRect
        ? surface.getBoundingClientRect()
        : null;
    var image = getProductPreviewImage(surface);
    var imageRect = getImageContentRect(image) || getImageElementRect(image);
    var templateRatio = getTemplateAspectRatio(widget);
    var stageRect = null;
    var left = 0;
    var top = 0;
    var width = surfaceRect ? surfaceRect.width : 0;
    var height = surfaceRect ? surfaceRect.height : 0;

    if (!surfaceRect || !overlay) {
      return;
    }

    if (image && image.naturalWidth > 0 && image.naturalHeight > 0) {
      widget.dataset.previewCoordinateWidthPx = String(image.naturalWidth);
      widget.dataset.previewCoordinateHeightPx = String(image.naturalHeight);
      widget.style.setProperty(
        "--personalize-pilot-aspect-ratio",
        image.naturalWidth + " / " + image.naturalHeight,
      );
      templateRatio = image.naturalWidth / image.naturalHeight;
    }

    if (imageRect && imageRect.width >= 40 && imageRect.height >= 40) {
      // Keep the full rendered image as the coordinate stage, even when the
      // theme crops it. Bounding to the visible fragment would rescale every
      // saved percentage and make editor and storefront layouts diverge.
      stageRect = imageRect;
      left = stageRect.left - surfaceRect.left;
      top = stageRect.top - surfaceRect.top;
      width = stageRect.width;
      height = stageRect.height;
    }

    overlay.style.left = Math.round(left * 10) / 10 + "px";
    overlay.style.top = Math.round(top * 10) / 10 + "px";
    overlay.style.right = "auto";
    overlay.style.bottom = "auto";
    overlay.style.width = Math.round(width * 10) / 10 + "px";
    overlay.style.height = Math.round(height * 10) / 10 + "px";
    overlay.dataset.personalizePilotStageRatio = String(
      Math.round((width / Math.max(height, 1)) * 1000) / 1000,
    );
    overlay.dataset.personalizePilotTemplateRatio = String(
      Math.round(templateRatio * 1000) / 1000,
    );
    overlay
      .querySelectorAll('[data-template-artwork-preview="true"]')
      .forEach(function (target) {
        syncTemplateArtworkGeometry(target);
        renderWarpedImageTarget(target);
      });
    if (
      widget &&
      typeof widget.personalizePilotSyncTextGeometry === "function"
    ) {
      widget.personalizePilotSyncTextGeometry();
    }
  }

  function scheduleMainImagePreviewOverlayPosition(surface, overlay, widget) {
    var image = getProductPreviewImage(surface);
    var reposition = function () {
      positionMainImagePreviewOverlay(surface, overlay, widget);
    };

    if (
      surface.personalizePilotPreviewImage &&
      surface.personalizePilotPreviewImageLoadHandler
    ) {
      surface.personalizePilotPreviewImage.removeEventListener(
        "load",
        surface.personalizePilotPreviewImageLoadHandler,
      );
    }

    surface.personalizePilotPreviewImage = image;
    surface.personalizePilotPreviewImageLoadHandler = reposition;

    if (image) {
      image.addEventListener("load", reposition);
    }

    reposition();

    if (window.requestAnimationFrame) {
      window.requestAnimationFrame(function () {
        reposition();
        window.requestAnimationFrame(reposition);
      });
    }

    surface.personalizePilotReposition = reposition;
    if (window.ResizeObserver && !surface.personalizePilotResizeObserver) {
      surface.personalizePilotResizeObserver = new ResizeObserver(function () {
        if (surface.personalizePilotReposition) {
          surface.personalizePilotReposition();
        }
      });
      surface.personalizePilotResizeObserver.observe(surface);
    }
  }

  function createMainImagePreview(
    widget,
    textPreviewTargets,
    imagePreviewTargets,
    previewText,
    previewImage,
  ) {
    var surface = findProductMediaSurface(widget);
    var textTargets = {};
    var imageTargets = {};

    if (!surface) {
      return {
        overlay: null,
        surface: null,
        textTargets: textTargets,
        imageTargets: imageTargets,
        previewText: null,
        previewImage: null,
      };
    }

    var existingOverlay = surface.querySelector(
      ".personalize-pilot-main-preview",
    );
    if (existingOverlay) {
      existingOverlay.remove();
    }

    surface.classList.add("personalize-pilot-main-media");
    surface.dataset.personalizePilotPreviewSurface = "true";
    applyMainImageToProductMedia(
      widget,
      surface,
      shouldShowComposedProductPreview(widget),
    );

    var overlay = document.createElement("div");
    overlay.className = "personalize-pilot-main-preview";
    overlay.setAttribute("aria-hidden", "true");
    overlay.hidden = !shouldShowComposedProductPreview(widget);

    if (widget.getAttribute("style")) {
      overlay.setAttribute("style", widget.getAttribute("style"));
    }

    Object.keys(textPreviewTargets).forEach(function (slotId) {
      var clone = clonePreviewTarget(
        textPreviewTargets[slotId],
        "data-main-preview-text-slot",
        slotId,
      );
      textTargets[slotId] = clone;
      overlay.appendChild(clone);
    });

    Object.keys(imagePreviewTargets).forEach(function (slotId) {
      if (
        usesFinishedFixedArtworkBase(widget) &&
        imagePreviewTargets[slotId].matches(
          '[data-template-artwork-preview="true"]',
        )
      ) {
        return;
      }

      var clone = clonePreviewTarget(
        imagePreviewTargets[slotId],
        "data-main-preview-image-slot",
        slotId,
      );
      imageTargets[slotId] = clone;
      overlay.appendChild(clone);
    });

    var fallbackText = null;
    var fallbackImage = null;

    if (previewText && Object.keys(textTargets).length === 0) {
      fallbackText = previewText.cloneNode(true);
      overlay.appendChild(fallbackText);
    }

    if (previewImage && Object.keys(imageTargets).length === 0) {
      fallbackImage = previewImage.cloneNode(true);
      overlay.appendChild(fallbackImage);
    }

    surface.appendChild(overlay);
    scheduleMainImagePreviewOverlayPosition(surface, overlay, widget);
    widget.dataset.personalizePilotPreviewAttached = "true";

    return {
      overlay: overlay,
      surface: surface,
      textTargets: textTargets,
      imageTargets: imageTargets,
      previewText: fallbackText,
      previewImage: fallbackImage,
    };
  }

  function isProductForm(form) {
    return Boolean(
      form &&
      form.tagName === "FORM" &&
      (String(form.getAttribute("action") || "").indexOf("/cart/add") >= 0 ||
        form.closest("product-form") ||
        (form.querySelector('[name="id"]') &&
          form.querySelector('button[name="add"], [type="submit"]'))),
    );
  }

  function scoreProductForm(form, widget, localRoot) {
    if (!isProductForm(form)) return Number.NEGATIVE_INFINITY;

    var rect = form.getBoundingClientRect();
    var widgetRect = widget.getBoundingClientRect();
    var distance =
      Math.abs(rect.top - widgetRect.top) +
      Math.abs(rect.left - widgetRect.left);
    var submitButton = form.querySelector(
      'button[name="add"], button[type="submit"], input[type="submit"]',
    );

    return (
      (submitButton ? 250000 : -250000) +
      (rect.width > 1 && rect.height > 1 ? 100000 : -100000) +
      (form.querySelector('[name="id"]') ? 10000 : 0) +
      (localRoot && localRoot.contains(form) ? 5000 : 0) -
      distance
    );
  }

  function findProductForm(widget) {
    var closestForm = widget.closest("form");
    var localRoot = widget.closest(
      "product-info, [id^='MainProduct'], [data-section-type*='product'], .product, section",
    );
    var candidates = Array.prototype.filter.call(
      document.querySelectorAll('form[action*="/cart/add"], product-form form'),
      isProductForm,
    );

    if (isProductForm(closestForm) && candidates.indexOf(closestForm) < 0) {
      candidates.push(closestForm);
    }

    if (candidates.length === 0) return null;

    return candidates
      .map(function (candidate) {
        return {
          candidate: candidate,
          score: scoreProductForm(candidate, widget, localRoot),
        };
      })
      .sort(function (left, right) {
        return right.score - left.score;
      })[0].candidate;
  }

  function attachWidget(widget, preferWidget) {
    var productId = widget.dataset.productId || "";
    var matchingWidgets = Array.prototype.filter.call(
      document.querySelectorAll("[data-personalize-pilot-widget]"),
      function (candidate) {
        return (candidate.dataset.productId || "") === productId;
      },
    );
    var initializedWidget = matchingWidgets.find(function (candidate) {
      return (
        candidate.dataset.personalizePilotInitialized === "true" &&
        candidate.dataset.personalizePilotDuplicate !== "true"
      );
    });
    var canonicalWidget = preferWidget
      ? widget
      : initializedWidget ||
        (matchingWidgets.length ? matchingWidgets[0] : widget);

    matchingWidgets.forEach(function (candidate) {
      if (candidate === canonicalWidget) {
        var wasDuplicate =
          candidate.dataset.personalizePilotDuplicate === "true";
        candidate.hidden = false;
        candidate.removeAttribute("aria-hidden");
        delete candidate.dataset.personalizePilotDuplicate;
        if (wasDuplicate) {
          candidate
            .querySelectorAll("input, select, textarea, button")
            .forEach(function (control) {
              if (
                control.dataset.personalizePilotDuplicateDisabled ===
                  "restore" &&
                !control.closest("[hidden]")
              ) {
                control.disabled = false;
              }
              delete control.dataset.personalizePilotDuplicateDisabled;
            });
        }
        return;
      }

      candidate.hidden = true;
      candidate.setAttribute("aria-hidden", "true");
      candidate.dataset.personalizePilotDuplicate = "true";
      candidate
        .querySelectorAll("input, select, textarea, button")
        .forEach(function (control) {
          if (!control.dataset.personalizePilotDuplicateDisabled) {
            control.dataset.personalizePilotDuplicateDisabled = control.disabled
              ? "preserve"
              : "restore";
          }
          control.disabled = true;
        });
    });

    if (canonicalWidget !== widget) {
      return;
    }

    if (widget.dataset.personalizePilotInitialized === "true") {
      if (typeof widget.personalizePilotRefresh === "function") {
        widget.personalizePilotRefresh();
        return;
      }

      delete widget.dataset.personalizePilotInitialized;
    }

    widget.dataset.personalizePilotInitialized = "true";

    var form = findProductForm(widget);
    var previewText = widget.querySelector("[data-preview-text]");
    var previewImage = widget.querySelector("[data-preview-image]");
    var primaryTextInput = widget.querySelector(
      '[data-preview-source="primary-text"]',
    );
    var primaryImageInput = widget.querySelector(
      '[data-file-preview="primary-image"]',
    );
    var textPreviewTargets = {};
    var imagePreviewTargets = {};
    var colorInputs = widget.querySelectorAll("[data-color-input]");
    var fontInput = widget.querySelector("[data-font-input]");
    // Definition products use the approved fixed typeface, also when the
    // merchant intentionally disables the general font picker.
    if (!fontInput && form && form.querySelector("definition-editor")) {
      fontInput = document.createElement("input");
      fontInput.type = "hidden";
      fontInput.name = "properties[Schriftart]";
      fontInput.value = "Libre Baskerville";
      fontInput.setAttribute("data-font-input", "");
      widget.appendChild(fontInput);
    }
    var fontOptionButtons = widget.querySelectorAll("[data-font-option]");
    var fontUpdateRequest = 0;
    var templateOptionButtons = widget.querySelectorAll(
      "[data-template-option]",
    );
    var imageScaleControls = widget.querySelectorAll(
      "[data-image-scale-control]",
    );
    var photoCropControls = widget.querySelectorAll(
      "[data-photo-crop-control]",
    );
    var photoCropStates = {};
    var customerNameInput =
      primaryTextInput || widget.querySelector("[data-preview-slot]");
    var uploadCountInput = widget.querySelector("[data-upload-count-target]");
    var variantConfigurations = {};
    var personalizationSurfaces = [];
    var customerDesignSettings = {};
    var experienceSettings = {};
    var freeformItems = [];
    var freeformSequence = 0;
    var freeformUndoStack = [];
    var freeformRedoStack = [];
    var freeformHistoryLimit = 40;
    var selectedFreeformItemId = "";
    var customerSlotLayouts = {};
    var activeSurfaceId = "front";
    var selectedVariantDisabled = false;
    var selectedVariantConfiguration = null;
    var baseBlankImageUrl = widget.dataset.blankImageUrl || "";
    var baseFinishedImageUrl =
      widget.dataset.finishedImageUrl || widget.dataset.mainImageUrl || "";
    var designSaveStatus = widget.querySelector("[data-design-save-status]");
    var materialInput = widget.querySelector("[data-material-input]");
    var lightingInputs = widget.querySelectorAll("[data-lighting-input]");
    var lightingModeInput = widget.querySelector("[data-lighting-mode-input]");
    var product3dButton = widget.querySelector("[data-product-3d-open]");
    var product3dStatus = widget.querySelector("[data-product-3d-status]");
    var personalizationChoiceInputs = widget.querySelectorAll(
      "[data-personalization-choice-input]",
    );
    var personalizationChoiceProperty = widget.querySelector(
      "[data-personalization-choice-property]",
    );
    var personalizationChoiceModeProperty = widget.querySelector(
      "[data-personalization-choice-mode-property]",
    );

    function hasOfferedStandardArtwork() {
      if (widget.dataset.personalizationRequired === "true") return false;
      if (widget.dataset.personalizationMode === "free") return false;
      return Array.from(
        widget.querySelectorAll('[data-template-option][aria-pressed="true"]'),
      ).every(function (button) {
        var fields = [];
        try {
          fields = JSON.parse(button.dataset.templateTextFields || "[]") || [];
        } catch {
          return false;
        }
        var hasNameArea =
          button.dataset.templateNameEnabled !== "false" || fields.length > 0;
        return (
          !hasNameArea || Boolean(button.dataset.templateUnpersonalizedImage)
        );
      });
    }

    function getPersonalizationChoice() {
      if (!hasOfferedStandardArtwork()) {
        return "personalized";
      }
      var selected = Array.from(personalizationChoiceInputs).find(
        function (input) {
          return input.checked;
        },
      );
      return selected && selected.value === "standard"
        ? "standard"
        : "personalized";
    }

    function isPersonalizationEnabled() {
      return getPersonalizationChoice() !== "standard";
    }

    function setPersonalizationControlsEnabled(enabled) {
      var controlsContainer = widget.querySelector(
        "[data-personalization-controls]",
      );
      if (!controlsContainer) return;

      controlsContainer
        .querySelectorAll("input, select, textarea, button")
        .forEach(function (control) {
          if (!enabled) {
            if (control.dataset.preserveWithoutPersonalization === "true") {
              return;
            }
            if (control.dataset.personalizationModeStored !== "true") {
              control.dataset.personalizationModeStored = "true";
              control.dataset.personalizationModeWasDisabled = control.disabled
                ? "true"
                : "false";
              control.dataset.personalizationModeWasRequired = control.required
                ? "true"
                : "false";
            }
            control.disabled = true;
            control.required = false;
            if (typeof control.setCustomValidity === "function") {
              control.setCustomValidity("");
            }
            control.removeAttribute("aria-invalid");
            return;
          }

          if (control.dataset.personalizationModeStored === "true") {
            control.disabled =
              control.dataset.personalizationModeWasDisabled === "true";
            control.required =
              control.dataset.personalizationModeWasRequired === "true";
          }
          delete control.dataset.personalizationModeStored;
          delete control.dataset.personalizationModeWasDisabled;
          delete control.dataset.personalizationModeWasRequired;
        });
    }

    function syncTemplateArtworkForPersonalizationChoice() {
      var enabled = isPersonalizationEnabled();

      Array.from(templateOptionButtons || [])
        .filter(function (button) {
          return button.getAttribute("aria-pressed") === "true";
        })
        .forEach(function (button) {
          var slotId = button.dataset.templateOption || "";
          var personalizedImage = button.dataset.templateImage || "";
          var unpersonalizedImage =
            button.dataset.templateUnpersonalizedImage || "";
          var selectedImage = enabled
            ? personalizedImage
            : unpersonalizedImage || personalizedImage;

          getImageTargets(slotId).forEach(function (target) {
            target.dataset.templatePersonalizationVariant = enabled
              ? "personalized"
              : "standard";
            updateImagePreviewTarget(target, selectedImage);
          });
        });
    }

    function applyPersonalizationChoice() {
      var personalizationRequired = !hasOfferedStandardArtwork();
      var choiceGroup = widget.querySelector("[data-personalization-choice]");
      if (choiceGroup) choiceGroup.hidden = personalizationRequired;
      Array.from(personalizationChoiceInputs).forEach(function (input) {
        if (personalizationRequired)
          input.checked = input.value === "personalized";
        input.disabled = personalizationRequired && input.value === "standard";
      });
      var choice = getPersonalizationChoice();
      var enabled = choice === "personalized";
      var selected = Array.from(personalizationChoiceInputs).find(
        function (input) {
          return input.checked;
        },
      );

      widget.classList.toggle("is-without-personalization", !enabled);
      widget.dataset.personalizePilotPersonalizationChoice = choice;
      setPersonalizationControlsEnabled(enabled);

      if (personalizationChoiceProperty) {
        personalizationChoiceProperty.value =
          (selected && selected.dataset.personalizationChoiceLabel) ||
          (enabled ? "Mit Personalisierung" : "Ohne Personalisierung");
      }
      if (personalizationChoiceModeProperty) {
        personalizationChoiceModeProperty.value = choice;
      }

      var validationNotice = widget.querySelector(
        "[data-personalization-validation-notice]",
      );
      if (!enabled && validationNotice) {
        validationNotice.hidden = true;
      }

      syncTemplateArtworkForPersonalizationChoice();
      if (enabled) {
        syncConditionalFields();
      }
      refreshMainImageMode();
      finalReviewConfirmed = false;
      scheduleMobileLivePreviewRefresh();
    }

    function setDesignSaveStatus(message, isError) {
      if (!designSaveStatus) return;
      designSaveStatus.textContent = message || "";
      designSaveStatus.hidden = !message;
      designSaveStatus.classList.toggle("is-error", Boolean(isError));
    }

    if (!form) {
      var formError = document.createElement("p");
      formError.className = "personalize-pilot-widget__connection-error";
      formError.setAttribute("role", "alert");
      formError.textContent = getMessage(
        widget,
        "messageFormMissing",
        "The personalization could not be connected to this product form.",
      );
      widget.prepend(formError);
      widget.dataset.personalizePilotFormConnected = "false";
    } else {
      widget.dataset.personalizePilotFormConnected = "true";
    }

    try {
      var parsedVariantConfigurations = JSON.parse(
        widget.dataset.variantConfigurations || "{}",
      );
      variantConfigurations =
        parsedVariantConfigurations &&
        typeof parsedVariantConfigurations === "object" &&
        !Array.isArray(parsedVariantConfigurations)
          ? parsedVariantConfigurations
          : {};
    } catch (error) {
      variantConfigurations = {};
    }

    try {
      personalizationSurfaces = JSON.parse(
        widget.dataset.personalizationSurfaces || "[]",
      );
      if (personalizationSurfaces.length > 0) {
        activeSurfaceId =
          widget.dataset.previewSurfaceId ||
          personalizationSurfaces[0].id ||
          "front";
      }
    } catch (error) {
      personalizationSurfaces = [];
    }

    function getConfiguredSurface(surfaceId) {
      return personalizationSurfaces.find(function (item) {
        return item.id === (surfaceId || activeSurfaceId || "front");
      });
    }

    function getConfiguredSurfaceArea(surfaceId) {
      var surface = getConfiguredSurface(surfaceId);
      var area = (surface && (surface.designArea || surface.previewArea)) || {
        x: 50,
        y: 50,
        width: 100,
        height: 100,
        rotation: 0,
        shape: "rectangle",
      };
      var requestedArea = {
        x: Number(area.x) || 50,
        y: Number(area.y) || 50,
        width: Number(area.width) || 100,
        height: Number(area.height) || 100,
        rotation: Number(area.rotation) || 0,
        shape:
          area.shape === "ellipse" || (surface && surface.shape === "ellipse")
            ? "ellipse"
            : "rectangle",
      };

      if (
        personalizationGeometry &&
        typeof personalizationGeometry.normalizeGeometrySurfaceArea ===
          "function"
      ) {
        return personalizationGeometry.normalizeGeometrySurfaceArea(
          requestedArea,
        );
      }
      return requestedArea;
    }

    function nearlyEqualLayoutValue(value, expected) {
      return Math.abs(Number(value) - expected) < 0.01;
    }

    function normalizeLegacyAcrylicLongTextLayout(layout, surfaceId) {
      if (!layout || layout.coordinateSpace !== "surface") return layout || {};
      var surface = getConfiguredSurface(surfaceId);
      var isAcrylicLongSurface =
        surface &&
        nearlyEqualLayoutValue(surface.widthMm, 110) &&
        nearlyEqualLayoutValue(surface.heightMm, 180);
      if (!isAcrylicLongSurface) return layout;

      // Compatibility bridge for the first Altenpflegerin v3 metafield. Keep
      // the normalized values in the complete motif-canvas coordinate space:
      // production applies its own contain transform from that immutable
      // source. The browser-only contain projection happens separately below.
      var isLegacyAltenpflegerinNamePlate =
        nearlyEqualLayoutValue(layout.x, 49.554367) &&
        nearlyEqualLayoutValue(layout.y, 74.14408) &&
        nearlyEqualLayoutValue(layout.width, 46.773619) &&
        nearlyEqualLayoutValue(layout.height, 6.058488);
      if (!isLegacyAltenpflegerinNamePlate) return layout;

      return Object.assign({}, layout, {
        width: 53.702317,
        height: 8.012839,
      });
    }

    function roundPreviewLayoutValue(value) {
      return Math.round(Number(value) * 1000000) / 1000000;
    }

    /**
     * Template-owned text is authored in the transparent motif canvas. The
     * Fixed acrylic motifs are shown with object-fit:contain inside their
     * product surface. Their option-owned text must pass through the exact same
     * centered letterbox transform or the name and the visible name plate drift
     * apart. The returned object is preview-only; the raw layout remains the
     * submitted and production source of truth.
     */
    function mapTemplateTextToContainedArtworkPreview(
      layout,
      surfaceId,
      target,
    ) {
      if (
        !layout ||
        layout.coordinateSpace !== "surface" ||
        !target ||
        target.dataset.templateOwnedText !== "true" ||
        target.dataset.templateProductionFitMode === "stretch"
      ) {
        return layout || {};
      }

      var surface = getConfiguredSurface(surfaceId);
      var isSupportedAcrylicSurface =
        surface &&
        nearlyEqualLayoutValue(surface.widthMm, 110) &&
        (nearlyEqualLayoutValue(surface.heightMm, 110) ||
          nearlyEqualLayoutValue(surface.heightMm, 180));
      if (!isSupportedAcrylicSurface) {
        return layout;
      }

      var artworkAspectRatio = Number(
        target.dataset.templateArtworkAspectRatio || 0,
      );
      var stageAspectRatio = getCanonicalProductPreviewStageAspectRatio();
      var area = getConfiguredSurfaceArea(surfaceId);
      var artworkLayout = {};
      try {
        artworkLayout = JSON.parse(
          target.dataset.templateArtworkLayout || "{}",
        );
      } catch (error) {
        artworkLayout = {};
      }

      var artworkX = getFiniteTextLayoutNumber(artworkLayout.x, 50);
      var artworkY = getFiniteTextLayoutNumber(artworkLayout.y, 50);
      var artworkWidth = Math.max(
        0.01,
        getFiniteTextLayoutNumber(artworkLayout.width, 100),
      );
      var artworkHeight = Math.max(
        0.01,
        getFiniteTextLayoutNumber(artworkLayout.height, 100),
      );
      var frameAspectRatio =
        (Number(area.width) * artworkWidth * stageAspectRatio) /
        Math.max(Number(area.height) * artworkHeight, 0.01);

      if (
        !Number.isFinite(artworkAspectRatio) ||
        artworkAspectRatio <= 0 ||
        !Number.isFinite(stageAspectRatio) ||
        stageAspectRatio <= 0 ||
        !Number.isFinite(frameAspectRatio) ||
        frameAspectRatio <= 0
      ) {
        return layout;
      }

      var scaleX = 1;
      var scaleY = 1;
      if (artworkAspectRatio > frameAspectRatio) {
        scaleY = Math.max(
          0.01,
          Math.min(1, frameAspectRatio / artworkAspectRatio),
        );
      } else if (artworkAspectRatio < frameAspectRatio) {
        scaleX = Math.max(
          0.01,
          Math.min(1, artworkAspectRatio / frameAspectRatio),
        );
      }

      return Object.assign({}, layout, {
        x: roundPreviewLayoutValue(
          artworkX +
            (getFiniteTextLayoutNumber(layout.x, 50) - 50) *
              (artworkWidth / 100) *
              scaleX,
        ),
        y: roundPreviewLayoutValue(
          artworkY +
            (getFiniteTextLayoutNumber(layout.y, 50) - 50) *
              (artworkHeight / 100) *
              scaleY,
        ),
        width: roundPreviewLayoutValue(
          getFiniteTextLayoutNumber(layout.width, 70) *
            (artworkWidth / 100) *
            scaleX,
        ),
        height: roundPreviewLayoutValue(
          getFiniteTextLayoutNumber(layout.height, 16) *
            (artworkHeight / 100) *
            scaleY,
        ),
      });
    }

    function resolveSurfaceRelativeLayout(layout, surfaceId) {
      var canonicalLayout = normalizeLegacyAcrylicLongTextLayout(
        layout,
        surfaceId,
      );
      if (!canonicalLayout || canonicalLayout.coordinateSpace !== "surface") {
        return canonicalLayout || {};
      }
      if (
        !personalizationGeometry ||
        typeof personalizationGeometry.projectSurfaceRelativeLayout !==
          "function"
      ) {
        return canonicalLayout;
      }
      return Object.assign(
        {},
        canonicalLayout,
        personalizationGeometry.projectSurfaceRelativeLayout(
          canonicalLayout,
          getConfiguredSurfaceArea(surfaceId),
        ),
        { coordinateSpace: "product" },
      );
    }

    function clampLayoutToConfiguredSurface(
      layout,
      surfaceId,
      stageAspectRatio,
      allowFullEllipseBounds,
    ) {
      if (
        !layout ||
        !personalizationGeometry ||
        typeof personalizationGeometry.clampGeometryLayout !== "function"
      ) {
        return layout || {};
      }

      var artworkArea = getConfiguredSurfaceArea(surfaceId);
      if (artworkArea.shape === "ellipse" && allowFullEllipseBounds === true) {
        // Template files are transparent and may use the full rectangular
        // bounding box of a round product. Constraining their transparent
        // corners to the ellipse would make them sqrt(2) too small compared
        // with the merchant editor and production renderer.
        artworkArea = Object.assign({}, artworkArea, { shape: "rectangle" });
      }

      return Object.assign(
        {},
        layout,
        personalizationGeometry.clampGeometryLayout(
          layout,
          artworkArea,
          stageAspectRatio,
        ),
      );
    }

    try {
      customerDesignSettings =
        JSON.parse(widget.dataset.customerDesignSettings || "{}") || {};
    } catch (error) {
      customerDesignSettings = {};
    }

    try {
      experienceSettings =
        JSON.parse(widget.dataset.experienceSettings || "{}") || {};
    } catch (error) {
      experienceSettings = {};
    }

    function applyMediaConfiguration() {
      var surface = personalizationSurfaces.find(function (item) {
        return item.id === activeSurfaceId;
      });
      var blankImageUrl =
        (selectedVariantConfiguration &&
          selectedVariantConfiguration.blankImageUrl) ||
        (surface && surface.blankImageUrl) ||
        baseBlankImageUrl;
      var variantFinishedImageUrl =
        selectedVariantConfiguration &&
        selectedVariantConfiguration.finishedImageUrl;
      var surfaceFinishedImageUrl = surface && surface.finishedImageUrl;
      var fixedTemplateValue = String(
        widget.dataset.fixedTemplateValue || "",
      ).trim();
      var productHandle = String(widget.dataset.productHandle || "")
        .trim()
        .toLowerCase();
      var normalizedSurfaceFinishedImageUrl = String(
        surfaceFinishedImageUrl || "",
      )
        .split("?")[0]
        .toLowerCase();
      var normalizedBaseFinishedImageUrl = String(baseFinishedImageUrl || "")
        .split("?")[0]
        .toLowerCase();
      var normalizedBlankImageUrl = String(blankImageUrl || "")
        .split("?")[0]
        .toLowerCase();
      var surfaceFinishedIsBlank = Boolean(
        normalizedSurfaceFinishedImageUrl &&
        normalizedSurfaceFinishedImageUrl === normalizedBlankImageUrl,
      );
      var baseFinishedIsSalesImage = Boolean(
        normalizedBaseFinishedImageUrl &&
        normalizedBaseFinishedImageUrl !== normalizedBlankImageUrl,
      );
      var surfaceHasFixedDesign = Boolean(
        surfaceFinishedImageUrl &&
        (normalizedSurfaceFinishedImageUrl === normalizedBaseFinishedImageUrl ||
          (productHandle &&
            normalizedSurfaceFinishedImageUrl.indexOf("/" + productHandle) >=
              0)),
      );
      var finishedImageUrl = variantFinishedImageUrl;

      if (!finishedImageUrl && fixedTemplateValue) {
        finishedImageUrl = surfaceHasFixedDesign
          ? surfaceFinishedImageUrl
          : baseFinishedImageUrl || surfaceFinishedImageUrl;
      }
      if (!finishedImageUrl) {
        // Older free-design configurations often stored the blank editor image
        // as their surface "finished" image. The Shopify product gallery may
        // meanwhile have a deliberately curated sales image. Keep that sales
        // image for the untouched product view and switch to the blank only
        // after the customer actually enters text or uploads artwork.
        finishedImageUrl =
          baseFinishedIsSalesImage && surfaceFinishedIsBlank
            ? baseFinishedImageUrl
            : surfaceFinishedImageUrl || baseFinishedImageUrl || blankImageUrl;
      }

      widget.dataset.blankImageUrl = blankImageUrl;
      widget.dataset.finishedImageUrl = finishedImageUrl;
      widget.dataset.mainImageUrl = finishedImageUrl;
      preloadConfiguredProductImages(widget);
    }

    function applySurfaceConfiguration(surfaceId) {
      activeSurfaceId = surfaceId || "front";
      applyMediaConfiguration();
      var activeSurface = personalizationSurfaces.find(function (surface) {
        return surface.id === activeSurfaceId;
      });
      var surfaceLabelInput = widget.querySelector(
        "[data-personalization-surface-label-input]",
      );
      var surfaceIdInput = widget.querySelector(
        "[data-personalization-surface-id-input]",
      );
      if (surfaceLabelInput) {
        surfaceLabelInput.value =
          (activeSurface && activeSurface.label) || activeSurfaceId;
      }
      if (surfaceIdInput) surfaceIdInput.value = activeSurfaceId;

      widget
        .querySelectorAll("[data-personalization-surface]")
        .forEach(function (element) {
          var isActive =
            element.dataset.personalizationSurface === activeSurfaceId;
          element.hidden = !isActive;
          if (element.matches("[data-personalize-field]")) {
            element
              .querySelectorAll("input, select, textarea")
              .forEach(function (control) {
                // A surface switch must not revive nested template or
                // conditional fields that are intentionally hidden. Those
                // controls otherwise leak empty/required values into the
                // Shopify form and can block Add to Cart invisibly.
                control.disabled =
                  selectedVariantDisabled ||
                  !isActive ||
                  Boolean(control.closest("[hidden]"));
              });
          }
        });
      widget
        .querySelectorAll("[data-personalization-surface-button]")
        .forEach(function (button) {
          button.setAttribute(
            "aria-pressed",
            button.dataset.personalizationSurfaceButton === activeSurfaceId
              ? "true"
              : "false",
          );
        });
      syncMainPreviewSurfaceVisibility();
    }

    function syncMainPreviewSurfaceVisibility() {
      if (!mainImagePreview || !mainImagePreview.overlay) return;
      mainImagePreview.overlay
        .querySelectorAll("[data-personalization-surface]")
        .forEach(function (element) {
          element.hidden =
            element.dataset.personalizationSurface !== activeSurfaceId ||
            element.dataset.templateExclusiveSuppressed === "true" ||
            element.dataset.templateNameEnabled === "false" ||
            element.classList.contains("is-conditionally-hidden") ||
            (!isPersonalizationEnabled() &&
              element.matches("[data-main-preview-text-slot]")) ||
            (element.matches("[data-main-preview-text-slot]") &&
              element.dataset.previewHasValue === "false");
        });
    }

    function getSelectedVariantId() {
      var variantInput = form && form.querySelector('[name="id"]');
      var rawVariantId = String((variantInput && variantInput.value) || "");
      var parts = rawVariantId.split("/").filter(Boolean);
      return parts.length > 0 ? parts[parts.length - 1] : rawVariantId;
    }

    function applySelectedVariantConfiguration() {
      var configuration = variantConfigurations[getSelectedVariantId()];
      selectedVariantConfiguration = configuration || null;
      selectedVariantDisabled = Boolean(
        configuration && configuration.active === false,
      );

      widget.hidden = selectedVariantDisabled;
      widget
        .querySelectorAll("input, select, textarea")
        .forEach(function (control) {
          control.disabled = selectedVariantDisabled;
        });
      applyMediaConfiguration();
      if (!configuration || selectedVariantDisabled) return;
      syncConditionalFields();
    }

    applySelectedVariantConfiguration();
    applySurfaceConfiguration(activeSurfaceId);

    widget
      .querySelectorAll("[data-preview-text-slot]")
      .forEach(function (target) {
        textPreviewTargets[target.dataset.previewTextSlot] = target;
      });

    widget
      .querySelectorAll("[data-preview-image-slot]")
      .forEach(function (target) {
        imagePreviewTargets[target.dataset.previewImageSlot] = target;
      });

    var mainImagePreview = createMainImagePreview(
      widget,
      textPreviewTargets,
      imagePreviewTargets,
      previewText,
      previewImage,
    );
    var previewRefreshTimer = null;
    var previewRefreshAttempts = 0;
    var mobilePreviewRefreshFrame = null;
    var mobilePreviewSourceSignature = "";

    function getMaterialPreviewTone(configuredTone) {
      return widget.dataset.productType === "acrylic_sign"
        ? "acrylic-light"
        : configuredTone || "normal";
    }

    function getCanonicalProductPreviewStageAspectRatio() {
      var naturalCoordinateWidth = Number(
        widget && widget.dataset.previewCoordinateWidthPx,
      );
      var naturalCoordinateHeight = Number(
        widget && widget.dataset.previewCoordinateHeightPx,
      );
      if (
        Number.isFinite(naturalCoordinateWidth) &&
        naturalCoordinateWidth > 0 &&
        Number.isFinite(naturalCoordinateHeight) &&
        naturalCoordinateHeight > 0
      ) {
        // Once the product image has loaded, its immutable pixel ratio is the
        // single coordinate stage for main, inline, follower and final review.
        // Prefer it over repeatedly rounded rendered rectangles so a resize or
        // sticky mobile clone cannot make the text jump by a few pixels.
        return naturalCoordinateWidth / naturalCoordinateHeight;
      }
      var overlayRatio = Number(
        mainImagePreview &&
          mainImagePreview.overlay &&
          mainImagePreview.overlay.dataset.personalizePilotStageRatio,
      );

      if (Number.isFinite(overlayRatio) && overlayRatio > 0) {
        return overlayRatio;
      }

      // Every product-image, inline, floating and final-review preview uses
      // the main product image as its single coordinate stage. Falling back to
      // the widget's configured image ratio keeps the same contract before
      // the gallery image has completed loading.
      return getTemplateAspectRatio(widget);
    }

    function getCurrentMaterialProfile() {
      var profiles = Array.isArray(experienceSettings.materialProfiles)
        ? experienceSettings.materialProfiles
        : [];
      var selectedMaterial = String(
        (materialInput && materialInput.value) || "",
      );
      return (
        profiles.find(function (profile) {
          return profile.materialValue === selectedMaterial;
        }) ||
        profiles.find(function (profile) {
          return profile.id === experienceSettings.defaultMaterialProfileId;
        }) ||
        profiles[0] || {
          id: "fallback",
          label: selectedMaterial || "Material",
          kind: "other",
          baseColor: "#c9c9c9",
          engravingColor: "#222222",
          roughness: 0.62,
          metalness: 0,
          transmission: 0,
          opacity: 1,
          previewTintStrength: 0,
          previewBlendMode: "multiply",
          engravingEffect: "none",
        }
      );
    }

    function normalizeLightingMode(value) {
      return String(value || "").toLowerCase() === "cool" ? "cool" : "warm";
    }

    function getCurrentLightingMode() {
      var selectedLightingInput = Array.from(lightingInputs).find(
        function (input) {
          return input.checked;
        },
      );

      return normalizeLightingMode(
        (selectedLightingInput && selectedLightingInput.dataset.lightingMode) ||
          (lightingModeInput && lightingModeInput.value) ||
          widget.dataset.defaultLightingMode,
      );
    }

    function getAcrylicLightingColor() {
      return getCurrentLightingMode() === "cool" ? "#effaff" : "#fff0bf";
    }

    function applyMaterialPreview() {
      if (!mainImagePreview.overlay) return;
      var profile = getCurrentMaterialProfile();
      var appearance = getMaterialEngravingAppearance(profile);
      var engravingFilter = ensureMaterialEngravingFilter(widget, appearance);
      var tint = mainImagePreview.overlay.querySelector("[data-material-tint]");
      var engravingColor = appearance.enabled ? appearance.color : profile.engravingColor || "#222222";
      var engravingEffect =
        profile.engravingEffect ||
        (profile.kind === "wood" ? "engraved" : "none");
      var strength = Math.max(
        0,
        Math.min(1, Number(profile.previewTintStrength || 0)),
      );
      var previewRoots = [
        widget,
        widget.querySelector(".personalize-pilot-widget__mockup"),
        mainImagePreview.overlay,
      ].filter(Boolean);

      previewRoots.forEach(function (root) {
        root.dataset.materialKind = profile.kind || "other";
        root.dataset.engravingEffect = engravingEffect;
        root.dataset.materialPreviewEnabled = String(appearance.enabled);
        root.style.setProperty("--pp-engraving-color", appearance.color);
        root.style.setProperty("--pp-engraving-opacity", String(appearance.opacity));
        root.style.setProperty("--pp-engraving-filter", engravingFilter);
      });

      Object.keys(textPreviewTargets).forEach(function (slotId) {
        getTextTargets(slotId).forEach(function (target) {
          target.style.color =
            target.dataset.previewTone === "acrylic-light"
              ? getAcrylicLightingColor()
              : engravingColor;
          target.dataset.materialEngravingColor = engravingColor;
          updatePreviewText(
            target,
            target.dataset.previewTextValue || target.textContent,
          );
        });
      });

      if (strength <= 0) {
        if (tint) tint.remove();
        return;
      }
      if (!tint) {
        tint = document.createElement("div");
        tint.className = "personalize-pilot-main-preview__material-tint";
        tint.dataset.materialTint = "true";
        tint.setAttribute("aria-hidden", "true");
        mainImagePreview.overlay.prepend(tint);
      }
      tint.style.backgroundColor = profile.baseColor || "#c9c9c9";
      tint.style.opacity = String(strength);
      tint.style.mixBlendMode = profile.previewBlendMode || "multiply";
    }

    function applyLightingPreview() {
      var lightingEnabled = widget.dataset.lightingEnabled === "true";
      var mode = getCurrentLightingMode();
      var previewImage = getProductPreviewImage(mainImagePreview.surface);
      var inlineProductImage = widget.querySelector(
        ".personalize-pilot-widget__mockup img",
      );
      var lightingTargets = [
        widget,
        widget.querySelector(".personalize-pilot-widget__mockup"),
        mainImagePreview.surface,
        mainImagePreview.overlay,
        previewImage,
        inlineProductImage,
      ].filter(Boolean);

      if (!lightingEnabled) {
        lightingTargets.forEach(function (target) {
          delete target.dataset.personalizePilotLightingMode;
        });
        applyMaterialPreview();
        return;
      }

      if (lightingModeInput) {
        lightingModeInput.value = mode;
      }
      lightingTargets.forEach(function (target) {
        target.dataset.personalizePilotLightingMode = mode;
      });
      applyMaterialPreview();
      scheduleMobileLivePreviewRefresh();
      widget.dispatchEvent(
        new CustomEvent("personalize-pilot:lighting-change", {
          bubbles: true,
          detail: { mode: mode },
        }),
      );
    }

    function getElementRotation(element) {
      var transform = window.getComputedStyle(element).transform;
      if (!transform || transform === "none") return 0;
      try {
        var matrix = new DOMMatrixReadOnly(transform);
        return (Math.atan2(matrix.b, matrix.a) * 180) / Math.PI;
      } catch (error) {
        return 0;
      }
    }

    function collectProduct3dDescriptors() {
      var overlay = mainImagePreview.overlay;
      if (!overlay) return [];
      var overlayRect = overlay.getBoundingClientRect();
      if (overlayRect.width <= 0 || overlayRect.height <= 0) return [];
      return Array.prototype.map
        .call(
          overlay.querySelectorAll(
            ".personalize-pilot-main-preview__item:not([hidden])",
          ),
          function (element) {
            var rect = element.getBoundingClientRect();
            var style = window.getComputedStyle(element);
            var image = element.querySelector("img");
            var svg = element.querySelector("svg");
            var imageUrl =
              image && !image.hidden
                ? image.currentSrc || image.src
                : svg
                  ? "data:image/svg+xml;charset=utf-8," +
                    encodeURIComponent(
                      new XMLSerializer().serializeToString(svg),
                    )
                  : "";
            var textNode = element.querySelector("[data-freeform-text]");
            var text = String(
              (textNode && textNode.textContent) ||
                element.dataset.previewTextValue ||
                element.textContent ||
                "",
            ).trim();
            return {
              kind: imageUrl ? "image" : "text",
              text: imageUrl ? undefined : text,
              imageUrl: imageUrl || undefined,
              x:
                ((rect.left + rect.width / 2 - overlayRect.left) /
                  overlayRect.width) *
                100,
              y:
                ((rect.top + rect.height / 2 - overlayRect.top) /
                  overlayRect.height) *
                100,
              width: (rect.width / overlayRect.width) * 100,
              height: (rect.height / overlayRect.height) * 100,
              rotation: getElementRotation(element),
              color: style.color,
              fontFamily: style.fontFamily,
              fontWeight: style.fontWeight,
              opacity: Number(style.opacity || 1),
              borderRadius:
                String(style.borderRadius || "").indexOf("50%") >= 0 ? 50 : 0,
            };
          },
        )
        .filter(function (descriptor) {
          return Boolean(descriptor.text || descriptor.imageUrl);
        })
        .slice(0, 30);
    }

    function setProduct3dStatus(message, failed) {
      if (!product3dStatus) return;
      product3dStatus.textContent = message || "";
      product3dStatus.hidden = !message;
      product3dStatus.classList.toggle("is-error", Boolean(failed));
    }

    function openProduct3d() {
      if (!product3dButton) return;
      product3dButton.disabled = true;
      product3dButton.setAttribute("aria-busy", "true");
      setProduct3dStatus(
        getMessage(widget, "message3dLoading", "3D view is loading ..."),
        false,
      );
      loadProduct3dRuntime(widget.dataset.product3dScriptUrl || "")
        .then(function (runtime) {
          setProduct3dStatus("", false);
          return runtime.open({
            productName: widget.dataset.productTitle || "Product",
            previewImageUrl: usesFinishedFixedArtworkBase(widget)
              ? widget.dataset.finishedImageUrl ||
                widget.dataset.mainImageUrl ||
                ""
              : widget.dataset.blankImageUrl ||
                widget.dataset.mainImageUrl ||
                "",
            experience: experienceSettings,
            material: getCurrentMaterialProfile(),
            designDescriptors: collectProduct3dDescriptors(),
            onError: function () {
              setProduct3dStatus(
                getMessage(
                  widget,
                  "message3dFailed",
                  "The 3D view failed. The 2D preview remains available.",
                ),
                true,
              );
            },
          });
        })
        .catch(function () {
          setProduct3dStatus(
            getMessage(
              widget,
              "message3dFailed",
              "The 3D view failed. The 2D preview remains available.",
            ),
            true,
          );
        })
        .finally(function () {
          product3dButton.disabled = false;
          product3dButton.removeAttribute("aria-busy");
        });
    }

    applyLightingPreview();
    if (materialInput) {
      materialInput.addEventListener("change", applyMaterialPreview);
    }
    lightingInputs.forEach(function (input) {
      input.addEventListener("change", function () {
        if (!input.checked) return;
        finalReviewConfirmed = false;
        applyLightingPreview();
        refreshMainImageMode();
      });
    });
    if (product3dButton) {
      product3dButton.addEventListener("click", openProduct3d);
    }

    function getTextTargets(slotId) {
      return [
        textPreviewTargets[slotId],
        mainImagePreview.textTargets[slotId],
      ].filter(Boolean);
    }

    function getImageTargets(slotId) {
      return [
        imagePreviewTargets[slotId],
        mainImagePreview.imageTargets[slotId],
      ].filter(Boolean);
    }

    function getCanonicalTemplateArtworkLayout(
      sourceLayout,
      surfaceId,
      stageAspectRatio,
    ) {
      var previewLayout = resolveSurfaceRelativeLayout(sourceLayout, surfaceId);
      return clampLayoutToConfiguredSurface(
        previewLayout,
        surfaceId,
        stageAspectRatio,
        true,
      );
    }

    function applyCanonicalTemplateArtworkBaseGeometry(
      target,
      previewLayout,
      stageAspectRatio,
    ) {
      var designX = Number(previewLayout.x) || 50;
      var designY = Number(previewLayout.y) || 50;
      var designWidth = Number(previewLayout.width) || 48;
      var designHeight = Number(previewLayout.height) || 48;

      target.dataset.templateBaseX = String(designX);
      target.dataset.templateBaseY = String(designY);
      target.dataset.templateBaseWidth = String(designWidth);
      target.dataset.templateBaseHeight = String(designHeight);
      target.dataset.templateBaseRotation = String(
        Number(previewLayout.rotation) || 0,
      );
      target.dataset.templateCanonicalStageAspectRatio =
        String(stageAspectRatio);
      target.style.setProperty("--slot-x", designX + "%");
      target.style.setProperty("--slot-y", designY + "%");
      target.style.setProperty("--slot-width", designWidth + "%");
      target.style.setProperty("--slot-height", designHeight + "%");
      target.style.setProperty(
        "--slot-rotation",
        (Number(previewLayout.rotation) || 0) + "deg",
      );
    }

    function getFiniteTextLayoutNumber(value, fallback) {
      var parsed = Number(value);
      return Number.isFinite(parsed) ? parsed : fallback;
    }

    function setResponsiveTextSize(target, layout, surfaceId) {
      if (!target || !layout) return;
      var fontSizeMm = getFiniteTextLayoutNumber(layout.fontSizeMm, 8);
      var resolvedSurfaceId =
        surfaceId || target.dataset.personalizationSurface || activeSurfaceId;
      target.dataset.previewFontSizeMm = String(fontSizeMm);
      target.style.setProperty(
        "--slot-size",
        getStorefrontFontSizePx(
          { fontSizeMm: fontSizeMm },
          target,
          resolvedSurfaceId,
        ) + "px",
      );
    }

    function applyResolvedTextLayout(target, sourceLayout, surfaceId) {
      if (!target || !sourceLayout) return sourceLayout || {};
      var resolvedSurfaceId =
        surfaceId || target.dataset.personalizationSurface || activeSurfaceId;
      var canonicalSourceLayout = normalizeLegacyAcrylicLongTextLayout(
        sourceLayout,
        resolvedSurfaceId,
      );
      var migratedLegacyLayout = canonicalSourceLayout !== sourceLayout;
      var previewSourceLayout = mapTemplateTextToContainedArtworkPreview(
        canonicalSourceLayout,
        resolvedSurfaceId,
        target,
      );
      var previewLayout = resolveSurfaceRelativeLayout(
        previewSourceLayout,
        resolvedSurfaceId,
      );
      previewLayout = clampLayoutToConfiguredSurface(
        previewLayout,
        resolvedSurfaceId,
        getCanonicalProductPreviewStageAspectRatio(),
        false,
      );

      target.style.setProperty(
        "--slot-x",
        getFiniteTextLayoutNumber(previewLayout.x, 50) + "%",
      );
      target.style.setProperty(
        "--slot-y",
        getFiniteTextLayoutNumber(previewLayout.y, 50) + "%",
      );
      target.style.setProperty(
        "--slot-width",
        getFiniteTextLayoutNumber(previewLayout.width, 70) + "%",
      );
      target.style.setProperty(
        "--slot-height",
        getFiniteTextLayoutNumber(previewLayout.height, 16) + "%",
      );
      target.style.setProperty(
        "--slot-rotation",
        getFiniteTextLayoutNumber(previewLayout.rotation, 0) + "deg",
      );
      target.style.setProperty(
        "--slot-align",
        canonicalSourceLayout.align || previewLayout.align || "center",
      );
      target.dataset.previewResolvedLayout = JSON.stringify(previewLayout);
      target.dataset.previewSourceLayout = JSON.stringify(
        canonicalSourceLayout,
      );
      target.dataset.previewSourceSurface = resolvedSurfaceId;
      target.dataset.previewTone = getMaterialPreviewTone(
        canonicalSourceLayout.previewTone,
      );
      setResponsiveTextSize(target, previewLayout, resolvedSurfaceId);

      if (migratedLegacyLayout) {
        var slotId =
          target.dataset.previewTextSlot ||
          target.dataset.mainPreviewTextSlot ||
          "";
        var submittedLayout = slotId
          ? widget.querySelector(
              '[data-customer-layout-input="' + slotId + '"]',
            )
          : null;
        if (submittedLayout) {
          // Persist the normalized motif-canvas layout. Saving the display-only
          // contain result would make production contain the text a second time.
          submittedLayout.value = JSON.stringify(canonicalSourceLayout);
        }
      }

      return previewLayout;
    }

    function syncConfiguredTextLayouts() {
      Object.keys(textPreviewTargets).forEach(function (slotId) {
        var source = textPreviewTargets[slotId];
        if (!source || source.dataset.templatePreview === "true") return;
        var layout = {};
        try {
          layout = JSON.parse(source.dataset.slotLayout || "{}");
        } catch (error) {
          layout = {};
        }
        if (!layout || !Object.keys(layout).length) return;
        getTextTargets(slotId).forEach(function (target) {
          applyResolvedTextLayout(
            target,
            layout,
            target.dataset.personalizationSurface || activeSurfaceId,
          );
        });
      });
    }

    function syncAllPreviewTextFontSizes() {
      Object.keys(textPreviewTargets).forEach(function (slotId) {
        getTextTargets(slotId).forEach(function (target) {
          var fontSizeMm = Number(target.dataset.previewFontSizeMm);
          if (!Number.isFinite(fontSizeMm) || fontSizeMm <= 0) return;
          setResponsiveTextSize(
            target,
            { fontSizeMm: fontSizeMm },
            target.dataset.personalizationSurface || activeSurfaceId,
          );
          updatePreviewText(
            target,
            target.dataset.previewTextValue || target.textContent,
          );
        });
      });
    }

    function syncCanonicalPreviewGeometry() {
      var canonicalStageAspectRatio =
        getCanonicalProductPreviewStageAspectRatio();

      Object.keys(imagePreviewTargets).forEach(function (slotId) {
        var persistedLayout = null;
        getImageTargets(slotId).forEach(function (target) {
          var sourceLayout = {};
          try {
            sourceLayout = JSON.parse(
              target.dataset.templateSourceLayout || "{}",
            );
          } catch (error) {
            sourceLayout = {};
          }
          if (!Object.keys(sourceLayout).length) return;

          var surfaceId =
            target.dataset.templateSourceSurface ||
            target.dataset.personalizationSurface ||
            activeSurfaceId;
          var previewLayout = getCanonicalTemplateArtworkLayout(
            sourceLayout,
            surfaceId,
            canonicalStageAspectRatio,
          );
          persistedLayout = previewLayout;
          applyCanonicalTemplateArtworkBaseGeometry(
            target,
            previewLayout,
            canonicalStageAspectRatio,
          );
          syncTemplateArtworkGeometry(target);
        });

        var layoutInput = getTemplateControl(
          "data-template-layout-input",
          slotId,
        );
        if (layoutInput && persistedLayout) {
          layoutInput.value = JSON.stringify(persistedLayout);
        }
      });

      Object.keys(textPreviewTargets).forEach(function (slotId) {
        var resolvedLayout = null;
        getTextTargets(slotId).forEach(function (target) {
          var sourceLayout = {};
          try {
            sourceLayout = JSON.parse(
              target.dataset.previewSourceLayout || "{}",
            );
          } catch (error) {
            sourceLayout = {};
          }
          if (!Object.keys(sourceLayout).length) return;
          resolvedLayout = applyResolvedTextLayout(
            target,
            sourceLayout,
            target.dataset.previewSourceSurface || activeSurfaceId,
          );
        });
        // The image can reveal its real aspect ratio after the controls were
        // initialized. Rebase the controls before replaying their adjustments;
        // otherwise they restore an obsolete name-band position on every input.
        rebaseCustomerTemplateTextGeometry(
          customerSlotLayouts[slotId],
          resolvedLayout,
        );
      });

      syncAllPreviewTextFontSizes();
      // Recalculating the canonical stage after an image load or a responsive
      // resize restores the authored template geometry first. Re-apply the
      // customer's active fine-tuning immediately afterwards so the preview
      // cannot jump back to 100% while the range control still shows a larger
      // value.
      refreshCustomerSlotLayouts();
    }

    widget.personalizePilotSyncTextGeometry = syncCanonicalPreviewGeometry;
    syncConfiguredTextLayouts();
    syncCanonicalPreviewGeometry();

    function syncClonedPreviewTextGeometry(source, clone) {
      if (!source || !clone) return;
      syncClonedWoodBasePreview(source, clone);
      var sourceTargets = Array.from(
        source.querySelectorAll("[data-main-preview-text-slot]"),
      );

      clone
        .querySelectorAll("[data-main-preview-text-slot]")
        .forEach(function (target) {
          var slotId = target.dataset.mainPreviewTextSlot || "";
          var sourceTarget = sourceTargets.find(function (candidate) {
            return candidate.dataset.mainPreviewTextSlot === slotId;
          });
          if (!sourceTarget) return;

          var sourceStage =
            sourceTarget.closest(".personalize-pilot-main-preview") || source;
          var cloneStage =
            target.closest(".personalize-pilot-main-preview") || clone;
          var sourceStageRect = sourceStage.getBoundingClientRect();
          var cloneStageRect = cloneStage.getBoundingClientRect();
          var scaleX =
            cloneStageRect.width / Math.max(sourceStageRect.width, 1);
          var scaleY =
            cloneStageRect.height / Math.max(sourceStageRect.height, 1);
          var scale = Math.min(scaleX, scaleY);
          if (!Number.isFinite(scale) || scale <= 0) scale = 1;

          var sourceStyles = window.getComputedStyle(sourceTarget);
          var sourceFontSize = Math.max(
            2,
            parseFloat(sourceStyles.fontSize || sourceTarget.style.fontSize) ||
              16,
          );
          var cloneFontSize = Number((sourceFontSize * scale).toFixed(3));
          var text =
            sourceTarget.dataset.previewTextValue ||
            sourceTarget.textContent ||
            "";
          var targetRect = target.getBoundingClientRect();
          var cloneSignature = [
            text,
            sourceStyles.fontFamily,
            sourceStyles.fontWeight,
            sourceStyles.fontStyle,
            sourceStyles.letterSpacing,
            sourceStyles.lineHeight,
            sourceStyles.color,
            sourceStyles.textShadow,
            sourceStyles.filter,
            sourceStyles.mixBlendMode,
            sourceStyles.opacity,
            sourceStyles.webkitTextStroke,
            cloneFontSize,
            Math.round(targetRect.width * 100) / 100,
            Math.round(targetRect.height * 100) / 100,
            target.dataset.textCurve || "0",
            target.dataset.surfaceMode || "flat",
            target.dataset.surfaceIntensity || "0",
          ].join("|");

          if (target.dataset.previewCloneSignature === cloneSignature) return;

          target.dataset.previewTextValue = text;
          target.dataset.previewCloneSignature = cloneSignature;
          target.style.fontFamily = sourceStyles.fontFamily;
          target.style.fontWeight = sourceStyles.fontWeight;
          target.style.fontStyle = sourceStyles.fontStyle;
          target.style.letterSpacing = sourceStyles.letterSpacing;
          var sourceLineHeightPx = parseFloat(sourceStyles.lineHeight);
          target.style.lineHeight =
            Number.isFinite(sourceLineHeightPx) && sourceLineHeightPx > 0
              ? Number((sourceLineHeightPx * scale).toFixed(3)) + "px"
              : sourceStyles.lineHeight;
          // The follower must be a scaled copy of the large preview, not a
          // second rendering with theme-default black text. Copy the computed
          // engraving treatment as inline values so color, relief/shadow and
          // multiply blending remain identical even outside the widget root.
          target.style.color = sourceStyles.color;
          target.style.textShadow = sourceStyles.textShadow;
          target.style.filter = sourceStyles.filter;
          target.style.mixBlendMode = sourceStyles.mixBlendMode;
          target.style.opacity = sourceStyles.opacity;
          target.style.webkitTextStroke = sourceStyles.webkitTextStroke;
          target.style.setProperty("--slot-size", cloneFontSize + "px");
          target.style.fontSize = cloneFontSize + "px";
          target.dataset.previewCloneScale = String(scale);
          var definitionParagraph = sourceTarget.querySelector("svg[data-definition-paragraph]");
          if (definitionParagraph) {
            // Preserve the measured lines and viewBox. Flattening the SVG into
            // text recreates a single oversized paragraph in mobile followers.
            target.replaceChildren(definitionParagraph.cloneNode(true));
            return;
          }
          target.textContent = text;
          renderGuidedTextCurve(target, text);
          renderWarpedTextTarget(target, text);
        });
    }

    function syncClonedWoodBasePreview(source, clone) {
      var sourceRect = source.getBoundingClientRect();
      if (!sourceRect.width || !sourceRect.height) return;
      var embedded = clone.querySelector("[data-wood-base-embedded-preview]");
      // The theme supplies a gallery fallback as well as an embedded layer.
      // Only the embedded layer belongs to an active composed preview.
      if (embedded && !embedded.closest("[hidden]")) {
        clone.querySelectorAll("[data-wood-base-image-preview]").forEach(function (layer) {
          layer.remove();
        });
      }
      clone.querySelectorAll("[data-wood-base-image-preview], [data-wood-base-embedded-preview]").forEach(function (layer) {
        var selector = layer.hasAttribute("data-wood-base-embedded-preview")
          ? "[data-wood-base-embedded-preview]" : "[data-wood-base-image-preview]";
        var original = source.querySelector(selector);
        if (!original) return;
        var originalRect = original.getBoundingClientRect();
        if (!originalRect.width || !originalRect.height) return;
        if (selector === "[data-wood-base-image-preview]") {
          layer.style.left = ((originalRect.left - sourceRect.left) / sourceRect.width * 100) + "%";
          layer.style.top = ((originalRect.top - sourceRect.top) / sourceRect.height * 100) + "%";
          layer.style.width = (originalRect.width / sourceRect.width * 100) + "%";
          layer.style.height = (originalRect.height / sourceRect.height * 100) + "%";
        }
        var originalText = original.querySelector("[data-wood-base-image-preview-text]");
        var text = layer.querySelector("[data-wood-base-image-preview-text]");
        if (!originalText || !text) return;
        var styles = window.getComputedStyle(originalText);
        var scale = layer.getBoundingClientRect().width / originalRect.width;
        if (!Number.isFinite(scale) || scale <= 0) return;
        if (text.textContent !== originalText.textContent) text.textContent = originalText.textContent;
        ["fontFamily", "fontWeight", "fontStyle", "color", "textShadow", "mixBlendMode"].forEach(function (key) {
          text.style[key] = styles[key];
        });
        text.style.fontSize = (parseFloat(styles.fontSize) * scale).toFixed(3) + "px";
      });
    }

    function installExternalPreviewFollowerSync() {
      if (!document.body || !mainImagePreview.surface) return;
      var syncFrame = 0;
      var observer = null;

      function observeFollowerChanges() {
        if (!observer || !document.body) return;
        observer.observe(document.body, { childList: true, subtree: true });
      }

      function syncFollowers() {
        syncFrame = 0;
        if (!widget.isConnected) {
          if (observer) observer.disconnect();
          return;
        }
        // Synchronising text replaces curve/canvas children. Disconnect while
        // doing that so our own DOM writes cannot schedule an endless next
        // animation frame and make the cloned text visibly oscillate.
        if (observer) observer.disconnect();
        document
          .querySelectorAll("[data-product-gallery-follower]")
          .forEach(function (follower) {
            var viewport = follower.querySelector(
              ".product-gallery-follower__viewport",
            );
            if (viewport) {
              syncClonedPreviewTextGeometry(mainImagePreview.surface, viewport);
            }
          });
        observeFollowerChanges();
      }

      function scheduleFollowerSync() {
        if (syncFrame) window.cancelAnimationFrame(syncFrame);
        syncFrame = window.requestAnimationFrame(syncFollowers);
      }

      // Guided text inputs can update the currently visible theme follower in
      // the same event turn. Waiting for the theme to replace its clone left
      // the old word visible for up to the later recovery refresh.
      widget.personalizePilotSyncFollowers = syncFollowers;

      observer = new MutationObserver(function (mutations) {
        var followerChanged = mutations.some(function (mutation) {
          if (
            mutation.target.closest &&
            mutation.target.closest("[data-product-gallery-follower]")
          ) {
            // Theme code has replaced the follower contents. This is a real
            // external update; it is safe because syncFollowers disconnects
            // this observer while applying the matching text geometry.
            return true;
          }
          return Array.from(mutation.addedNodes || []).some(function (node) {
            return Boolean(
              node.nodeType === 1 &&
              ((node.matches &&
                node.matches("[data-product-gallery-follower]")) ||
                (node.querySelector &&
                  node.querySelector("[data-product-gallery-follower]"))),
            );
          });
        });
        if (followerChanged) scheduleFollowerSync();
      });
      observeFollowerChanges();
      scheduleFollowerSync();
    }

    installExternalPreviewFollowerSync();

    function getPreviewCloneSourceSignature(source, previewRect) {
      if (!source) return "";
      var productImage = getProductPreviewImage(source);
      return [
        source.innerHTML,
        source.dataset.personalizePilotPreviewMode || "",
        productImage
          ? productImage.currentSrc || productImage.getAttribute("src") || ""
          : "",
        Math.round(Number(previewRect && previewRect.width) * 100) / 100,
        Math.round(Number(previewRect && previewRect.height) * 100) / 100,
        document.fonts ? document.fonts.status : "unsupported",
      ].join("\u241f");
    }

    function refreshMobileLivePreview() {
      var previewHost = widget.querySelector(
        "[data-mobile-live-preview-content]",
      );
      var source = mainImagePreview.surface;
      if (!previewHost || !source || !source.isConnected) return;

      var sourceRect = source.getBoundingClientRect();
      // A temporarily hidden/reflowing gallery has no usable coordinate frame.
      // Keep the last valid preview rather than replacing it with a 1:1 guess.
      if (
        !Number.isFinite(sourceRect.width) ||
        !Number.isFinite(sourceRect.height) ||
        sourceRect.width <= 0 ||
        sourceRect.height <= 0
      ) {
        mobilePreviewSourceSignature = "";
        return;
      }
      // The follower is a scaled copy of the complete main preview. Using the
      // visible image-content rectangle here created a second coordinate
      // system whenever the gallery contained letterboxing. That made the
      // mobile overlay larger than the main preview. Keep one source rectangle
      // for the product image, overlay, text and final review.
      var previewRect = sourceRect;
      var nextSourceSignature = getPreviewCloneSourceSignature(
        source,
        previewRect,
      );
      if (
        mobilePreviewSourceSignature === nextSourceSignature &&
        previewHost.firstElementChild
      ) {
        return;
      }
      var clone = source.cloneNode(true);
      clone.removeAttribute("id");
      clone.classList.add("personalize-pilot-mobile-preview__product");
      clone.classList.remove("is-active", "is-selected");
      clone.querySelectorAll("[id]").forEach(function (element) {
        element.removeAttribute("id");
      });
      clone
        .querySelectorAll(
          "button, input, select, textarea, .personalize-pilot-main-preview__design-area, .personalize-pilot-widget__freeform-handle, [data-personalize-pilot-preview-status], [hidden]",
        )
        .forEach(function (element) {
          element.remove();
        });
      clone
        .querySelectorAll(
          ".is-customer-editable, .is-selected, .is-dragging, .is-conditionally-hidden",
        )
        .forEach(function (element) {
          element.classList.remove(
            "is-customer-editable",
            "is-selected",
            "is-dragging",
            "is-conditionally-hidden",
          );
          element.removeAttribute("tabindex");
        });
      clone
        .querySelectorAll(".personalize-pilot-main-preview")
        .forEach(function (overlay) {
          overlay.hidden = false;
          overlay.classList.remove("is-customer-editing");
        });
      clone.setAttribute("aria-hidden", "true");
      // Do not expose the unscaled clone for a frame. Its text still carries
      // the large preview font size until the measured clone geometry below
      // has been applied, which otherwise looks like a visible text jump on
      // mobile product pages.
      clone.style.visibility = "hidden";
      mobilePreviewSourceSignature = nextSourceSignature;
      previewHost.replaceChildren(clone);
      previewHost.style.setProperty(
        "--personalize-pilot-mobile-preview-ratio",
        String(previewRect.width / previewRect.height),
      );
      previewHost.style.aspectRatio =
        previewRect.width + " / " + previewRect.height;

      window.requestAnimationFrame(function () {
        // Rapid light/size changes may already have replaced this clone.
        // Only the current preview may be fitted and made visible.
        if (previewHost.firstElementChild !== clone || !source.isConnected) return;
        // Mobile toolbar/orientation changes can resize the source between
        // cloning and fitting. Image aspect and overlay must use the same
        // current frame, never a mix of old and new measurements.
        var currentRect = source.getBoundingClientRect();
        if (
          !Number.isFinite(currentRect.width) ||
          !Number.isFinite(currentRect.height) ||
          currentRect.width <= 0 ||
          currentRect.height <= 0
        ) {
          mobilePreviewSourceSignature = "";
          return;
        }
        previewHost.style.setProperty(
          "--personalize-pilot-mobile-preview-ratio",
          String(currentRect.width / currentRect.height),
        );
        previewHost.style.aspectRatio =
          currentRect.width + " / " + currentRect.height;
        syncFinalReviewOverlayGeometry(source, clone, currentRect);
        syncClonedPreviewTextGeometry(source, clone);
        copyReviewCanvases(source, clone);
        clone.style.visibility = "";
      });
    }

    function scheduleMobileLivePreviewRefresh() {
      if (mobilePreviewRefreshFrame) {
        window.cancelAnimationFrame(mobilePreviewRefreshFrame);
      }
      mobilePreviewRefreshFrame = window.requestAnimationFrame(function () {
        mobilePreviewRefreshFrame = null;
        refreshMobileLivePreview();
      });
    }

    function getVisibleMobilePreviewSlots(root) {
      return Array.from(
        root.querySelectorAll(
          "[data-main-preview-text-slot], [data-main-preview-image-slot], [data-wood-base-image-preview-text]",
        ),
      )
        .filter(function (target) {
          var embedded = root.querySelector("[data-wood-base-embedded-preview]");
          if (embedded && !embedded.closest("[hidden]") && target.closest("[data-wood-base-image-preview]")) return false;
          return !target.closest("[hidden]");
        })
        .map(function (target) {
          return (
            target.getAttribute("data-main-preview-text-slot") ||
            target.getAttribute("data-main-preview-image-slot") ||
            "wood-base"
          );
        })
        .sort()
        .join("|");
    }

    function syncCurrentMobilePreviewText() {
      var previewHost = widget.querySelector(
        "[data-mobile-live-preview-content]",
      );
      var source = mainImagePreview.surface;
      if (!previewHost || !previewHost.firstElementChild || !source) {
        return false;
      }
      // Empty/hidden slots are intentionally omitted from a clone. On the
      // first keystroke (or when a field is cleared/added), text-only sync
      // cannot create/remove those nodes. Rebuild before considering it fresh.
      if (
        getVisibleMobilePreviewSlots(source) !==
        getVisibleMobilePreviewSlots(previewHost)
      ) {
        return false;
      }
      var sourceRect = source.getBoundingClientRect();
      syncFinalReviewOverlayGeometry(source, previewHost, sourceRect);
      syncClonedPreviewTextGeometry(source, previewHost);
      // Do not stamp the full source signature after a text-only update:
      // images, lighting or newly added base engraving may still need cloning.
      return true;
    }

    var freeformSymbolLibrary = [
      {
        label: "Herz",
        value: "heart",
        path: "M12 21s-7.2-4.35-9.6-8.34C.46 9.64 1.28 5.5 4.8 4.18 7.02 3.35 9.2 4.2 12 7c2.8-2.8 4.98-3.65 7.2-2.82 3.52 1.32 4.34 5.46 2.4 8.48C19.2 16.65 12 21 12 21Z",
      },
      {
        label: "Herz Kontur",
        value: "heart_outline",
        path: "M16.5 3c-1.74 0-3.41.81-4.5 2.09C10.91 3.81 9.24 3 7.5 3 4.42 3 2 5.42 2 8.5c0 3.76 3.4 6.86 8.55 11.54L12 21.35l1.45-1.32C18.6 15.36 22 12.26 22 8.5 22 5.42 19.58 3 16.5 3Zm-4.4 15.55-.1.1-.1-.1C7.14 14.24 4 11.39 4 8.5 4 6.5 5.5 5 7.5 5c1.54 0 3.04.99 3.57 2.36h1.87C13.46 5.99 14.96 5 16.5 5c2 0 3.5 1.5 3.5 3.5 0 2.89-3.14 5.74-7.9 10.05Z",
      },
      {
        label: "Doppelherz",
        value: "double_heart",
        path: "M8.4 20.2S1.2 16.05.45 12.15C-.12 9.21 1.86 6.7 4.65 6.7c1.5 0 2.72.68 3.75 1.82C9.43 7.38 10.65 6.7 12.15 6.7c2.79 0 4.77 2.51 4.2 5.45-.75 3.9-7.95 8.05-7.95 8.05Zm7.2-4.7-.72-.45c1.17-1.61 1.79-3.21 1.79-4.7 0-2.65-1.48-4.81-3.7-5.68.74-.77 1.68-1.22 2.78-1.22 2.79 0 4.77 2.51 4.2 5.45-.42 2.18-2.86 4.58-4.35 5.6Z",
      },
      {
        label: "Stern",
        value: "star",
        path: "m12 2.2 2.95 5.98 6.6.96-4.78 4.66 1.13 6.58L12 17.27l-5.9 3.11 1.13-6.58-4.78-4.66 6.6-.96L12 2.2Z",
      },
      {
        label: "Unendlich",
        value: "infinity",
        path: "M7.1 7.2c-2.65 0-4.6 2.1-4.6 4.8s1.95 4.8 4.6 4.8c2.08 0 3.7-1.24 4.9-2.72 1.2 1.48 2.82 2.72 4.9 2.72 2.65 0 4.6-2.1 4.6-4.8s-1.95-4.8-4.6-4.8c-2.08 0-3.7 1.24-4.9 2.72C10.8 8.44 9.18 7.2 7.1 7.2Zm0 2.4c1.12 0 2.24.94 3.4 2.4-1.16 1.46-2.28 2.4-3.4 2.4-1.3 0-2.2-1.02-2.2-2.4s.9-2.4 2.2-2.4Zm9.8 0c1.3 0 2.2 1.02 2.2 2.4s-.9 2.4-2.2 2.4c-1.12 0-2.24-.94-3.4-2.4 1.16-1.46 2.28-2.4 3.4-2.4Z",
      },
      {
        label: "Ring",
        value: "ring",
        path: "M9.2 3.2 12 6l2.8-2.8 2.2 2.2-2.2 2.2A6.5 6.5 0 1 1 9.2 7.6L7 5.4l2.2-2.2ZM12 9a4 4 0 1 0 0 8 4 4 0 0 0 0-8Z",
      },
      {
        label: "Pfote",
        value: "paw",
        path: "M8.1 10.2c1.32-.28 2.02-1.86 1.57-3.52-.46-1.66-1.9-2.78-3.22-2.5-1.32.29-2.02 1.87-1.56 3.53.45 1.66 1.89 2.77 3.21 2.49Zm7.8 0c1.32.28 2.76-.83 3.21-2.49.46-1.66-.24-3.24-1.56-3.53-1.32-.28-2.76.84-3.22 2.5-.45 1.66.25 3.24 1.57 3.52ZM12 9.5c-3.1 0-6.2 3.66-6.2 6.55 0 2.2 1.66 3.75 3.7 3.75 1.08 0 1.74-.5 2.5-.5s1.42.5 2.5.5c2.04 0 3.7-1.55 3.7-3.75C18.2 13.16 15.1 9.5 12 9.5Z",
      },
    ];
    var freeformShapeLibrary = [
      { label: "Rechteck", value: "rectangle" },
      { label: "Kreis / Ellipse", value: "ellipse" },
      { label: "Linie", value: "line" },
      { label: "Dreieck", value: "triangle" },
      { label: "Stern", value: "star" },
      { label: "Herz", value: "heart" },
    ];

    function clampFreeformNumber(value, minimum, maximum) {
      var parsed = Number(value);
      if (
        personalizationGeometry &&
        typeof personalizationGeometry.clampGeometryNumber === "function"
      ) {
        return personalizationGeometry.clampGeometryNumber(
          parsed,
          minimum,
          maximum,
        );
      }
      if (!Number.isFinite(parsed)) return minimum;
      return Math.max(minimum, Math.min(maximum, parsed));
    }

    function beginCustomerPointerDrag(event, target, onMove) {
      if (event.button !== undefined && event.button !== 0) return;
      var pointerId = event.pointerId;
      var previousUserSelect = document.body.style.userSelect;

      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === "function")
        event.stopImmediatePropagation();
      target.classList.add("is-dragging");
      if (mainImagePreview.overlay)
        mainImagePreview.overlay.classList.add("is-customer-editing");
      document.body.style.userSelect = "none";

      function move(moveEvent) {
        if (
          moveEvent.pointerId !== undefined &&
          moveEvent.pointerId !== pointerId
        )
          return;
        moveEvent.preventDefault();
        onMove(moveEvent);
      }

      function stop(stopEvent) {
        if (
          stopEvent &&
          stopEvent.pointerId !== undefined &&
          stopEvent.pointerId !== pointerId
        ) {
          return;
        }
        target.classList.remove("is-dragging");
        if (mainImagePreview.overlay)
          mainImagePreview.overlay.classList.remove("is-customer-editing");
        document.body.style.userSelect = previousUserSelect;
        document.removeEventListener("pointermove", move, true);
        document.removeEventListener("pointerup", stop, true);
        document.removeEventListener("pointercancel", stop, true);
        window.removeEventListener("blur", stop);
      }

      document.addEventListener("pointermove", move, {
        capture: true,
        passive: false,
      });
      document.addEventListener("pointerup", stop, true);
      document.addEventListener("pointercancel", stop, true);
      window.addEventListener("blur", stop);
    }

    function connectFreeformControl(control) {
      if (control && productFormId && !control.closest("form")) {
        control.setAttribute("form", productFormId);
      }
    }

    function cloneFreeformItems(items) {
      return items.map(function (item) {
        return Object.assign({}, item);
      });
    }

    function createFreeformSnapshot() {
      return {
        items: cloneFreeformItems(freeformItems),
        sequence: freeformSequence,
        selectedItemId: selectedFreeformItemId,
      };
    }

    function updateFreeformHistoryButtons() {
      var undoButton = widget.querySelector("[data-freeform-undo]");
      var redoButton = widget.querySelector("[data-freeform-redo]");
      if (undoButton) undoButton.disabled = freeformUndoStack.length === 0;
      if (redoButton) redoButton.disabled = freeformRedoStack.length === 0;
    }

    function rememberFreeformState() {
      freeformUndoStack.push(createFreeformSnapshot());
      if (freeformUndoStack.length > freeformHistoryLimit) {
        freeformUndoStack.shift();
      }
      freeformRedoStack = [];
      updateFreeformHistoryButtons();
    }

    function restoreFreeformSnapshot(snapshot) {
      if (!snapshot) return;
      freeformItems = cloneFreeformItems(snapshot.items || []);
      freeformSequence = Number(snapshot.sequence || 0);
      selectedFreeformItemId = snapshot.selectedItemId || "";
      renderFreeformEditor();
    }

    function undoFreeformChange() {
      if (freeformUndoStack.length === 0) return;
      freeformRedoStack.push(createFreeformSnapshot());
      restoreFreeformSnapshot(freeformUndoStack.pop());
    }

    function redoFreeformChange() {
      if (freeformRedoStack.length === 0) return;
      freeformUndoStack.push(createFreeformSnapshot());
      restoreFreeformSnapshot(freeformRedoStack.pop());
    }

    function resetFreeformHistory() {
      freeformUndoStack = [];
      freeformRedoStack = [];
      selectedFreeformItemId = "";
      updateFreeformHistoryButtons();
    }

    function updateFreeformSelection() {
      widget.querySelectorAll("[data-freeform-item]").forEach(function (card) {
        card.classList.toggle(
          "is-selected",
          card.dataset.freeformItem === selectedFreeformItemId,
        );
      });
      if (mainImagePreview.overlay) {
        mainImagePreview.overlay
          .querySelectorAll("[data-freeform-preview]")
          .forEach(function (target) {
            var selected =
              target.dataset.freeformPreview === selectedFreeformItemId;
            target.classList.toggle("is-selected", selected);
            target.setAttribute("aria-pressed", selected ? "true" : "false");
          });
      }
    }

    function selectFreeformItem(itemId, focusPreview) {
      selectedFreeformItemId = itemId || "";
      updateFreeformSelection();
      if (focusPreview && mainImagePreview.overlay) {
        var target = mainImagePreview.overlay.querySelector(
          '[data-freeform-preview="' + selectedFreeformItemId + '"]',
        );
        if (target) target.focus({ preventScroll: true });
      }
    }

    function getFreeformDesignArea(surfaceId) {
      var surface = personalizationSurfaces.find(function (item) {
        return item.id === (surfaceId || activeSurfaceId);
      });
      var configuredArea = (surface && surface.designArea) || {};
      var requestedArea = {
        x:
          configuredArea.x !== undefined
            ? configuredArea.x
            : customerDesignSettings.designAreaXPercent || 50,
        y:
          configuredArea.y !== undefined
            ? configuredArea.y
            : customerDesignSettings.designAreaYPercent || 50,
        width:
          configuredArea.width !== undefined
            ? configuredArea.width
            : customerDesignSettings.designAreaWidthPercent || 80,
        height:
          configuredArea.height !== undefined
            ? configuredArea.height
            : customerDesignSettings.designAreaHeightPercent || 70,
        rotation:
          configuredArea.rotation !== undefined ? configuredArea.rotation : 0,
        shape: configuredArea.shape === "ellipse" ? "ellipse" : "rectangle",
      };

      if (
        personalizationGeometry &&
        typeof personalizationGeometry.normalizeGeometrySurfaceArea ===
          "function"
      ) {
        return personalizationGeometry.normalizeGeometrySurfaceArea(
          requestedArea,
        );
      }
      var width = clampFreeformNumber(requestedArea.width, 8, 100);
      var height = clampFreeformNumber(requestedArea.height, 8, 100);

      return {
        x: clampFreeformNumber(requestedArea.x, width / 2, 100 - width / 2),
        y: clampFreeformNumber(requestedArea.y, height / 2, 100 - height / 2),
        width: width,
        height: height,
        rotation: clampFreeformNumber(requestedArea.rotation, -180, 180),
        shape: requestedArea.shape,
      };
    }

    function rotateDesignPoint(x, y, centerX, centerY, degrees) {
      if (
        personalizationGeometry &&
        typeof personalizationGeometry.rotateGeometryPoint === "function"
      ) {
        return personalizationGeometry.rotateGeometryPoint(
          x,
          y,
          centerX,
          centerY,
          degrees,
        );
      }
      var radians = (degrees * Math.PI) / 180;
      var cosine = Math.cos(radians);
      var sine = Math.sin(radians);
      var deltaX = x - centerX;
      var deltaY = y - centerY;
      return {
        x: centerX + deltaX * cosine - deltaY * sine,
        y: centerY + deltaX * sine + deltaY * cosine,
      };
    }

    function clampRelativeDesignPoint(x, y, width, height, shape) {
      if (
        personalizationGeometry &&
        typeof personalizationGeometry.clampRelativeGeometryPoint === "function"
      ) {
        return personalizationGeometry.clampRelativeGeometryPoint(
          x,
          y,
          width,
          height,
          shape,
        );
      }
      var radiusX = Math.max(0, (100 - width) / 2);
      var radiusY = Math.max(0, (100 - height) / 2);
      var localX = Number(x || 50) - 50;
      var localY = Number(y || 50) - 50;
      if (shape === "ellipse" && radiusX > 0 && radiusY > 0) {
        var distance = Math.sqrt(
          (localX * localX) / (radiusX * radiusX) +
            (localY * localY) / (radiusY * radiusY),
        );
        if (distance > 1) {
          localX /= distance;
          localY /= distance;
        }
      } else {
        localX = clampFreeformNumber(localX, -radiusX, radiusX);
        localY = clampFreeformNumber(localY, -radiusY, radiusY);
      }
      return { x: 50 + localX, y: 50 + localY };
    }

    function clampAbsoluteDesignPoint(x, y, width, height, area) {
      if (
        personalizationGeometry &&
        typeof personalizationGeometry.clampGeometryLayout === "function"
      ) {
        var clampedLayout = personalizationGeometry.clampGeometryLayout(
          {
            x: x,
            y: y,
            width: width,
            height: height,
            rotation: 0,
          },
          area,
        );
        return { x: clampedLayout.x, y: clampedLayout.y };
      }
      var local = rotateDesignPoint(
        x,
        y,
        area.x,
        area.y,
        -Number(area.rotation || 0),
      );
      var relative = clampRelativeDesignPoint(
        50 + ((local.x - area.x) / Math.max(area.width, 1)) * 100,
        50 + ((local.y - area.y) / Math.max(area.height, 1)) * 100,
        (width / Math.max(area.width, 1)) * 100,
        (height / Math.max(area.height, 1)) * 100,
        area.shape,
      );
      var clampedLocalX = area.x + ((relative.x - 50) / 100) * area.width;
      var clampedLocalY = area.y + ((relative.y - 50) / 100) * area.height;
      return rotateDesignPoint(
        clampedLocalX,
        clampedLocalY,
        area.x,
        area.y,
        Number(area.rotation || 0),
      );
    }

    function getFreeformRelativeSize(item) {
      var geometryKind =
        item.kind === "clipart"
          ? "image"
          : item.kind === "shape"
            ? "symbol"
            : item.kind;
      var relativeSize;
      if (
        personalizationGeometry &&
        typeof personalizationGeometry.getFreeformRelativeGeometrySize ===
          "function"
      ) {
        relativeSize = personalizationGeometry.getFreeformRelativeGeometrySize(
          geometryKind,
          item.scale,
          customerDesignSettings.allowTextLineBreaks === true,
        );
      } else {
        var requestedScale = clampFreeformNumber(item.scale, 25, 250) / 100;
        var baseWidth =
          geometryKind === "text" ? 56 : geometryKind === "image" ? 36 : 18;
        var baseHeight =
          geometryKind === "text"
            ? customerDesignSettings.allowTextLineBreaks
              ? 44
              : 24
            : geometryKind === "image"
              ? 36
              : 18;
        var effectiveScale = Math.min(
          requestedScale,
          96 / baseWidth,
          96 / baseHeight,
        );
        relativeSize = {
          width: baseWidth * effectiveScale,
          height: baseHeight * effectiveScale,
          scale: effectiveScale,
        };
      }

      if (geometryKind === "image") {
        relativeSize = Object.assign({}, relativeSize, {
          width: Math.min(
            96,
            relativeSize.width *
              (clampFreeformNumber(item.widthScale ?? 100, 25, 250) / 100),
          ),
          height: Math.min(
            96,
            relativeSize.height *
              (clampFreeformNumber(item.heightScale ?? 100, 25, 250) / 100),
          ),
        });
      }

      return relativeSize;
    }

    function getFreeformLayout(item) {
      var area = getFreeformDesignArea(item.surfaceId);
      var geometryKind =
        item.kind === "clipart"
          ? "image"
          : item.kind === "shape"
            ? "symbol"
            : item.kind;
      var usesFreeImageProportions =
        geometryKind === "image" &&
        (Math.abs(Number(item.widthScale ?? 100) - 100) > 0.01 ||
          Math.abs(Number(item.heightScale ?? 100) - 100) > 0.01);
      if (
        !usesFreeImageProportions &&
        personalizationGeometry &&
        typeof personalizationGeometry.getFreeformLayoutGeometry === "function"
      ) {
        var geometryLayout = personalizationGeometry.getFreeformLayoutGeometry({
          kind: geometryKind,
          x: item.x,
          y: item.y,
          scalePercent: item.scale,
          rotation: Number(item.rotation || 0),
          allowTextLineBreaks:
            customerDesignSettings.allowTextLineBreaks === true,
          surface: area,
        });
        item.x = geometryLayout.relativeX;
        item.y = geometryLayout.relativeY;

        return {
          x: geometryLayout.x,
          y: geometryLayout.y,
          width: geometryLayout.width,
          height: geometryLayout.height,
          rotation: geometryLayout.rotation,
          fontSizeMm: geometryLayout.fontSizeMm,
          align: "center",
          boundaryShape: "rectangle",
          autoFitText: true,
          allowLineBreaks:
            geometryKind === "text" &&
            customerDesignSettings.allowTextLineBreaks === true,
          surfaceMode: "flat",
          surfaceIntensity: 0,
        };
      }
      var relativeSize = getFreeformRelativeSize(
        Object.assign({}, item, { kind: geometryKind }),
      );
      var relativePoint = clampRelativeDesignPoint(
        item.x,
        item.y,
        relativeSize.width,
        relativeSize.height,
        area.shape,
      );
      var relativeX = relativePoint.x;
      var relativeY = relativePoint.y;

      item.x = relativeX;
      item.y = relativeY;

      var unrotatedX = area.x - area.width / 2 + (relativeX / 100) * area.width;
      var unrotatedY =
        area.y - area.height / 2 + (relativeY / 100) * area.height;
      var rotatedCenter = rotateDesignPoint(
        unrotatedX,
        unrotatedY,
        area.x,
        area.y,
        area.rotation,
      );

      return {
        x: Number(rotatedCenter.x.toFixed(2)),
        y: Number(rotatedCenter.y.toFixed(2)),
        width: Number(((relativeSize.width / 100) * area.width).toFixed(2)),
        height: Number(((relativeSize.height / 100) * area.height).toFixed(2)),
        rotation: Number(
          clampFreeformNumber(
            Number(item.rotation || 0) + Number(area.rotation || 0),
            -180,
            180,
          ).toFixed(2),
        ),
        fontSizeMm: Number(
          (
            (geometryKind === "text" ? 8 : geometryKind === "image" ? 1 : 10) *
            relativeSize.scale
          ).toFixed(2),
        ),
        align: "center",
        boundaryShape: "rectangle",
        autoFitText: true,
        allowLineBreaks:
          geometryKind === "text" &&
          customerDesignSettings.allowTextLineBreaks === true,
        surfaceMode: "flat",
        surfaceIntensity: 0,
      };
    }

    function getChargeableFreeformCounts() {
      if (!isPersonalizationEnabled()) {
        return { text: 0, image: 0, symbol: 0, shape: 0 };
      }
      var activeTexts = freeformItems.filter(function (item) {
        return item.kind === "text" && String(item.text || "").trim();
      }).length;
      var activeSymbols = freeformItems.filter(function (item) {
        return item.kind === "symbol";
      }).length;
      var activeShapes = freeformItems.filter(function (item) {
        return item.kind === "shape";
      }).length;
      var activeImages = freeformItems.filter(function (item) {
        return item.kind === "image" && Boolean(item.fileName);
      }).length;

      return {
        text: Math.max(
          0,
          activeTexts -
            Number(customerDesignSettings.includedTextElements || 0),
        ),
        image: Math.max(
          0,
          activeImages -
            Number(customerDesignSettings.includedImageElements || 0),
        ),
        symbol: Math.max(
          0,
          activeSymbols -
            Number(customerDesignSettings.includedSymbolElements || 0),
        ),
        shape: Math.max(
          0,
          activeShapes -
            Number(customerDesignSettings.includedShapeElements || 0),
        ),
      };
    }

    function getFreeformItemPrice(item) {
      if (item.kind === "clipart") {
        return Math.max(0, Number(item.priceAdjustment || 0));
      }
      var sameKindItems = freeformItems.filter(function (candidate) {
        return (
          candidate.kind === item.kind &&
          (candidate.kind === "text"
            ? String(candidate.text || "").trim()
            : candidate.kind === "image"
              ? Boolean(candidate.fileName)
              : true)
        );
      });
      var itemIndex = sameKindItems.indexOf(item);
      var included = Number(
        item.kind === "text"
          ? customerDesignSettings.includedTextElements || 0
          : item.kind === "image"
            ? customerDesignSettings.includedImageElements || 0
            : item.kind === "shape"
              ? customerDesignSettings.includedShapeElements || 0
              : customerDesignSettings.includedSymbolElements || 0,
      );

      if (itemIndex < included) return 0;
      return Number(
        item.kind === "text"
          ? customerDesignSettings.extraTextPrice || 0
          : item.kind === "image"
            ? customerDesignSettings.extraImagePrice || 0
            : item.kind === "shape"
              ? customerDesignSettings.extraShapePrice || 0
              : customerDesignSettings.extraSymbolPrice || 0,
      );
    }

    function formatStorefrontMoney(cents) {
      var currency = widget.dataset.currency || "EUR";
      try {
        return new Intl.NumberFormat(document.documentElement.lang || "de-DE", {
          style: "currency",
          currency: currency,
        })
          .format(Number(cents || 0) / 100)
          .replace(/\s(?=[^\d\s]+$)/, "\u00a0");
      } catch (error) {
        return (
          (Number(cents || 0) / 100).toFixed(2).replace(".", ",") + "\u00a0€"
        );
      }
    }

    function updateFreeformPrice() {
      var counts = getChargeableFreeformCounts();
      var price = freeformItems.reduce(function (total, item) {
        return total + getFreeformItemPrice(item);
      }, 0);
      var priceBox = widget.querySelector("[data-freeform-price]");
      var priceValue = widget.querySelector("[data-freeform-price-value]");
      var priceInput = widget.querySelector("[data-freeform-price-input]");
      var warning = widget.querySelector("[data-freeform-price-warning]");
      var totalValue = widget.querySelector("[data-freeform-total-value]");
      var missingVariant =
        (counts.text > 0 &&
          Number(customerDesignSettings.extraTextPrice || 0) > 0 &&
          !customerDesignSettings.extraTextVariantId) ||
        (counts.image > 0 &&
          Number(customerDesignSettings.extraImagePrice || 0) > 0 &&
          !customerDesignSettings.extraImageVariantId) ||
        (counts.symbol > 0 &&
          Number(customerDesignSettings.extraSymbolPrice || 0) > 0 &&
          !customerDesignSettings.extraSymbolVariantId) ||
        (counts.shape > 0 &&
          Number(customerDesignSettings.extraShapePrice || 0) > 0 &&
          !customerDesignSettings.extraShapeVariantId) ||
        freeformItems.some(function (item) {
          return (
            item.kind === "clipart" &&
            Number(item.priceAdjustment || 0) > 0 &&
            !item.shopifyVariantId
          );
        });
      var formatted = formatStorefrontMoney(Math.round(price * 100));

      if (priceBox) priceBox.hidden = !(price > 0);
      if (priceValue) priceValue.textContent = "+" + formatted;
      if (priceInput) {
        priceInput.value = formatted;
        priceInput.disabled = !(price > 0);
        connectFreeformControl(priceInput);
      }
      if (warning) {
        warning.hidden = !missingVariant;
        if (missingVariant) {
          warning.textContent =
            "Der Aufpreis wurde noch nicht mit einer passenden Shopify-Aufpreisvariante verbunden.";
        }
      }
      if (totalValue) {
        totalValue.textContent = formatStorefrontMoney(
          Number(widget.dataset.basePriceCents || 0) + Math.round(price * 100),
        );
      }
    }

    function getStorefrontFontSizePx(layout, target, surfaceId) {
      var targetStage = target
        ? target.closest(".personalize-pilot-main-preview") ||
          target.parentElement
        : null;
      var targetStageRect =
        targetStage && targetStage.getBoundingClientRect
          ? targetStage.getBoundingClientRect()
          : null;
      var overlayRect =
        mainImagePreview &&
        mainImagePreview.overlay &&
        mainImagePreview.overlay.getBoundingClientRect
          ? mainImagePreview.overlay.getBoundingClientRect()
          : null;
      var stageWidth =
        targetStageRect && targetStageRect.width > 40
          ? targetStageRect.width
          : overlayRect && overlayRect.width > 40
            ? overlayRect.width
            : 0;
      var productionWidthMm = Number(widget.dataset.previewWidthMm || 100);
      var configuredFontSizeMm = Number(layout.fontSizeMm || 8);
      var autoFitText =
        layout.autoFitText !== false &&
        (!target || target.dataset.autoFitText !== "false");
      var effectiveFontSizeMm = Math.min(
        80,
        Math.max(0.1, configuredFontSizeMm) * (autoFitText ? 2 : 1),
      );
      var configuredSurface = getConfiguredSurface(
        surfaceId ||
          (target && target.dataset.personalizationSurface) ||
          activeSurfaceId,
      );
      var surfaceWidthMm = Number(
        configuredSurface && configuredSurface.widthMm,
      );
      if (Number.isFinite(surfaceWidthMm) && surfaceWidthMm > 0) {
        productionWidthMm = surfaceWidthMm;
      }
      var surfaceWidthPercent = Number(
        getConfiguredSurfaceArea(
          surfaceId ||
            (target && target.dataset.personalizationSurface) ||
            activeSurfaceId,
        ).width || 100,
      );
      if (
        stageWidth > 0 &&
        Number.isFinite(productionWidthMm) &&
        productionWidthMm > 0
      ) {
        return Math.max(
          6,
          (effectiveFontSizeMm / productionWidthMm) *
            stageWidth *
            (Math.max(0.5, Math.min(100, surfaceWidthPercent)) / 100),
        );
      }
      return Math.max(6, effectiveFontSizeMm * 2.7);
    }

    function getGuidedTextCurvePath(curve) {
      var normalized = Math.max(-100, Math.min(100, Number(curve || 0)));
      var eased =
        (normalized < 0 ? -1 : 1) * Math.pow(Math.abs(normalized) / 100, 0.82);
      var controlY = Number((22 - eased * 18).toFixed(3));

      return "M 4 22 Q 50 " + controlY + " 96 22";
    }

    function updateGuidedCurvedTextSvg(svg, target, value, curve) {
      if (!svg || !target) return;
      var computed = window.getComputedStyle
        ? window.getComputedStyle(target)
        : null;
      var path = svg.querySelector("path");
      var textNode = svg.querySelector("text");
      var textPath = svg.querySelector("textPath");

      svg.setAttribute("viewBox", "0 0 100 44");
      svg.setAttribute("preserveAspectRatio", "xMidYMid meet");
      if (path) path.setAttribute("d", getGuidedTextCurvePath(curve));
      if (textNode) {
        textNode.style.fontFamily =
          (computed && computed.fontFamily) ||
          target.style.fontFamily ||
          "inherit";
        textNode.style.fontWeight =
          (computed && computed.fontWeight) || target.style.fontWeight || "700";
        textNode.style.fill = "currentColor";
        textNode.style.textRendering = "geometricPrecision";
      }
      if (textPath) textPath.textContent = value || "Dein Text";
    }

    function updateCurvedTextSvg(svg, target, value, curve, letterSpacing) {
      if (!svg || !target) return;

      var targetRect = target.getBoundingClientRect
        ? target.getBoundingClientRect()
        : null;
      var width = Math.max(
        40,
        Math.round(
          (targetRect && targetRect.width) || target.clientWidth || 160,
        ),
      );
      var height = Math.max(
        24,
        Math.round(
          (targetRect && targetRect.height) || target.clientHeight || 44,
        ),
      );
      var computed = window.getComputedStyle
        ? window.getComputedStyle(target)
        : null;
      var fontSize = Math.max(
        6,
        parseFloat(
          (computed && computed.fontSize) || target.style.fontSize || "16",
        ) || 16,
      );
      var normalizedCurve = getEasedCurveStrength(curve);
      var availableHeight = Math.max(4, height - fontSize * 0.9);
      var amplitude =
        normalizedCurve *
        Math.min(Math.max(height * 0.34, availableHeight * 0.7), width * 0.16);
      var centerBaseline = height / 2 + fontSize * 0.2;
      var endpointY = centerBaseline + amplitude * 0.5;
      var controlY = centerBaseline - amplitude * 1.5;
      var horizontalPadding = Math.max(
        2,
        Math.min(width * 0.08, fontSize * 0.35),
      );
      var path = svg.querySelector("path");
      var textNode = svg.querySelector("text");
      var textPath = svg.querySelector("textPath");

      svg.setAttribute("viewBox", "0 0 " + width + " " + height);
      svg.setAttribute("preserveAspectRatio", "xMidYMid meet");
      if (path) {
        path.setAttribute(
          "d",
          "M " +
            horizontalPadding.toFixed(2) +
            " " +
            endpointY.toFixed(2) +
            " Q " +
            (width / 2).toFixed(2) +
            " " +
            controlY.toFixed(2) +
            " " +
            (width - horizontalPadding).toFixed(2) +
            " " +
            endpointY.toFixed(2),
        );
      }
      if (textNode) {
        textNode.style.fontFamily =
          (computed && computed.fontFamily) ||
          target.style.fontFamily ||
          "inherit";
        textNode.style.fontWeight =
          (computed && computed.fontWeight) || target.style.fontWeight || "700";
        textNode.style.fontSize = fontSize + "px";
        textNode.style.fill = "currentColor";
        textNode.style.textRendering = "geometricPrecision";
      }
      if (textPath) {
        textPath.textContent = value || "Dein Text";
        textPath.style.letterSpacing =
          clampFreeformNumber(Number(letterSpacing || 0), 0, 12) + "px";
      }
    }

    function applyFreeformVisualEffects(target, item) {
      if (!target) return;
      target.style.zIndex = String(Number(item.zIndex || item.sequence || 1));
      target.style.opacity = String(
        clampFreeformNumber(Number(item.opacity ?? 100), 10, 100) / 100,
      );

      if (item.kind === "image" || item.kind === "clipart") {
        var image = target.querySelector("img");
        if (image) {
          image.style.filter =
            "brightness(" +
            clampFreeformNumber(Number(item.brightness ?? 100), 0, 200) +
            "%) contrast(" +
            clampFreeformNumber(Number(item.contrast ?? 100), 0, 200) +
            "%) saturate(" +
            clampFreeformNumber(Number(item.saturation ?? 100), 0, 200) +
            "%) grayscale(" +
            clampFreeformNumber(Number(item.grayscale ?? 0), 0, 100) +
            "%)";
          image.style.transform =
            "scale(" +
            (item.flipX ? -1 : 1) +
            ", " +
            (item.flipY ? -1 : 1) +
            ")";
          image.style.clipPath =
            item.imageMask === "ellipse"
              ? "ellipse(50% 50% at 50% 50%)"
              : item.imageMask === "rounded"
                ? "inset(0 round 14%)"
                : item.imageMask === "rectangle"
                  ? "inset(0)"
                  : "none";
        }
      }

      if (item.kind === "shape") {
        var shape = target.querySelector("[data-freeform-shape]");
        if (shape) {
          shape.setAttribute(
            "fill",
            item.shapeType === "line" ? "none" : item.fillColor || "#111111",
          );
          shape.setAttribute(
            "stroke",
            item.strokeColor || item.fillColor || "#111111",
          );
          shape.setAttribute(
            "stroke-width",
            String(clampFreeformNumber(Number(item.strokeWidth || 1), 0.25, 6)),
          );
        }
      }

      if (item.kind === "text") {
        var curve = clampFreeformNumber(Number(item.textCurve || 0), -100, 100);
        var flatText = target.querySelector("[data-freeform-text]");
        var curveSvg = target.querySelector("[data-freeform-curve-svg]");
        if (flatText) flatText.hidden = Math.abs(curve) > 1;
        if (curveSvg) {
          // SVGElement.hidden is only an expando, unlike HTMLElement.hidden.
          // Use the real attribute so the flat and curved renderers are exclusive
          // and cloneNode preserves their visibility in every preview.
          curveSvg.toggleAttribute("hidden", Math.abs(curve) <= 1);
          updateCurvedTextSvg(
            curveSvg,
            target,
            item.text || "Dein Text",
            curve,
            item.letterSpacing,
          );
        }
      }
    }

    function syncFreeformItem(item) {
      var layout = getFreeformLayout(item);
      var target = mainImagePreview.overlay
        ? mainImagePreview.overlay.querySelector(
            '[data-freeform-preview="' + item.id + '"]',
          )
        : null;
      var propertyInput = widget.querySelector(
        '[data-freeform-property="' + item.id + '"]',
      );
      var layoutInput = widget.querySelector(
        '[data-freeform-layout="' + item.id + '"]',
      );
      var value =
        item.kind === "text"
          ? String(item.text || "").trim()
          : item.kind === "image"
            ? item.fileName || ""
            : item.kind === "clipart"
              ? item.clipartName || ""
              : item.kind === "shape"
                ? item.shapeLabel || "Form"
                : item.symbolLabel;

      if (target) {
        target.style.setProperty("--slot-x", layout.x + "%");
        target.style.setProperty("--slot-y", layout.y + "%");
        target.style.setProperty("--slot-width", layout.width + "%");
        target.style.setProperty("--slot-height", layout.height + "%");
        target.style.setProperty("--slot-rotation", layout.rotation + "deg");
        if (item.kind === "text") {
          setResponsiveTextSize(
            target,
            layout,
            item.surfaceId || activeSurfaceId,
          );
        }
        if (fontInput && item.kind === "text") {
          target.style.fontFamily = getPreviewFontFamily(fontInput.value);
          target.style.fontWeight = getPreviewFontWeight(fontInput.value);
        }
        if (colorInputs.length > 0) target.style.color = colorInputs[0].value;
        target.hidden =
          !value ||
          Boolean(item.surfaceId && item.surfaceId !== activeSurfaceId);
        if (item.kind === "text") {
          var textContent = target.querySelector("[data-freeform-text]");
          if (textContent) textContent.textContent = item.text || "Dein Text";
        }
        if (item.kind === "image") {
          target.dataset.imageFit =
            Math.abs(Number(item.widthScale ?? 100) - 100) > 0.01 ||
            Math.abs(Number(item.heightScale ?? 100) - 100) > 0.01
              ? "stretch"
              : "contain";
          applyConfiguredImageFit(target);
          updateImagePreviewTarget(target, item.previewUrl || "");
        }
        applyFreeformVisualEffects(target, item);
      }

      if (propertyInput) {
        propertyInput.value = value || "";
        propertyInput.disabled = !value;
      }
      if (layoutInput) {
        layoutInput.value = JSON.stringify({
          slotId: item.id,
          label:
            item.kind === "text"
              ? "Eigener Text"
              : item.kind === "image"
                ? "Eigenes Bild"
                : item.kind === "clipart"
                  ? item.clipartName
                  : item.kind === "shape"
                    ? item.shapeLabel
                    : item.symbolLabel,
          type:
            item.kind === "text"
              ? "text"
              : item.kind === "image"
                ? "image"
                : "select",
          objectKind: item.kind,
          textValue:
            item.kind === "text" ? String(item.text || "").trim() : undefined,
          selectedValue: item.kind === "symbol" ? item.symbolValue : undefined,
          symbolPath: item.kind === "symbol" ? item.symbolPath : undefined,
          clipartAssetId:
            item.kind === "clipart" ? item.clipartAssetId : undefined,
          clipartImageUrl:
            item.kind === "clipart" ? item.clipartImageUrl : undefined,
          shapeType: item.kind === "shape" ? item.shapeType : undefined,
          fileName: item.kind === "image" ? item.fileName : undefined,
          fileType: item.kind === "image" ? item.fileType : undefined,
          fileSize: item.kind === "image" ? item.fileSize : undefined,
          fileWidthPx: item.kind === "image" ? item.fileWidthPx : undefined,
          fileHeightPx: item.kind === "image" ? item.fileHeightPx : undefined,
          assetId: item.kind === "image" ? item.assetId : undefined,
          imageFit:
            item.kind === "image"
              ? Math.abs(Number(item.widthScale ?? 100) - 100) > 0.01 ||
                Math.abs(Number(item.heightScale ?? 100) - 100) > 0.01
                ? "stretch"
                : "contain"
              : undefined,
          imageScalePercent: item.kind === "image" ? 100 : undefined,
          templateFont:
            item.kind === "text" && fontInput ? fontInput.value : undefined,
          templateTextColor:
            colorInputs.length > 0 ? colorInputs[0].value : undefined,
          priceAdjustment: getFreeformItemPrice(item),
          fillColor: item.fillColor,
          strokeColor: item.strokeColor,
          strokeWidth: item.strokeWidth,
          opacity: item.opacity,
          zIndex: item.zIndex,
          imageMask: item.imageMask,
          brightness: item.brightness,
          contrast: item.contrast,
          saturation: item.saturation,
          grayscale: item.grayscale,
          flipX: item.flipX === true,
          flipY: item.flipY === true,
          textCurve: item.textCurve,
          letterSpacing: item.letterSpacing,
          layout: layout,
          productionMode: customerDesignSettings.productionMode || "engrave",
          surfaceId: item.surfaceId || "front",
          customerAdded: true,
        });
        layoutInput.disabled = !value;
      }

      updateFreeformPrice();
      refreshMainImageMode();
      if (target && item.kind === "text" && !target.hidden) {
        target.style.fontSize =
          getAutoFitFontSize(widget, item.text || "Dein Text", target) + "px";
        renderWarpedTextTarget(target, item.text || "Dein Text");
        applyFreeformVisualEffects(target, item);
      }
      if (!mainImagePreview.overlay || !mainImagePreview.overlay.isConnected) {
        scheduleMainImagePreviewRefresh();
      }
      updateFreeformSelection();
    }

    function attachFreeformDrag(target, item) {
      if (!mainImagePreview.overlay) return;

      var canMove = customerDesignSettings.allowMove === true;
      var canEdit =
        canMove ||
        customerDesignSettings.allowResize === true ||
        customerDesignSettings.allowRotate === true;
      if (!canEdit) return;

      target.classList.add("is-customer-editable");
      target.tabIndex = 0;
      target.setAttribute("role", "button");
      target.setAttribute(
        "aria-label",
        (item.kind === "text"
          ? "Text"
          : item.kind === "image"
            ? "Bild"
            : item.kind === "clipart"
              ? item.clipartName || "Motiv"
              : item.kind === "shape"
                ? item.shapeLabel || "Form"
                : item.symbolLabel || "Symbol") +
          " auswählen. Pfeiltasten verschieben, Löschtaste entfernt das Element.",
      );
      target.addEventListener("click", function () {
        selectFreeformItem(item.id, false);
      });
      target.addEventListener("focus", function () {
        selectFreeformItem(item.id, false);
      });
      target.addEventListener("keydown", function (event) {
        if (event.target !== target) return;
        if (event.key === "Delete" || event.key === "Backspace") {
          event.preventDefault();
          rememberFreeformState();
          freeformItems = freeformItems.filter(function (candidate) {
            return candidate.id !== item.id;
          });
          selectedFreeformItemId = "";
          renderFreeformEditor();
          return;
        }
        if (
          !canMove ||
          ["ArrowLeft", "ArrowRight", "ArrowUp", "ArrowDown"].indexOf(
            event.key,
          ) < 0
        ) {
          return;
        }

        event.preventDefault();
        rememberFreeformState();
        var step = event.shiftKey ? 5 : 1;
        if (event.key === "ArrowLeft") item.x -= step;
        if (event.key === "ArrowRight") item.x += step;
        if (event.key === "ArrowUp") item.y -= step;
        if (event.key === "ArrowDown") item.y += step;
        var relativeSize = getFreeformRelativeSize(item);
        var area = getFreeformDesignArea(item.surfaceId);
        var clampedPoint = clampRelativeDesignPoint(
          item.x,
          item.y,
          relativeSize.width,
          relativeSize.height,
          area.shape,
        );
        item.x = clampedPoint.x;
        item.y = clampedPoint.y;
        syncFreeformControls(item);
        syncFreeformItem(item);
      });

      if (!canMove) return;

      target.addEventListener("pointerdown", function (event) {
        if (event.target !== target && event.target.closest("button")) return;
        var overlayRect = mainImagePreview.overlay.getBoundingClientRect();
        var designArea = getFreeformDesignArea(item.surfaceId);
        var relativeSize = getFreeformRelativeSize(item);
        var startX = event.clientX;
        var startY = event.clientY;
        var originalX = item.x;
        var originalY = item.y;

        selectFreeformItem(item.id, false);
        rememberFreeformState();
        beginCustomerPointerDrag(event, target, function (moveEvent) {
          var deltaX =
            ((moveEvent.clientX - startX) / Math.max(1, overlayRect.width)) *
            100;
          var deltaY =
            ((moveEvent.clientY - startY) / Math.max(1, overlayRect.height)) *
            100;
          var radians = (-Number(designArea.rotation || 0) * Math.PI) / 180;
          var localDeltaX =
            deltaX * Math.cos(radians) - deltaY * Math.sin(radians);
          var localDeltaY =
            deltaX * Math.sin(radians) + deltaY * Math.cos(radians);
          item.x =
            originalX + localDeltaX * (100 / Math.max(1, designArea.width));
          item.y =
            originalY + localDeltaY * (100 / Math.max(1, designArea.height));
          var clampedPoint = clampRelativeDesignPoint(
            item.x,
            item.y,
            relativeSize.width,
            relativeSize.height,
            designArea.shape,
          );
          item.x = clampedPoint.x;
          item.y = clampedPoint.y;
          if (customerDesignSettings.allowAdvancedAlignment !== false) {
            if (Math.abs(item.x - 50) <= 2) item.x = 50;
            if (Math.abs(item.y - 50) <= 2) item.y = 50;
            freeformItems.forEach(function (candidate) {
              if (
                candidate.id === item.id ||
                candidate.surfaceId !== item.surfaceId
              )
                return;
              if (Math.abs(item.x - candidate.x) <= 1.5) item.x = candidate.x;
              if (Math.abs(item.y - candidate.y) <= 1.5) item.y = candidate.y;
            });
          }
          syncFreeformControls(item);
          syncFreeformItem(item);
        });
      });
    }

    function syncFreeformControls(item) {
      ["x", "y", "scale", "widthScale", "heightScale", "rotation"].forEach(
        function (key) {
          var control = widget.querySelector(
            '[data-freeform-control="' + item.id + "-" + key + '"]',
          );
          if (control)
            control.value = String(Math.round(Number(item[key]) || 0));
        },
      );
    }

    function normalizeFreeformRotation(value) {
      var normalized = Number(value || 0);
      while (normalized > 180) normalized -= 360;
      while (normalized < -180) normalized += 360;
      return normalized;
    }

    function attachFreeformTransformHandles(target, item) {
      if (!mainImagePreview.overlay) return;

      if (customerDesignSettings.allowResize === true) {
        var resizeHandle = document.createElement("button");
        resizeHandle.type = "button";
        resizeHandle.className =
          "personalize-pilot-widget__freeform-handle personalize-pilot-widget__freeform-handle--resize";
        resizeHandle.textContent = "↗";
        resizeHandle.title = "Größe ändern";
        resizeHandle.setAttribute("aria-label", "Elementgröße ändern");
        resizeHandle.addEventListener("pointerdown", function (event) {
          var targetRect = target.getBoundingClientRect();
          var centerX = targetRect.left + targetRect.width / 2;
          var centerY = targetRect.top + targetRect.height / 2;
          var startDistance = Math.max(
            1,
            Math.hypot(event.clientX - centerX, event.clientY - centerY),
          );
          var originalScale = Number(item.scale || 100);
          var minimum = Number(customerDesignSettings.minScalePercent || 40);
          var maximum = Number(customerDesignSettings.maxScalePercent || 160);

          selectFreeformItem(item.id, false);
          rememberFreeformState();
          beginCustomerPointerDrag(event, resizeHandle, function (moveEvent) {
            var distance = Math.max(
              1,
              Math.hypot(
                moveEvent.clientX - centerX,
                moveEvent.clientY - centerY,
              ),
            );
            item.scale = clampFreeformNumber(
              originalScale * (distance / startDistance),
              minimum,
              maximum,
            );
            syncFreeformControls(item);
            syncFreeformItem(item);
          });
        });
        target.appendChild(resizeHandle);
      }

      if (customerDesignSettings.allowRotate === true) {
        var rotateHandle = document.createElement("button");
        rotateHandle.type = "button";
        rotateHandle.className =
          "personalize-pilot-widget__freeform-handle personalize-pilot-widget__freeform-handle--rotate";
        rotateHandle.textContent = "↻";
        rotateHandle.title = "Element drehen";
        rotateHandle.setAttribute("aria-label", "Element drehen");
        rotateHandle.addEventListener("pointerdown", function (event) {
          var targetRect = target.getBoundingClientRect();
          var centerX = targetRect.left + targetRect.width / 2;
          var centerY = targetRect.top + targetRect.height / 2;
          var startAngle = Math.atan2(
            event.clientY - centerY,
            event.clientX - centerX,
          );
          var originalRotation = Number(item.rotation || 0);

          selectFreeformItem(item.id, false);
          rememberFreeformState();
          beginCustomerPointerDrag(event, rotateHandle, function (moveEvent) {
            var currentAngle = Math.atan2(
              moveEvent.clientY - centerY,
              moveEvent.clientX - centerX,
            );
            item.rotation = normalizeFreeformRotation(
              originalRotation + ((currentAngle - startAngle) * 180) / Math.PI,
            );
            syncFreeformControls(item);
            syncFreeformItem(item);
          });
        });
        target.appendChild(rotateHandle);
      }
    }

    function createFreeformPreviewTarget(item) {
      var target = document.createElement("div");
      target.className =
        "personalize-pilot-widget__preview-item personalize-pilot-main-preview__item " +
        (item.kind === "text"
          ? "personalize-pilot-widget__preview-item--text"
          : "personalize-pilot-widget__preview-item--image" +
            (item.kind === "symbol"
              ? " personalize-pilot-widget__freeform-symbol"
              : item.kind === "shape"
                ? " personalize-pilot-widget__freeform-shape"
                : item.kind === "clipart"
                  ? " personalize-pilot-widget__freeform-clipart"
                  : " personalize-pilot-widget__freeform-image"));
      target.dataset.freeformPreview = item.id;
      target.dataset.personalizationSurface = item.surfaceId || "front";
      target.dataset.allowLineBreaks =
        item.kind === "text" &&
        customerDesignSettings.allowTextLineBreaks === true
          ? "true"
          : "false";
      target.dataset.autoFitText = "true";

      if (item.kind === "text") {
        var textContent = document.createElement("span");
        textContent.dataset.freeformText = "true";
        textContent.textContent = item.text || "Dein Text";
        target.appendChild(textContent);
        var curveSvg = document.createElementNS(
          "http://www.w3.org/2000/svg",
          "svg",
        );
        var curvePath = document.createElementNS(
          "http://www.w3.org/2000/svg",
          "path",
        );
        var curveText = document.createElementNS(
          "http://www.w3.org/2000/svg",
          "text",
        );
        var curveTextPath = document.createElementNS(
          "http://www.w3.org/2000/svg",
          "textPath",
        );
        var curvePathId =
          "personalize-curve-" + item.id.replace(/[^a-z0-9_-]/gi, "-");
        curveSvg.setAttribute("viewBox", "0 0 100 44");
        curveSvg.setAttribute("preserveAspectRatio", "xMidYMid meet");
        curveSvg.dataset.freeformCurveSvg = "true";
        curveSvg.setAttribute("hidden", "");
        curvePath.id = curvePathId;
        curvePath.setAttribute("d", "M 4 22 Q 50 22 96 22");
        curvePath.setAttribute("fill", "none");
        curvePath.setAttribute("stroke", "none");
        curveTextPath.setAttribute("href", "#" + curvePathId);
        curveTextPath.setAttribute("startOffset", "50%");
        curveTextPath.setAttribute("text-anchor", "middle");
        curveTextPath.textContent = item.text || "Dein Text";
        curveText.appendChild(curveTextPath);
        curveSvg.appendChild(curvePath);
        curveSvg.appendChild(curveText);
        target.appendChild(curveSvg);
      } else if (item.kind === "symbol") {
        var svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
        var path = document.createElementNS(
          "http://www.w3.org/2000/svg",
          "path",
        );
        svg.setAttribute("viewBox", "0 0 24 24");
        svg.setAttribute("width", "100%");
        svg.setAttribute("height", "100%");
        path.setAttribute("d", item.symbolPath);
        path.setAttribute("fill", "currentColor");
        svg.appendChild(path);
        target.appendChild(svg);
      } else if (item.kind === "image") {
        var image = document.createElement("img");
        var imageLabel = document.createElement("span");
        image.alt = "";
        image.hidden = true;
        imageLabel.textContent = "Bild";
        target.dataset.imageFit = "contain";
        target.dataset.imageScalePercent = "100";
        target.appendChild(image);
        target.appendChild(imageLabel);
      } else if (item.kind === "clipart") {
        var clipartImage = document.createElement("img");
        clipartImage.alt = "";
        clipartImage.src = item.clipartImageUrl || "";
        clipartImage.decoding = "async";
        target.dataset.imageFit = "contain";
        target.appendChild(clipartImage);
      } else if (item.kind === "shape") {
        var shapeSvg = document.createElementNS(
          "http://www.w3.org/2000/svg",
          "svg",
        );
        var shapeNode;
        shapeSvg.setAttribute("viewBox", "0 0 24 24");
        shapeSvg.setAttribute("width", "100%");
        shapeSvg.setAttribute("height", "100%");
        if (item.shapeType === "ellipse") {
          shapeNode = document.createElementNS(
            "http://www.w3.org/2000/svg",
            "ellipse",
          );
          shapeNode.setAttribute("cx", "12");
          shapeNode.setAttribute("cy", "12");
          shapeNode.setAttribute("rx", "9");
          shapeNode.setAttribute("ry", "8");
        } else if (item.shapeType === "line") {
          shapeNode = document.createElementNS(
            "http://www.w3.org/2000/svg",
            "line",
          );
          shapeNode.setAttribute("x1", "3");
          shapeNode.setAttribute("y1", "12");
          shapeNode.setAttribute("x2", "21");
          shapeNode.setAttribute("y2", "12");
          shapeNode.setAttribute("stroke-linecap", "round");
        } else if (item.shapeType === "triangle") {
          shapeNode = document.createElementNS(
            "http://www.w3.org/2000/svg",
            "path",
          );
          shapeNode.setAttribute("d", "M12 3 22 21H2Z");
        } else if (item.shapeType === "star") {
          shapeNode = document.createElementNS(
            "http://www.w3.org/2000/svg",
            "path",
          );
          shapeNode.setAttribute(
            "d",
            "m12 2.2 2.95 5.98 6.6.96-4.78 4.66 1.13 6.58L12 17.27l-5.9 3.11 1.13-6.58-4.78-4.66 6.6-.96L12 2.2Z",
          );
        } else if (item.shapeType === "heart") {
          shapeNode = document.createElementNS(
            "http://www.w3.org/2000/svg",
            "path",
          );
          shapeNode.setAttribute(
            "d",
            "M12 21s-7.2-4.35-9.6-8.34C.46 9.64 1.28 5.5 4.8 4.18 7.02 3.35 9.2 4.2 12 7c2.8-2.8 4.98-3.65 7.2-2.82 3.52 1.32 4.34 5.46 2.4 8.48C19.2 16.65 12 21 12 21Z",
          );
        } else {
          shapeNode = document.createElementNS(
            "http://www.w3.org/2000/svg",
            "rect",
          );
          shapeNode.setAttribute("x", "3");
          shapeNode.setAttribute("y", "4");
          shapeNode.setAttribute("width", "18");
          shapeNode.setAttribute("height", "16");
          shapeNode.setAttribute("rx", "1");
        }
        shapeNode.dataset.freeformShape = "true";
        shapeSvg.appendChild(shapeNode);
        target.appendChild(shapeSvg);
      }

      attachFreeformTransformHandles(target, item);
      attachFreeformDrag(target, item);
      return target;
    }

    function ensureFreeformBoundary() {
      if (!mainImagePreview.overlay || customerDesignSettings.enabled === false)
        return;
      var area = getFreeformDesignArea(activeSurfaceId);
      var boundary = mainImagePreview.overlay.querySelector(
        "[data-freeform-design-area]",
      );
      if (!boundary) {
        boundary = document.createElement("div");
        boundary.className = "personalize-pilot-main-preview__design-area";
        boundary.dataset.freeformDesignArea = "true";
        boundary.setAttribute("aria-hidden", "true");
        mainImagePreview.overlay.appendChild(boundary);
      }
      boundary.style.left = area.x + "%";
      boundary.style.top = area.y + "%";
      boundary.style.width = area.width + "%";
      boundary.style.height = area.height + "%";
      boundary.style.transform =
        "translate(-50%, -50%) rotate(" + area.rotation + "deg)";
      boundary.style.borderRadius = area.shape === "ellipse" ? "50%" : "4px";
    }

    function refreshFreeformPreviewTargets() {
      if (!mainImagePreview.overlay) return;
      ensureFreeformBoundary();
      mainImagePreview.overlay
        .querySelectorAll("[data-freeform-preview]")
        .forEach(function (target) {
          target.remove();
        });
      freeformItems.forEach(function (item) {
        mainImagePreview.overlay.appendChild(createFreeformPreviewTarget(item));
        syncFreeformItem(item);
      });
    }

    function createFreeformRange(
      card,
      item,
      key,
      label,
      minimum,
      maximum,
      disabled,
    ) {
      if (disabled) return;
      var field = document.createElement("label");
      var caption = document.createElement("span");
      var control = document.createElement("input");
      caption.textContent = label;
      control.type = "range";
      control.min = String(minimum);
      control.max = String(maximum);
      control.step = "1";
      control.value = String(Math.round(item[key]));
      control.dataset.freeformControl = item.id + "-" + key;
      var historyCaptured = false;
      function captureHistory() {
        if (historyCaptured) return;
        rememberFreeformState();
        historyCaptured = true;
      }
      control.addEventListener("pointerdown", captureHistory);
      control.addEventListener("keydown", function (event) {
        if (
          [
            "ArrowLeft",
            "ArrowRight",
            "ArrowUp",
            "ArrowDown",
            "Home",
            "End",
          ].indexOf(event.key) >= 0
        ) {
          captureHistory();
        }
      });
      control.addEventListener("input", function () {
        captureHistory();
        item[key] = Number(control.value);
        syncFreeformItem(item);
      });
      control.addEventListener("change", function () {
        historyCaptured = false;
      });
      control.addEventListener("blur", function () {
        historyCaptured = false;
      });
      field.appendChild(caption);
      field.appendChild(control);
      card.querySelector("[data-freeform-controls]").appendChild(field);
    }

    function createFreeformSelect(card, item, key, label, options) {
      var field = document.createElement("label");
      var caption = document.createElement("span");
      var control = document.createElement("select");
      caption.textContent = label;
      options.forEach(function (option) {
        var optionNode = document.createElement("option");
        optionNode.value = option.value;
        optionNode.textContent = option.label;
        control.appendChild(optionNode);
      });
      control.value = String(item[key] || options[0].value);
      control.addEventListener("change", function () {
        rememberFreeformState();
        item[key] = control.value;
        syncFreeformItem(item);
      });
      field.appendChild(caption);
      field.appendChild(control);
      card.querySelector("[data-freeform-controls]").appendChild(field);
    }

    function createFreeformColor(card, item, key, label, fallback) {
      var field = document.createElement("label");
      var caption = document.createElement("span");
      var control = document.createElement("input");
      caption.textContent = label;
      control.type = "color";
      control.value = item[key] || fallback;
      control.addEventListener("change", function () {
        rememberFreeformState();
        item[key] = control.value;
        syncFreeformItem(item);
      });
      field.appendChild(caption);
      field.appendChild(control);
      card.querySelector("[data-freeform-controls]").appendChild(field);
    }

    function createFreeformToggle(card, item, key, label) {
      var field = document.createElement("label");
      var control = document.createElement("input");
      var caption = document.createElement("span");
      field.className = "personalize-pilot-widget__freeform-toggle";
      control.type = "checkbox";
      control.checked = item[key] === true;
      caption.textContent = label;
      control.addEventListener("change", function () {
        rememberFreeformState();
        item[key] = control.checked;
        syncFreeformItem(item);
      });
      field.appendChild(control);
      field.appendChild(caption);
      card.querySelector("[data-freeform-controls]").appendChild(field);
    }

    function createFreeformAlignmentTools(card, item) {
      if (customerDesignSettings.allowAdvancedAlignment === false) return;
      var toolbar = document.createElement("div");
      var actions = [
        {
          label: "Links ausrichten",
          text: "←",
          run: function () {
            item.x = 0;
          },
        },
        {
          label: "Horizontal zentrieren",
          text: "↔",
          run: function () {
            item.x = 50;
          },
        },
        {
          label: "Rechts ausrichten",
          text: "→",
          run: function () {
            item.x = 100;
          },
        },
        {
          label: "Oben ausrichten",
          text: "↑",
          run: function () {
            item.y = 0;
          },
        },
        {
          label: "Vertikal zentrieren",
          text: "↕",
          run: function () {
            item.y = 50;
          },
        },
        {
          label: "Unten ausrichten",
          text: "↓",
          run: function () {
            item.y = 100;
          },
        },
        {
          label: "Ebene nach hinten",
          text: "▾",
          run: function () {
            item.zIndex =
              Math.min.apply(
                null,
                freeformItems.map(function (candidate) {
                  return Number(candidate.zIndex || candidate.sequence || 1);
                }),
              ) - 1;
          },
        },
        {
          label: "Ebene nach vorne",
          text: "▴",
          run: function () {
            item.zIndex =
              Math.max.apply(
                null,
                freeformItems.map(function (candidate) {
                  return Number(candidate.zIndex || candidate.sequence || 1);
                }),
              ) + 1;
          },
        },
      ];
      toolbar.className = "personalize-pilot-widget__freeform-align";
      toolbar.setAttribute("role", "toolbar");
      toolbar.setAttribute("aria-label", "Element ausrichten und Ebene ändern");
      actions.forEach(function (action) {
        var button = document.createElement("button");
        button.type = "button";
        button.textContent = action.text;
        button.title = action.label;
        button.setAttribute("aria-label", action.label);
        button.addEventListener("click", function (event) {
          event.stopPropagation();
          rememberFreeformState();
          action.run();
          syncFreeformControls(item);
          syncFreeformItem(item);
          refreshFreeformPreviewTargets();
        });
        toolbar.appendChild(button);
      });
      card.appendChild(toolbar);
    }

    function isCurrentFreeformUpload(item, uploadGeneration) {
      return (
        freeformItems.indexOf(item) >= 0 &&
        item.uploadGeneration === uploadGeneration
      );
    }

    async function handleFreeformImageChange(
      item,
      input,
      statusTarget,
      errorTarget,
    ) {
      var file = input.files && input.files[0];
      if (file || item.fileName || item.assetId) rememberFreeformState();
      var uploadGeneration = String(Number(item.uploadGeneration || 0) + 1);
      item.uploadGeneration = uploadGeneration;

      item.previewUrl = "";
      item.fileName = "";
      item.fileType = "";
      item.fileSize = 0;
      item.fileWidthPx = 0;
      item.fileHeightPx = 0;
      item.assetId = "";
      item.uploadState = "";
      input.setCustomValidity("");
      errorTarget.hidden = true;
      statusTarget.hidden = true;
      syncFreeformItem(item);

      if (!file) return;

      var fileError = getFileError(widget, file, input);
      var imageInspection = { error: "", width: 0, height: 0 };
      if (!fileError) {
        imageInspection = await inspectRasterImage(widget, file, input);
        fileError = imageInspection.error;
      }
      if (!isCurrentFreeformUpload(item, uploadGeneration)) return;
      if (fileError || !String(file.type || "").startsWith("image/")) {
        var invalidMessage =
          fileError ||
          "Bitte lade eine Bilddatei im JPG-, PNG-, WebP-, GIF- oder SVG-Format hoch.";
        errorTarget.textContent = invalidMessage;
        errorTarget.hidden = false;
        input.value = "";
        input.setCustomValidity(invalidMessage);
        return;
      }

      item.fileName = file.name;
      item.fileType = file.type;
      item.fileSize = file.size;
      item.fileWidthPx = imageInspection.width;
      item.fileHeightPx = imageInspection.height;
      try {
        item.previewUrl =
          (await createTransparentWhitePreviewObjectUrl(file)) ||
          URL.createObjectURL(file);
      } catch (error) {
        item.previewUrl = URL.createObjectURL(file);
      }
      if (!isCurrentFreeformUpload(item, uploadGeneration)) {
        URL.revokeObjectURL(item.previewUrl);
        item.previewUrl = "";
        return;
      }
      item.uploadState = "uploading";
      input.setCustomValidity(
        getMessage(
          widget,
          "messageUploadPending",
          "Die Datei wird noch hochgeladen.",
        ),
      );
      statusTarget.textContent = getMessage(
        widget,
        "messageUploadPreparing",
        "Bild wird sicher gespeichert ...",
      );
      statusTarget.hidden = false;
      syncFreeformItem(item);

      try {
        var privateUpload = await uploadFileToPrivateStorage(
          widget,
          file,
          item.fileName,
          input,
        );
        if (!isCurrentFreeformUpload(item, uploadGeneration)) return;
        if (!privateUpload || !privateUpload.assetId) {
          throw new Error(
            "Der sichere Bild-Upload ist momentan nicht erreichbar. Bitte versuche es erneut.",
          );
        }
        item.assetId = privateUpload.assetId;
        item.fileType = privateUpload.mimeType || item.fileType;
        item.fileWidthPx = privateUpload.width || item.fileWidthPx;
        item.fileHeightPx = privateUpload.height || item.fileHeightPx;
        item.uploadState = "ready";
        input.setCustomValidity("");
        statusTarget.textContent = getMessage(
          widget,
          "messageUploadComplete",
          "Bild sicher gespeichert.",
        );
        syncFreeformItem(item);
      } catch (error) {
        if (!isCurrentFreeformUpload(item, uploadGeneration)) return;
        var message =
          error && error.message
            ? error.message
            : getMessage(
                widget,
                "messageUploadFailed",
                "Bild-Upload fehlgeschlagen.",
              );
        item.uploadState = "error";
        input.setCustomValidity(message);
        errorTarget.textContent = message;
        errorTarget.hidden = false;
        statusTarget.hidden = true;
        syncFreeformItem(item);
      }
    }

    function renderFreeformEditor() {
      var editor = widget.querySelector("[data-freeform-editor]");
      var list = widget.querySelector("[data-freeform-list]");
      if (!editor || !list) return;

      list.innerHTML = "";
      if (mainImagePreview.overlay) {
        mainImagePreview.overlay
          .querySelectorAll("[data-freeform-preview]")
          .forEach(function (target) {
            target.remove();
          });
      }

      freeformItems.forEach(function (item) {
        var card = document.createElement("article");
        var top = document.createElement("div");
        var title = document.createElement("strong");
        var remove = document.createElement("button");
        var duplicate = document.createElement("button");
        var propertyInput = document.createElement("input");
        var layoutInput = document.createElement("input");
        var controls = document.createElement("div");
        var target = createFreeformPreviewTarget(item);

        card.className = "personalize-pilot-widget__freeform-item";
        card.dataset.freeformItem = item.id;
        top.className = "personalize-pilot-widget__freeform-item-top";
        title.textContent =
          item.kind === "text"
            ? "Eigener Text"
            : item.kind === "image"
              ? "Eigenes Bild"
              : item.kind === "clipart"
                ? item.clipartName
                : item.kind === "shape"
                  ? item.shapeLabel
                  : item.symbolLabel;
        if (personalizationSurfaces.length > 1) {
          var itemSurface = personalizationSurfaces.find(function (surface) {
            return surface.id === item.surfaceId;
          });
          title.textContent +=
            " · " +
            ((itemSurface && itemSurface.label) ||
              item.surfaceId ||
              "Vorderseite");
        }
        card.hidden = Boolean(
          item.surfaceId && item.surfaceId !== activeSurfaceId,
        );
        top.appendChild(title);
        if (customerDesignSettings.allowDuplicate !== false) {
          duplicate.type = "button";
          duplicate.className = "personalize-pilot-widget__freeform-duplicate";
          duplicate.textContent = "Duplizieren";
          duplicate.addEventListener("click", function (event) {
            event.stopPropagation();
            var sameKindCount = freeformItems.filter(function (candidate) {
              return candidate.kind === item.kind;
            }).length;
            var maximum = Number(
              item.kind === "text"
                ? customerDesignSettings.maxTextElements
                : item.kind === "image"
                  ? customerDesignSettings.maxImageElements
                  : item.kind === "shape"
                    ? customerDesignSettings.maxShapeElements
                    : item.kind === "clipart"
                      ? customerDesignSettings.maxClipartElements
                      : customerDesignSettings.maxSymbolElements,
            );
            if (sameKindCount >= maximum) return;
            rememberFreeformState();
            freeformSequence += 1;
            var clonedItem = Object.assign({}, item, {
              id: "free-" + item.kind + "-" + freeformSequence,
              sequence: freeformSequence,
              x: Number(item.x || 50) + 3,
              y: Number(item.y || 50) + 3,
              zIndex: freeformSequence,
              uploadGeneration: "",
            });
            freeformItems.push(clonedItem);
            selectedFreeformItemId = clonedItem.id;
            renderFreeformEditor();
          });
          top.appendChild(duplicate);
        }
        if (customerDesignSettings.allowDelete !== false) {
          remove.type = "button";
          remove.className = "personalize-pilot-widget__freeform-remove";
          remove.textContent = "Entfernen";
          remove.addEventListener("click", function (event) {
            event.stopPropagation();
            rememberFreeformState();
            freeformItems = freeformItems.filter(function (candidate) {
              return candidate !== item;
            });
            if (selectedFreeformItemId === item.id) {
              selectedFreeformItemId = "";
            }
            renderFreeformEditor();
          });
          top.appendChild(remove);
        }
        card.appendChild(top);

        if (item.kind === "text") {
          var textInput = document.createElement(
            customerDesignSettings.allowTextLineBreaks === true
              ? "textarea"
              : "input",
          );
          if (textInput.tagName === "INPUT") textInput.type = "text";
          textInput.maxLength = Number(widget.dataset.maxCharacters || 60);
          textInput.placeholder = "Dein Text";
          textInput.value = item.text;
          textInput.setAttribute("aria-label", "Eigener Text");
          var textHistoryCaptured = false;
          textInput.addEventListener("focus", function () {
            if (textHistoryCaptured) return;
            rememberFreeformState();
            textHistoryCaptured = true;
            selectFreeformItem(item.id, false);
          });
          textInput.addEventListener("input", function () {
            item.text = textInput.value;
            syncFreeformItem(item);
          });
          textInput.addEventListener("blur", function () {
            textHistoryCaptured = false;
          });
          card.appendChild(textInput);
        } else if (item.kind === "image") {
          var uploadField = document.createElement("label");
          var uploadCaption = document.createElement("span");
          var imageInput = document.createElement("input");
          var imageStatus = document.createElement("small");
          var imageError = document.createElement("small");
          uploadField.className = "personalize-pilot-widget__freeform-upload";
          uploadCaption.textContent = item.fileName || "Bild auswählen";
          imageInput.type = "file";
          imageInput.accept =
            "image/jpeg,image/png,image/webp,image/gif,image/svg+xml";
          imageInput.dataset.fileMode = "images";
          imageInput.dataset.maxFileSizeMb = "10";
          imageInput.dataset.personalizationSlotId = item.id;
          imageStatus.className =
            "personalize-pilot-widget__freeform-upload-status";
          imageStatus.textContent =
            item.uploadState === "ready"
              ? "Bild sicher gespeichert."
              : item.uploadState === "uploading"
                ? "Bild wird sicher gespeichert ..."
                : "";
          imageStatus.hidden = !imageStatus.textContent;
          imageError.className = "personalize-pilot-widget__freeform-warning";
          imageError.hidden = true;
          imageInput.addEventListener("change", function () {
            void handleFreeformImageChange(
              item,
              imageInput,
              imageStatus,
              imageError,
            );
          });
          uploadField.appendChild(uploadCaption);
          uploadField.appendChild(imageInput);
          uploadField.appendChild(imageStatus);
          uploadField.appendChild(imageError);
          card.appendChild(uploadField);
        }

        controls.className = "personalize-pilot-widget__freeform-controls";
        controls.dataset.freeformControls = "true";
        card.appendChild(controls);
        createFreeformRange(
          card,
          item,
          "x",
          "Links / rechts",
          0,
          100,
          !customerDesignSettings.allowMove,
        );
        createFreeformRange(
          card,
          item,
          "y",
          "Oben / unten",
          0,
          100,
          !customerDesignSettings.allowMove,
        );
        if (item.kind === "image" || item.kind === "clipart") {
          createFreeformRange(
            card,
            item,
            "widthScale",
            "Breite",
            25,
            250,
            !customerDesignSettings.allowResize,
          );
          createFreeformRange(
            card,
            item,
            "heightScale",
            "Höhe",
            25,
            250,
            !customerDesignSettings.allowResize,
          );
        } else {
          createFreeformRange(
            card,
            item,
            "scale",
            "Größe",
            Number(customerDesignSettings.minScalePercent || 40),
            Number(customerDesignSettings.maxScalePercent || 160),
            !customerDesignSettings.allowResize,
          );
        }
        createFreeformRange(
          card,
          item,
          "rotation",
          "Drehung",
          -180,
          180,
          !customerDesignSettings.allowRotate,
        );
        if (
          item.kind === "text" &&
          customerDesignSettings.allowCurvedText !== false
        ) {
          createFreeformRange(
            card,
            item,
            "textCurve",
            "Textbogen",
            -100,
            100,
            false,
          );
          createFreeformRange(
            card,
            item,
            "letterSpacing",
            "Buchstabenabstand",
            0,
            12,
            false,
          );
        }
        if (
          (item.kind === "image" || item.kind === "clipart") &&
          customerDesignSettings.allowImageEditing !== false
        ) {
          var allowedMasks = Array.isArray(
            customerDesignSettings.allowedImageMasks,
          )
            ? customerDesignSettings.allowedImageMasks
            : ["none", "rectangle", "ellipse", "rounded"];
          var maskLabels = {
            none: "Ohne Maske",
            rectangle: "Rechteck",
            ellipse: "Kreis / Ellipse",
            rounded: "Abgerundet",
          };
          createFreeformSelect(
            card,
            item,
            "imageMask",
            "Bildmaske",
            allowedMasks.map(function (mask) {
              return { value: mask, label: maskLabels[mask] || mask };
            }),
          );
          createFreeformRange(
            card,
            item,
            "brightness",
            "Helligkeit",
            0,
            200,
            false,
          );
          createFreeformRange(
            card,
            item,
            "contrast",
            "Kontrast",
            0,
            200,
            false,
          );
          createFreeformRange(
            card,
            item,
            "saturation",
            "Sättigung",
            0,
            200,
            false,
          );
          createFreeformRange(
            card,
            item,
            "grayscale",
            "Graustufen",
            0,
            100,
            false,
          );
          createFreeformToggle(card, item, "flipX", "Horizontal spiegeln");
          createFreeformToggle(card, item, "flipY", "Vertikal spiegeln");
        }
        if (item.kind === "shape") {
          createFreeformColor(card, item, "fillColor", "Füllfarbe", "#111111");
          createFreeformColor(card, item, "strokeColor", "Kontur", "#111111");
          createFreeformRange(
            card,
            item,
            "strokeWidth",
            "Konturstärke",
            1,
            6,
            false,
          );
        }
        if (
          item.kind === "shape" ||
          item.kind === "image" ||
          item.kind === "clipart"
        ) {
          createFreeformRange(
            card,
            item,
            "opacity",
            "Deckkraft",
            10,
            100,
            false,
          );
        }
        createFreeformAlignmentTools(card, item);

        propertyInput.type = "hidden";
        propertyInput.name =
          "properties[" +
          (item.kind === "text"
            ? "Eigener Text "
            : item.kind === "image"
              ? "Eigenes Bild "
              : item.kind === "clipart"
                ? "Eigenes Motiv "
                : item.kind === "shape"
                  ? "Eigene Form "
                  : "Eigenes Symbol ") +
          item.sequence +
          "]";
        propertyInput.dataset.freeformProperty = item.id;
        layoutInput.type = "hidden";
        layoutInput.name =
          "properties[_personalize_pilot_freeform_" + item.id + "]";
        layoutInput.dataset.freeformLayout = item.id;
        connectFreeformControl(propertyInput);
        connectFreeformControl(layoutInput);
        card.appendChild(propertyInput);
        card.appendChild(layoutInput);
        list.appendChild(card);
        card.addEventListener("click", function () {
          selectFreeformItem(item.id, false);
        });
        if (mainImagePreview.overlay)
          mainImagePreview.overlay.appendChild(target);
        syncFreeformItem(item);
      });

      var textCount = freeformItems.filter(function (item) {
        return item.kind === "text";
      }).length;
      var symbolCount = freeformItems.filter(function (item) {
        return item.kind === "symbol";
      }).length;
      var imageCount = freeformItems.filter(function (item) {
        return item.kind === "image";
      }).length;
      var shapeCount = freeformItems.filter(function (item) {
        return item.kind === "shape";
      }).length;
      var clipartCount = freeformItems.filter(function (item) {
        return item.kind === "clipart";
      }).length;
      widget
        .querySelectorAll('[data-freeform-add="text"]')
        .forEach(function (button) {
          button.disabled =
            textCount >= Number(customerDesignSettings.maxTextElements || 0);
        });
      widget
        .querySelectorAll('[data-freeform-add="image"]')
        .forEach(function (button) {
          button.disabled =
            imageCount >= Number(customerDesignSettings.maxImageElements || 0);
        });
      widget
        .querySelectorAll('[data-freeform-add="symbol"]')
        .forEach(function (button) {
          button.disabled =
            symbolCount >=
            Number(customerDesignSettings.maxSymbolElements || 0);
        });
      widget
        .querySelectorAll('[data-freeform-add="shape"]')
        .forEach(function (button) {
          button.disabled =
            shapeCount >= Number(customerDesignSettings.maxShapeElements || 0);
        });
      widget
        .querySelectorAll('[data-freeform-add="clipart"]')
        .forEach(function (button) {
          button.disabled =
            clipartCount >=
            Number(customerDesignSettings.maxClipartElements || 0);
        });
      updateFreeformPrice();
      refreshMainImageMode();
      updateFreeformSelection();
      updateFreeformHistoryButtons();
    }

    function addFreeformText() {
      var textCount = freeformItems.filter(function (item) {
        return item.kind === "text";
      }).length;
      if (textCount >= Number(customerDesignSettings.maxTextElements || 0))
        return;
      rememberFreeformState();
      freeformSequence += 1;
      var itemId = "free-text-" + freeformSequence;
      freeformItems.push({
        id: itemId,
        sequence: freeformSequence,
        kind: "text",
        text: "",
        x: 50,
        y: 42 + Math.min(textCount, 3) * 10,
        scale: 100,
        rotation: 0,
        textCurve: 0,
        letterSpacing: 0,
        zIndex: freeformSequence,
        surfaceId: activeSurfaceId,
      });
      selectedFreeformItemId = itemId;
      renderFreeformEditor();
      var newestInput = widget.querySelector(
        "[data-freeform-list] article:last-child input[type='text'], " +
          "[data-freeform-list] article:last-child textarea",
      );
      if (newestInput) newestInput.focus();
    }

    function addFreeformSymbol(symbol) {
      var symbolCount = freeformItems.filter(function (item) {
        return item.kind === "symbol";
      }).length;
      if (symbolCount >= Number(customerDesignSettings.maxSymbolElements || 0))
        return;
      rememberFreeformState();
      freeformSequence += 1;
      var itemId = "free-symbol-" + freeformSequence;
      freeformItems.push({
        id: itemId,
        sequence: freeformSequence,
        kind: "symbol",
        symbolLabel: symbol.label,
        symbolValue: symbol.value,
        symbolPath: symbol.path,
        x: 50 + Math.min(symbolCount, 2) * 12,
        y: 62,
        scale: 100,
        rotation: 0,
        opacity: 100,
        zIndex: freeformSequence,
        surfaceId: activeSurfaceId,
      });
      selectedFreeformItemId = itemId;
      renderFreeformEditor();
    }

    function addFreeformImage() {
      var imageCount = freeformItems.filter(function (item) {
        return item.kind === "image";
      }).length;
      if (imageCount >= Number(customerDesignSettings.maxImageElements || 0))
        return;
      rememberFreeformState();
      freeformSequence += 1;
      var itemId = "free-image-" + freeformSequence;
      freeformItems.push({
        id: itemId,
        sequence: freeformSequence,
        kind: "image",
        fileName: "",
        previewUrl: "",
        x: 42 + Math.min(imageCount, 2) * 16,
        y: 62,
        scale: 100,
        widthScale: 100,
        heightScale: 100,
        rotation: 0,
        imageMask: "none",
        brightness: 100,
        contrast: 100,
        saturation: 100,
        grayscale: 0,
        opacity: 100,
        flipX: false,
        flipY: false,
        zIndex: freeformSequence,
        surfaceId: activeSurfaceId,
      });
      selectedFreeformItemId = itemId;
      renderFreeformEditor();
      var newestInput = widget.querySelector(
        "[data-freeform-list] article:last-child input[type='file']",
      );
      if (newestInput) newestInput.click();
    }

    function addFreeformShape(shape) {
      var shapeCount = freeformItems.filter(function (item) {
        return item.kind === "shape";
      }).length;
      if (shapeCount >= Number(customerDesignSettings.maxShapeElements || 0))
        return;
      rememberFreeformState();
      freeformSequence += 1;
      var itemId = "free-shape-" + freeformSequence;
      freeformItems.push({
        id: itemId,
        sequence: freeformSequence,
        kind: "shape",
        shapeType: shape.value,
        shapeLabel: shape.label,
        fillColor: "#111111",
        strokeColor: "#111111",
        strokeWidth: 1,
        opacity: 100,
        x: 50 + Math.min(shapeCount, 2) * 10,
        y: 68,
        scale: 100,
        rotation: 0,
        zIndex: freeformSequence,
        surfaceId: activeSurfaceId,
      });
      selectedFreeformItemId = itemId;
      renderFreeformEditor();
    }

    function addFreeformClipart(asset) {
      var clipartCount = freeformItems.filter(function (item) {
        return item.kind === "clipart";
      }).length;
      if (
        clipartCount >= Number(customerDesignSettings.maxClipartElements || 0)
      )
        return;
      rememberFreeformState();
      freeformSequence += 1;
      var itemId = "free-clipart-" + freeformSequence;
      freeformItems.push({
        id: itemId,
        sequence: freeformSequence,
        kind: "clipart",
        clipartAssetId: asset.id,
        clipartName: asset.name,
        clipartImageUrl: asset.imageUrl,
        priceAdjustment: Number(asset.priceAdjustment || 0),
        shopifyVariantId: asset.shopifyVariantId || "",
        imageMask: "none",
        brightness: 100,
        contrast: 100,
        saturation: 100,
        grayscale: 0,
        opacity: 100,
        flipX: false,
        flipY: false,
        x: 42 + Math.min(clipartCount, 2) * 16,
        y: 62,
        scale: 100,
        rotation: 0,
        zIndex: freeformSequence,
        surfaceId: activeSurfaceId,
      });
      selectedFreeformItemId = itemId;
      renderFreeformEditor();
    }

    function initializeFreeformEditor() {
      var editor = widget.querySelector("[data-freeform-editor]");
      var picker = widget.querySelector("[data-freeform-symbol-picker]");
      var shapePicker = widget.querySelector("[data-freeform-shape-picker]");
      var clipartPicker = widget.querySelector(
        "[data-freeform-clipart-picker]",
      );
      if (!editor || customerDesignSettings.enabled === false) return;

      widget
        .querySelectorAll('[data-freeform-add="text"]')
        .forEach(function (button) {
          button.addEventListener("click", addFreeformText);
        });
      widget
        .querySelectorAll('[data-freeform-add="image"]')
        .forEach(function (button) {
          button.addEventListener("click", addFreeformImage);
        });
      widget
        .querySelectorAll('[data-freeform-add="symbol"]')
        .forEach(function (button) {
          button.addEventListener("click", function () {
            if (picker) picker.hidden = !picker.hidden;
          });
        });
      widget
        .querySelectorAll('[data-freeform-add="shape"]')
        .forEach(function (button) {
          button.addEventListener("click", function () {
            if (shapePicker) shapePicker.hidden = !shapePicker.hidden;
          });
        });
      widget
        .querySelectorAll('[data-freeform-add="clipart"]')
        .forEach(function (button) {
          button.addEventListener("click", function () {
            if (clipartPicker) clipartPicker.hidden = !clipartPicker.hidden;
          });
        });
      var undoButton = widget.querySelector("[data-freeform-undo]");
      var redoButton = widget.querySelector("[data-freeform-redo]");
      if (undoButton) undoButton.addEventListener("click", undoFreeformChange);
      if (redoButton) redoButton.addEventListener("click", redoFreeformChange);
      editor.addEventListener("keydown", function (event) {
        var target = event.target;
        var editingText =
          target &&
          (target.tagName === "INPUT" ||
            target.tagName === "TEXTAREA" ||
            target.isContentEditable);
        if (
          editingText ||
          !(event.metaKey || event.ctrlKey) ||
          event.key.toLowerCase() !== "z"
        ) {
          return;
        }
        event.preventDefault();
        if (event.shiftKey) redoFreeformChange();
        else undoFreeformChange();
      });
      if (picker) {
        var allowedSymbols = Array.isArray(
          customerDesignSettings.allowedSymbolValues,
        )
          ? customerDesignSettings.allowedSymbolValues
          : freeformSymbolLibrary.map(function (symbol) {
              return symbol.value;
            });
        freeformSymbolLibrary
          .filter(function (symbol) {
            return allowedSymbols.indexOf(symbol.value) >= 0;
          })
          .forEach(function (symbol) {
            var button = document.createElement("button");
            button.type = "button";
            button.title = symbol.label;
            button.innerHTML =
              '<svg viewBox="0 0 24 24" width="28" height="28" aria-hidden="true"><path d="' +
              symbol.path +
              '" fill="currentColor"></path></svg><span>' +
              symbol.label +
              "</span>";
            button.addEventListener("click", function () {
              addFreeformSymbol(symbol);
              picker.hidden = true;
            });
            picker.appendChild(button);
          });
      }
      if (shapePicker) {
        var allowedShapes = Array.isArray(
          customerDesignSettings.allowedShapeTypes,
        )
          ? customerDesignSettings.allowedShapeTypes
          : freeformShapeLibrary.map(function (shape) {
              return shape.value;
            });
        freeformShapeLibrary
          .filter(function (shape) {
            return allowedShapes.indexOf(shape.value) >= 0;
          })
          .forEach(function (shape) {
            var button = document.createElement("button");
            var icon = document.createElement("span");
            var label = document.createElement("span");
            button.type = "button";
            button.title = shape.label;
            icon.className =
              "personalize-pilot-widget__shape-icon personalize-pilot-widget__shape-icon--" +
              shape.value;
            icon.setAttribute("aria-hidden", "true");
            label.textContent = shape.label;
            button.appendChild(icon);
            button.appendChild(label);
            button.addEventListener("click", function () {
              addFreeformShape(shape);
              shapePicker.hidden = true;
            });
            shapePicker.appendChild(button);
          });
      }
      if (clipartPicker) {
        var clipartAssets = Array.isArray(customerDesignSettings.clipartAssets)
          ? customerDesignSettings.clipartAssets
          : [];
        clipartAssets.forEach(function (asset) {
          var button = document.createElement("button");
          var image = document.createElement("img");
          var label = document.createElement("span");
          button.type = "button";
          button.title = asset.name;
          image.src = asset.imageUrl;
          image.alt = "";
          image.width = 48;
          image.height = 48;
          image.loading = "lazy";
          label.textContent =
            asset.name +
            (Number(asset.priceAdjustment || 0) > 0
              ? " (+" +
                formatStorefrontMoney(Number(asset.priceAdjustment) * 100) +
                ")"
              : "");
          button.appendChild(image);
          button.appendChild(label);
          button.addEventListener("click", function () {
            addFreeformClipart(asset);
            clipartPicker.hidden = true;
          });
          clipartPicker.appendChild(button);
        });
      }
      renderFreeformEditor();
    }

    function getCustomerSlotTargets(slotId) {
      return textPreviewTargets[slotId]
        ? getTextTargets(slotId)
        : getImageTargets(slotId);
    }

    function resetCustomerSlotBaseLayout(slotId, sourceBase, surfaceId) {
      var panel = widget.querySelector(
        '[data-customer-layout-panel="' + slotId + '"]',
      );
      if (!panel) return;

      var normalizedSource = sourceBase || {};
      var normalizedSurface = surfaceId || "front";
      panel.dataset.customerBaseLayout = JSON.stringify(normalizedSource);
      panel.dataset.customerSurface = normalizedSurface;

      var state = customerSlotLayouts[slotId];
      if (!state) return;

      state.sourceBase = normalizedSource;
      var previewSource = normalizedSource;
      if (state.kind === "template-text") {
        var previewTarget = getCustomerSlotTargets(slotId)[0];
        previewSource = mapTemplateTextToContainedArtworkPreview(
          normalizedSource,
          normalizedSurface,
          previewTarget,
        );
      }
      var base = resolveSurfaceRelativeLayout(previewSource, normalizedSurface);
      base = clampLayoutToConfiguredSurface(
        base,
        normalizedSurface,
        getCanonicalProductPreviewStageAspectRatio(),
        false,
      );
      state.base = base;
      state.surfaceId = normalizedSurface;
      state.x = Number(base.x || 50);
      state.y = Number(base.y || 50);
      state.scale = 100;
      state.widthScale = 100;
      state.heightScale = 100;
      state.rotation = Number(base.rotation || 0);
      state.textCurve = Number(base.textCurve || 0);

      widget
        .querySelectorAll('[data-customer-layout-control="' + slotId + '"]')
        .forEach(function (control) {
          var key = control.dataset.layoutKey || "";
          if (
            key === "scale" ||
            key === "widthScale" ||
            key === "heightScale"
          ) {
            control.value = "100";
          } else if (key === "x" || key === "y") {
            control.value = String(Math.round(Number(state[key] || 0)));
          } else if (key === "rotation" || key === "textCurve") {
            control.value = String(Number(state[key] || 0));
          }
          updateCustomerLayoutOutput(slotId, key, control.value);
        });
      syncCustomerSlotLayout(slotId);
    }

    function getStableCustomerResizeScale(
      base,
      area,
      requestedScale,
      scalesWidth,
      scalesHeight,
    ) {
      var normalizedRequestedScale = clampFreeformNumber(
        requestedScale,
        0.25,
        2.5,
      );
      var createCandidate = function (scale) {
        return {
          x: Number(base.x || area.x || 50),
          y: Number(base.y || area.y || 50),
          width: Math.max(
            4,
            Number(base.width || 4) * (scalesWidth ? scale : 1),
          ),
          height: Math.max(
            4,
            Number(base.height || 4) * (scalesHeight ? scale : 1),
          ),
          rotation: Number(base.rotation || 0),
        };
      };
      var isContained = function (scale) {
        var candidate = createCandidate(scale);
        if (
          personalizationGeometry &&
          typeof personalizationGeometry.isGeometryLayoutContained ===
            "function"
        ) {
          return personalizationGeometry.isGeometryLayoutContained(
            candidate,
            area,
            getCanonicalProductPreviewStageAspectRatio(),
          );
        }
        var left = area.x - area.width / 2;
        var right = area.x + area.width / 2;
        var top = area.y - area.height / 2;
        var bottom = area.y + area.height / 2;
        return (
          candidate.x - candidate.width / 2 >= left &&
          candidate.x + candidate.width / 2 <= right &&
          candidate.y - candidate.height / 2 >= top &&
          candidate.y + candidate.height / 2 <= bottom
        );
      };

      if (isContained(normalizedRequestedScale)) {
        return normalizedRequestedScale;
      }

      // Calculate every candidate from the immutable start geometry. This
      // keeps the authored center stable and prevents cumulative movement when
      // the customer moves the range input repeatedly.
      var low = Math.min(1, normalizedRequestedScale);
      var high = normalizedRequestedScale;
      if (!isContained(low)) return low;
      for (var index = 0; index < 18; index += 1) {
        var middle = (low + high) / 2;
        if (isContained(middle)) {
          low = middle;
        } else {
          high = middle;
        }
      }
      return low;
    }

    function syncCustomerSlotLayout(slotId) {
      var state = customerSlotLayouts[slotId];
      if (!state) return;
      var base = state.base;
      var definitionParagraph = /^definition-line-[123]$/.test(slotId) &&
        form && form.querySelector("definition-editor");
      if (definitionParagraph) {
        // Dictionary text is one left column. Only its vertical position may
        // change, including drag, reset and reopening an older saved design.
        state.x = base.x;
        state.scale = 100;
        state.widthScale = 100;
        state.heightScale = 100;
        state.rotation = 0;
        state.textCurve = 0;
      }
      var area = getFreeformDesignArea(state.surfaceId);
      var baseWidth = clampFreeformNumber(base.width, 4, 100);
      var baseHeight = clampFreeformNumber(base.height, 4, 100);
      var requestedScale = clampFreeformNumber(state.scale, 25, 250) / 100;
      var widthScale = clampFreeformNumber(state.widthScale, 25, 250) / 100;
      var heightScale = clampFreeformNumber(state.heightScale, 25, 250) / 100;
      var scale = Math.min(
        requestedScale,
        area.width / Math.max(baseWidth, 1),
        area.height / Math.max(baseHeight, 1),
      );
      var keepsTemplateBounds = state.kind === "template-text";
      var templateTextScale = keepsTemplateBounds
        ? getStableCustomerResizeScale(base, area, requestedScale, false, true)
        : scale;
      var width = keepsTemplateBounds
        ? baseWidth
        : Math.min(area.width, baseWidth * scale * widthScale);
      var height = keepsTemplateBounds
        ? Math.min(area.height, baseHeight * templateTextScale)
        : Math.min(area.height, baseHeight * scale * heightScale);
      var fontScale = keepsTemplateBounds ? templateTextScale : scale;
      var clampedCenter = clampAbsoluteDesignPoint(
        state.x,
        state.y,
        width,
        height,
        area,
      );
      var layout = {
        coordinateSpace: "product",
        x: Number(clampedCenter.x.toFixed(2)),
        y: Number(clampedCenter.y.toFixed(2)),
        width: Number(width.toFixed(2)),
        height: Number(height.toFixed(2)),
        rotation: Number(
          clampFreeformNumber(state.rotation, -180, 180).toFixed(2),
        ),
        fontSizeMm: Number(
          (clampFreeformNumber(base.fontSizeMm, 1, 80) * fontScale).toFixed(2),
        ),
        align: base.align || "center",
        boundaryShape: base.boundaryShape || "rectangle",
        autoFitText: base.autoFitText !== false,
        allowLineBreaks: base.allowLineBreaks === true,
        surfaceMode: base.surfaceMode || "flat",
        surfaceIntensity: Number(base.surfaceIntensity || 0),
        textCurve: Number(
          clampFreeformNumber(state.textCurve, -100, 100).toFixed(2),
        ),
      };
      state.x = layout.x;
      state.y = layout.y;
      state.layout = layout;

      getCustomerSlotTargets(slotId).forEach(function (target) {
        target.style.setProperty("--slot-x", layout.x + "%");
        target.style.setProperty("--slot-y", layout.y + "%");
        target.style.setProperty("--slot-width", layout.width + "%");
        target.style.setProperty("--slot-height", layout.height + "%");
        target.style.setProperty("--slot-rotation", layout.rotation + "deg");
        setResponsiveTextSize(
          target,
          layout,
          target.dataset.personalizationSurface || activeSurfaceId,
        );
        target.dataset.textCurve = String(layout.textCurve || 0);
        if (state.kind === "image") {
          var usesFreeProportions =
            Math.abs(state.widthScale - 100) > 0.01 ||
            Math.abs(state.heightScale - 100) > 0.01;
          if (usesFreeProportions && !photoCropStates[slotId]) {
            target.dataset.imageFit = "stretch";
          }
          applyConfiguredImageFit(target);
        }
        if (textPreviewTargets[slotId]) {
          updatePreviewText(
            target,
            target.dataset.previewTextValue || target.textContent,
          );
        }
      });

      var hiddenInput = widget.querySelector(
        '[data-customer-layout-input="' + slotId + '"]',
      );
      if (hiddenInput) {
        var submittedLayout = layout;
        if (state.kind === "template-text") {
          // Template text is authored in the transparent motif canvas. Keep
          // that coordinate space in the line-item property. The customer may
          // enlarge the text line vertically so Auto-Fit has real room to make
          // a short name visibly larger; its center and engraving-lane width
          // remain immutable. Persisting the preview projection would make
          // order/production code apply contain to an already contained layout.
          var sourceHeight = clampFreeformNumber(
            Number((state.sourceBase || base).height),
            4,
            100,
          );
          submittedLayout = Object.assign({}, state.sourceBase || base, {
            height: Number((sourceHeight * fontScale).toFixed(2)),
            fontSizeMm: Number(
              (
                clampFreeformNumber(
                  Number((state.sourceBase || base).fontSizeMm),
                  1,
                  80,
                ) * fontScale
              ).toFixed(2),
            ),
          });
        }
        hiddenInput.value = JSON.stringify(submittedLayout);
      }
      var imageFitInput = widget.querySelector(
        '[data-customer-image-fit-input="' + slotId + '"]',
      );
      if (imageFitInput && state.kind === "image" && !photoCropStates[slotId]) {
        imageFitInput.value =
          Math.abs(state.widthScale - 100) > 0.01 ||
          Math.abs(state.heightScale - 100) > 0.01
            ? "stretch"
            : imageFitInput.defaultValue || "contain";
      }
      if (typeof widget.personalizePilotSyncFollowers === "function") {
        widget.personalizePilotSyncFollowers();
      }
      if (state.kind === "image" || !syncCurrentMobilePreviewText()) {
        scheduleMobileLivePreviewRefresh();
      }
    }

    function formatCustomerLayoutOutput(key, value) {
      var rounded = Math.round(Number(value || 0));
      if (key === "textCurve") {
        if (Math.abs(rounded) <= 1) return "Gerade";
        return (
          (rounded > 0 ? "Nach oben " : "Nach unten ") + Math.abs(rounded) + "%"
        );
      }
      return rounded + "%";
    }

    function updateCustomerLayoutOutput(slotId, key, value) {
      widget
        .querySelectorAll("[data-customer-layout-output]")
        .forEach(function (output) {
          if (
            output.dataset.customerLayoutOutput === slotId &&
            output.dataset.layoutKey === key
          ) {
            output.textContent = formatCustomerLayoutOutput(key, value);
          }
        });

      if (key === "textCurve") {
        widget
          .querySelectorAll('[data-customer-curve-preset="' + slotId + '"]')
          .forEach(function (button) {
            button.setAttribute(
              "aria-pressed",
              Number(button.dataset.curveValue || 0) === Number(value)
                ? "true"
                : "false",
            );
          });
      }
    }

    function attachCustomerSlotDrag(slotId) {
      var state = customerSlotLayouts[slotId];
      // For cropped photos dragging moves the photo, not the containing frame.
      // Frame geometry has its own labelled controls below the upload.
      if (widget.querySelector('[data-photo-crop-panel="' + slotId + '"]')) return;
      if (!state || !state.permissions.move || !mainImagePreview.overlay)
        return;
      var target = textPreviewTargets[slotId]
        ? mainImagePreview.textTargets[slotId]
        : mainImagePreview.imageTargets[slotId];
      if (!target || target.dataset.customerDragAttached === "true") return;

      target.dataset.customerDragAttached = "true";
      target.classList.add("is-customer-editable");
      target.addEventListener("pointerdown", function (event) {
        syncCustomerSlotLayout(slotId);
        var overlayRect = mainImagePreview.overlay.getBoundingClientRect();
        var area = getFreeformDesignArea(state.surfaceId);
        var layout = state.layout || state.base;
        var startX = event.clientX;
        var startY = event.clientY;
        var originalX = state.x;
        var originalY = state.y;

        beginCustomerPointerDrag(event, target, function (moveEvent) {
          state.x =
            originalX +
            ((moveEvent.clientX - startX) / Math.max(1, overlayRect.width)) *
              100;
          state.y =
            originalY +
            ((moveEvent.clientY - startY) / Math.max(1, overlayRect.height)) *
              100;
          var nextCenter = clampAbsoluteDesignPoint(
            state.x,
            state.y,
            Number(layout.width || 0),
            Number(layout.height || 0),
            area,
          );
          state.x = nextCenter.x;
          state.y = nextCenter.y;
          var xControl = widget.querySelector(
            '[data-customer-layout-control="' +
              slotId +
              '"][data-layout-key="x"]',
          );
          var yControl = widget.querySelector(
            '[data-customer-layout-control="' +
              slotId +
              '"][data-layout-key="y"]',
          );
          if (xControl) xControl.value = String(Math.round(state.x));
          if (yControl) yControl.value = String(Math.round(state.y));
          syncCustomerSlotLayout(slotId);
        });
      });
    }

    function refreshCustomerSlotLayouts() {
      Object.keys(customerSlotLayouts).forEach(function (slotId) {
        syncCustomerSlotLayout(slotId);
        attachCustomerSlotDrag(slotId);
      });
    }

    function initializeCustomerSlotLayouts() {
      widget
        .querySelectorAll("[data-customer-layout-panel]")
        .forEach(function (panel) {
          var slotId = panel.dataset.customerLayoutPanel || "";
          var sourceBase = {};
          try {
            sourceBase =
              JSON.parse(panel.dataset.customerBaseLayout || "{}") || {};
          } catch (error) {
            sourceBase = {};
          }
          var surfaceId = panel.dataset.customerSurface || "front";
          var kind = panel.dataset.customerLayoutKind || "text";
          var previewSource = sourceBase;
          // Initial controls must use the same contained-artwork projection as
          // a later template selection. Otherwise their first refresh overwrites
          // the correct preview with unprojected motif-canvas coordinates.
          if (kind === "template-text") {
            previewSource = mapTemplateTextToContainedArtworkPreview(
              sourceBase,
              surfaceId,
              getCustomerSlotTargets(slotId)[0],
            );
          }
          var base = resolveSurfaceRelativeLayout(previewSource, surfaceId);
          base = clampLayoutToConfiguredSurface(
            base,
            surfaceId,
            getCanonicalProductPreviewStageAspectRatio(),
            false,
          );
          customerSlotLayouts[slotId] = {
            base: base,
            sourceBase: sourceBase,
            kind: kind,
            surfaceId: surfaceId,
            x: Number(base.x || 50),
            y: Number(base.y || 50),
            scale: 100,
            widthScale: 100,
            heightScale: 100,
            rotation: Number(base.rotation || 0),
            textCurve: Number(base.textCurve || 0),
            permissions: {
              move: panel.dataset.customerCanMove === "true",
              resize: panel.dataset.customerCanResize === "true",
              rotate: panel.dataset.customerCanRotate === "true",
              curve: panel.dataset.customerCanCurve === "true",
            },
          };
        });

      widget
        .querySelectorAll("[data-customer-layout-control]")
        .forEach(function (control) {
          var slotId = control.dataset.customerLayoutControl || "";
          var key = control.dataset.layoutKey || "";
          var state = customerSlotLayouts[slotId];
          if (/^definition-line-[123]$/.test(slotId) && (key === "x" || key === "y")) control.step = ".01";
          if (
            state &&
            (key === "x" ||
              key === "y" ||
              key === "rotation" ||
              key === "textCurve")
          ) {
            control.value = String(Number(state[key] || 0));
          }
          updateCustomerLayoutOutput(slotId, key, control.value);
          control.addEventListener("input", function () {
            var slotId = control.dataset.customerLayoutControl || "";
            var key = control.dataset.layoutKey || "";
            var state = customerSlotLayouts[slotId];
            if (!state || !key) return;
            if ((key === "x" || key === "y") && !state.permissions.move) return;
            if (
              (key === "scale" ||
                key === "widthScale" ||
                key === "heightScale") &&
              !state.permissions.resize
            )
              return;
            if (key === "rotation" && !state.permissions.rotate) return;
            if (key === "textCurve" && !state.permissions.curve) return;
            customerSlotLayouts[slotId][key] = Number(control.value);
            updateCustomerLayoutOutput(slotId, key, control.value);
            syncCustomerSlotLayout(slotId);
          });
        });
      widget
        .querySelectorAll("[data-customer-curve-preset]")
        .forEach(function (button) {
          button.addEventListener("click", function () {
            var slotId = button.dataset.customerCurvePreset || "";
            var control = widget.querySelector(
              '[data-customer-layout-control="' +
                slotId +
                '"][data-layout-key="textCurve"]',
            );
            if (!control) return;
            control.value = button.dataset.curveValue || "0";
            control.dispatchEvent(new Event("input", { bubbles: true }));
          });
        });
      refreshCustomerSlotLayouts();
    }

    function setImageToolsVisible(slotId, visible) {
      widget.querySelectorAll('[data-image-tools="' + slotId + '"]').forEach(function (tools) {
        tools.hidden = !visible;
        tools.querySelectorAll("input, select, textarea, button").forEach(function (control) {
          var field = control.closest("[data-personalize-field]");
          var available = visible && isPersonalizationEnabled() && !selectedVariantDisabled &&
            (!field || (field.dataset.templateExclusiveSuppressed !== "true" && conditionMatches(field)));
          control.disabled = !available || Boolean(control.closest("[hidden]"));
        });
      });
    }

    function syncOptionalImageAreas() {
      widget.querySelectorAll("[data-optional-image-toggle]").forEach(function (toggle) {
        var slotId = toggle.dataset.optionalImageToggle;
        var content = widget.querySelector('[data-optional-image-content="' + slotId + '"]');
        var field = toggle.closest("[data-personalize-field]");
        if (!content || !field) return;
        toggle.disabled = !isPersonalizationEnabled() || selectedVariantDisabled || field.hidden ||
          field.dataset.templateExclusiveSuppressed === "true" || !conditionMatches(field);
        toggle.required = false;
        content.hidden = !toggle.checked;
        toggle.setAttribute("aria-expanded", String(toggle.checked));
        content.querySelectorAll("input, select, textarea, button").forEach(function (control) {
          control.disabled = !toggle.checked || !isPersonalizationEnabled() || selectedVariantDisabled ||
            field.dataset.templateExclusiveSuppressed === "true" || !conditionMatches(field) ||
            Boolean(control.closest("[hidden]"));
        });
        getImageTargets(slotId).forEach(function (target) {
          target.dataset.customerImageEnabled = String(toggle.checked);
          target.hidden = !toggle.checked || field.hidden;
        });
      });
    }

    widget.querySelectorAll("[data-optional-image-toggle]").forEach(function (toggle) {
      var label = toggle.closest("[data-optional-image-toggle-label]");
      if (label) label.hidden = false;
      toggle.addEventListener("change", function () {
        syncOptionalImageAreas();
        updateUploadCount();
        refreshMainImageMode();
        scheduleMobileLivePreviewRefresh();
      });
    });

    function updateImageScale(slotId, value) {
      var photoCropState = photoCropStates[slotId];
      var normalizedValue = normalizeImageScalePercent(
        value,
        photoCropState ? photoCropState.version === 1 ? 250 : 300 : 100,
      );

      getImageTargets(slotId).forEach(function (target) {
        applyImageScaleToTarget(target, normalizedValue);
      });
      widget
        .querySelectorAll("[data-image-scale-output]")
        .forEach(function (output) {
          if (output.dataset.imageScaleOutput === slotId) {
            output.textContent = normalizedValue + "%";
          }
        });
      scheduleMobileLivePreviewRefresh();
    }

    function syncImageScaleControlsToPreview() {
      imageScaleControls.forEach(function (control) {
        updateImageScale(
          control.dataset.imageScaleControl || "",
          control.value,
        );
      });
    }

    imageScaleControls.forEach(function (control) {
      control.addEventListener("input", function () {
        updateImageScale(
          control.dataset.imageScaleControl || "",
          control.value,
        );
      });
    });

    widget.querySelectorAll("[data-customer-image-fit-input]").forEach(function (control) {
      control.addEventListener("input", function () {
        var slotId = control.dataset.customerImageFitInput;
        if (!photoCropStates[slotId]) return;
        var fit = control.value === "contain" ? "contain" : "cover";
        getImageTargets(slotId).forEach(function (target) {
          target.dataset.imageFit = fit;
          applyConfiguredImageFit(target);
        });
        scheduleMobileLivePreviewRefresh();
      });
    });

    widget.querySelectorAll("[data-image-action-slot]").forEach(function (button) {
      button.addEventListener("click", function () {
        var slotId = button.dataset.imageActionSlot;
        var scaleControl = widget.querySelector('[data-image-scale-control="' + slotId + '"]');
        if (!scaleControl) return;
        if (button.dataset.imageFitAction) {
          var fit = button.dataset.imageFitAction === "contain" ? "contain" : "cover";
          getImageTargets(slotId).forEach(function (target) { target.dataset.imageFit = fit; });
          var fitInput = widget.querySelector('[data-customer-image-fit-input="' + slotId + '"]');
          if (fitInput) fitInput.value = fit;
          var state = getPhotoCropState(slotId); state.x = 50; state.y = 50; state.version = 2;
          scaleControl.value = "100";
          syncPhotoCrop(slotId);
        } else {
          scaleControl.value = String(normalizeImageScalePercent(Number(scaleControl.value) + Number(button.dataset.imageZoomStep || 0), 300));
        }
        scaleControl.dispatchEvent(new Event("input", { bubbles: true }));
      });
    });
    widget.querySelectorAll("[data-image-center]").forEach(function (button) {
      button.addEventListener("click", function () {
        var slotId = button.dataset.imageCenter;
        var state = getPhotoCropState(slotId); state.x = 50; state.y = 50;
        syncPhotoCrop(slotId);
      });
    });
    widget.querySelectorAll("[data-image-remove]").forEach(function (button) {
      button.addEventListener("click", function () {
        var input = widget.querySelector('[data-file-preview-slot="' + button.dataset.imageRemove + '"]');
        if (input) { input.value = ""; input.dispatchEvent(new Event("change", { bubbles: true })); }
      });
    });

    function getPhotoCropState(slotId) {
      if (!photoCropStates[slotId]) {
        photoCropStates[slotId] = { x: 50, y: 50, version: 2 };
      }
      return photoCropStates[slotId];
    }

    function syncPhotoCropControls(slotId) {
      var state = getPhotoCropState(slotId);
      photoCropControls.forEach(function (control) {
        if (control.dataset.photoCropControl !== slotId) return;
        control.value = String(
          Math.round(control.dataset.cropKey === "y" ? state.y : state.x),
        );
      });
    }

    function syncPhotoCrop(slotId) {
      var state = getPhotoCropState(slotId);
      state.x = Math.round(clampFreeformNumber(state.x, 0, 100) * 100) / 100;
      state.y = Math.round(clampFreeformNumber(state.y, 0, 100) * 100) / 100;
      getImageTargets(slotId).forEach(function (target) {
        if (!isCoverCropPreviewTarget(target)) return;
        target.dataset.imagePlacementVersion = String(state.version || 2);
        target.dataset.imagePositionXPercent = String(state.x);
        target.dataset.imagePositionYPercent = String(state.y);
        target.style.setProperty("--slot-image-position-x", state.x + "%");
        target.style.setProperty("--slot-image-position-y", state.y + "%");
        applyConfiguredImageFit(target);
      });
      var hiddenInput = widget.querySelector(
        '[data-photo-crop-input="' + slotId + '"]',
      );
      if (hiddenInput) {
        hiddenInput.value = JSON.stringify({
          x: Number(state.x.toFixed(2)),
          y: Number(state.y.toFixed(2)),
          version: state.version === 1 ? undefined : 2,
        });
      }
      syncPhotoCropControls(slotId);
      scheduleMobileLivePreviewRefresh();
    }

    function attachPhotoCropDrag(slotId) {
      var target = mainImagePreview.imageTargets[slotId];
      if (
        !target ||
        !isCoverCropPreviewTarget(target) ||
        target.dataset.photoCropDragAttached === "true"
      ) {
        return;
      }

      target.dataset.photoCropDragAttached = "true";
      target.classList.add("is-customer-editable");
      target.tabIndex = 0;
      target.setAttribute("role", "button");
      target.setAttribute(
        "aria-label",
        document.documentElement.lang === "en" ? "Move image. Drag or use arrow keys." : "Bild verschieben. Ziehen oder Pfeiltasten verwenden.",
      );
      target.addEventListener("keydown", function (event) {
        if (
          ["ArrowLeft", "ArrowRight", "ArrowUp", "ArrowDown"].indexOf(
            event.key,
          ) < 0
        ) {
          return;
        }
        event.preventDefault();
        var state = getPhotoCropState(slotId);
        var step = event.shiftKey ? 5 : 1;
        if (event.key === "ArrowLeft") state.x -= step;
        if (event.key === "ArrowRight") state.x += step;
        if (event.key === "ArrowUp") state.y -= step;
        if (event.key === "ArrowDown") state.y += step;
        syncPhotoCrop(slotId);
      });
      target.addEventListener("pointerdown", function (event) {
        if (event.button !== undefined && event.button !== 0) return;
        var state = getPhotoCropState(slotId);
        var targetRect = target.getBoundingClientRect();
        var startClientX = event.clientX;
        var startClientY = event.clientY;
        var startPositionX = state.x;
        var startPositionY = state.y;
        var image = target.querySelector("img");
        if (!image || !image.naturalWidth) return;
        var placement = resolveCustomerImagePlacement(targetRect.width, targetRect.height,
          image.naturalWidth, image.naturalHeight, target.dataset.imageFit,
          target.dataset.imageScalePercent || 100, state.x, state.y);
        var travelX = Math.abs(targetRect.width - placement.width);
        var travelY = Math.abs(targetRect.height - placement.height);
        beginCustomerPointerDrag(event, target, function (moveEvent) {
          state.x = travelX > 1 ? startPositionX + (moveEvent.clientX - startClientX) / travelX * 100 : startPositionX;
          state.y = travelY > 1 ? startPositionY + (moveEvent.clientY - startClientY) / travelY * 100 : startPositionY;
          syncPhotoCrop(slotId);
        });
      });
    }

    function refreshPhotoCrops() {
      Object.keys(photoCropStates).forEach(function (slotId) {
        syncPhotoCrop(slotId);
        attachPhotoCropDrag(slotId);
      });
    }

    function initializePhotoCrops() {
      widget
        .querySelectorAll("[data-photo-crop-panel]")
        .forEach(function (panel) {
          getPhotoCropState(panel.dataset.photoCropPanel || "");
        });
      photoCropControls.forEach(function (control) {
        var slotId = control.dataset.photoCropControl || "";
        var state = getPhotoCropState(slotId);
        var key = control.dataset.cropKey === "y" ? "y" : "x";
        state[key] = clampFreeformNumber(Number(control.value), 0, 100);
        control.addEventListener("input", function () {
          state[key] = clampFreeformNumber(Number(control.value), 0, 100);
          syncPhotoCrop(slotId);
        });
      });
      widget
        .querySelectorAll("[data-photo-crop-input]")
        .forEach(function (input) {
          input.addEventListener("input", function () {
            var slotId = input.dataset.photoCropInput || "";
            try {
              var parsed = JSON.parse(input.value || "{}");
              var state = getPhotoCropState(slotId);
              state.version = parsed.version === 2 ? 2 : 1;
              state.x = clampFreeformNumber(Number(parsed.x), 0, 100);
              state.y = clampFreeformNumber(Number(parsed.y), 0, 100);
              syncPhotoCrop(slotId);
            } catch (error) {
              // Keep the last valid, server-verifiable crop.
            }
          });
        });
      refreshPhotoCrops();
    }

    function getSlotControl(slotId) {
      var controls = widget.querySelectorAll("[data-personalization-slot-id]");

      for (
        var controlIndex = 0;
        controlIndex < controls.length;
        controlIndex += 1
      ) {
        if (controls[controlIndex].dataset.personalizationSlotId === slotId) {
          return controls[controlIndex];
        }
      }

      return null;
    }

    function getConditionalControlValue(control) {
      if (!control || control.disabled) {
        return "";
      }

      if (control.type === "checkbox") {
        return control.checked ? String(control.value || "true") : "";
      }

      if (control.type === "radio") {
        var radioControls = widget.querySelectorAll(
          "[data-personalization-slot-id]",
        );

        for (
          var radioIndex = 0;
          radioIndex < radioControls.length;
          radioIndex += 1
        ) {
          if (
            radioControls[radioIndex].dataset.personalizationSlotId ===
              control.dataset.personalizationSlotId &&
            radioControls[radioIndex].checked
          ) {
            return String(radioControls[radioIndex].value || "");
          }
        }

        return "";
      }

      if (control.type === "file") {
        return control.files && control.files.length > 0
          ? control.files[0].name
          : "";
      }

      return String(control.value || "");
    }

    function conditionRuleMatches(rule) {
      var dependsOnSlotId = String(rule.dependsOnSlotId || "");
      var operator = String(rule.operator || "filled");
      var expectedValue = String(rule.value || "");
      var dependency = dependsOnSlotId ? getSlotControl(dependsOnSlotId) : null;
      var actualValue = getConditionalControlValue(dependency);

      if (!dependsOnSlotId) {
        return true;
      }

      if (!dependency || !isConditionDependencyAvailable(dependency)) {
        return false;
      }

      if (operator === "checked") {
        return Boolean(dependency.type === "checkbox" && dependency.checked);
      }

      if (operator === "unchecked") {
        return Boolean(dependency.type === "checkbox" && !dependency.checked);
      }

      if (operator === "equals") {
        return actualValue === expectedValue;
      }

      if (operator === "not_equals") {
        return actualValue !== expectedValue;
      }

      if (operator === "empty") {
        return actualValue.trim().length === 0;
      }

      if (operator === "contains") {
        return (
          actualValue
            .toLocaleLowerCase()
            .indexOf(expectedValue.toLocaleLowerCase()) >= 0
        );
      }

      if (operator === "not_contains") {
        return (
          actualValue
            .toLocaleLowerCase()
            .indexOf(expectedValue.toLocaleLowerCase()) < 0
        );
      }

      if (operator === "greater_than" || operator === "less_than") {
        var actualNumber = Number(actualValue);
        var expectedNumber = Number(expectedValue);
        if (
          !Number.isFinite(actualNumber) ||
          !Number.isFinite(expectedNumber)
        ) {
          return false;
        }
        return operator === "greater_than"
          ? actualNumber > expectedNumber
          : actualNumber < expectedNumber;
      }

      return actualValue.trim().length > 0;
    }

    function isConditionDependencyAvailable(dependency) {
      if (!dependency.disabled) return true;

      var dependencyField = dependency.closest("[data-personalize-field]");
      if (!dependencyField) return false;
      if (dependencyField.dataset.templateExclusiveSuppressed === "true") {
        return false;
      }

      var dependencySurfaceId =
        dependencyField.dataset.personalizationSurface || "";
      var disabledOnlyByInactiveSurface =
        dependencySurfaceId && dependencySurfaceId !== activeSurfaceId;
      if (!disabledOnlyByInactiveSurface) return false;

      return conditionMatches(dependencyField);
    }

    function conditionMatches(field) {
      var group = null;
      if (field.dataset.conditionalRules) {
        try {
          var parsedGroup = JSON.parse(field.dataset.conditionalRules);
          if (
            parsedGroup &&
            Array.isArray(parsedGroup.rules) &&
            parsedGroup.rules.length > 0 &&
            parsedGroup.rules.length <= 5
          ) {
            group = parsedGroup;
          }
        } catch (_error) {
          group = null;
        }
      }

      var rules = group
        ? group.rules
        : field.dataset.conditionalDependsOn
          ? [
              {
                dependsOnSlotId: field.dataset.conditionalDependsOn,
                operator: field.dataset.conditionalOperator || "filled",
                value: field.dataset.conditionalValue || "",
              },
            ]
          : [];
      if (rules.length === 0) return true;
      var matches = rules.map(conditionRuleMatches);
      return group && group.combinator === "or"
        ? matches.some(Boolean)
        : matches.every(Boolean);
    }

    function setConditionalFieldVisibility(field, visible) {
      var slotId = field.dataset.personalizationSlotContainer || "";
      var fieldControls = field.querySelectorAll("input, select, textarea");
      var previewTargets = getTextTargets(slotId).concat(
        getImageTargets(slotId),
      );
      var fieldSurfaceId = field.dataset.personalizationSurface;
      var isActiveSurface =
        !fieldSurfaceId || fieldSurfaceId === activeSurfaceId;
      var isTemplateExclusiveSuppressed =
        field.dataset.templateExclusiveSuppressed === "true";
      var isAvailable =
        visible &&
        isActiveSurface &&
        !selectedVariantDisabled &&
        !isTemplateExclusiveSuppressed;

      field.hidden = !isAvailable;
      field.setAttribute("aria-hidden", isAvailable ? "false" : "true");

      fieldControls.forEach(function (control) {
        control.disabled = !isAvailable || Boolean(control.closest("[hidden]"));

        if (control.dataset.multiOption !== undefined) {
          control.required = false;
        } else if (control.type !== "hidden") {
          control.required =
            isAvailable && field.dataset.fieldRequired === "true";
        }
      });

      previewTargets.forEach(function (target) {
        target.hidden =
          !isAvailable || target.dataset.previewHasValue === "false";
        target.classList.toggle("is-conditionally-hidden", !isAvailable);
      });
    }

    function getMultiChoiceControls(slotId) {
      return Array.prototype.filter.call(
        widget.querySelectorAll("[data-multi-option]"),
        function (control) {
          return control.dataset.multiOption === slotId;
        },
      );
    }

    function syncMultiChoice(slotId) {
      var hiddenInputs = widget.querySelectorAll("[data-multi-input]");
      var valuesInputs = widget.querySelectorAll("[data-multi-values-input]");
      var hiddenInput = null;
      var valuesInput = null;

      for (
        var inputIndex = 0;
        inputIndex < hiddenInputs.length;
        inputIndex += 1
      ) {
        if (hiddenInputs[inputIndex].dataset.multiInput === slotId) {
          hiddenInput = hiddenInputs[inputIndex];
          break;
        }
      }

      for (
        var valuesIndex = 0;
        valuesIndex < valuesInputs.length;
        valuesIndex += 1
      ) {
        if (valuesInputs[valuesIndex].dataset.multiValuesInput === slotId) {
          valuesInput = valuesInputs[valuesIndex];
          break;
        }
      }

      if (!hiddenInput) return;

      var controls = getMultiChoiceControls(slotId);
      var selectedControls = controls.filter(function (control) {
        return control.checked && !control.disabled;
      });
      var selectedLabels = selectedControls
        .map(function (control) {
          return String(control.dataset.multiValue || control.value || "");
        })
        .filter(Boolean);
      var selectedValues = selectedControls
        .map(function (control) {
          return String(control.value || "");
        })
        .filter(Boolean);
      var field = hiddenInput.closest("[data-personalize-field]");
      var requiresSelection =
        field &&
        !field.hidden &&
        field.dataset.fieldRequired === "true" &&
        selectedLabels.length === 0;
      var message = requiresSelection
        ? getMessage(
            widget,
            "messageMultiRequired",
            "Please select at least one option.",
          )
        : "";

      hiddenInput.value = selectedLabels.join(" | ");
      if (valuesInput) {
        valuesInput.value = JSON.stringify(selectedValues);
      }
      controls.forEach(function (control, index) {
        control.setCustomValidity(index === 0 ? message : "");
        control.setAttribute("aria-invalid", message ? "true" : "false");
      });
    }

    function syncAllMultiChoices() {
      var initializedSlots = {};

      widget
        .querySelectorAll("[data-multi-option]")
        .forEach(function (control) {
          var slotId = control.dataset.multiOption;
          if (!slotId || initializedSlots[slotId]) return;
          initializedSlots[slotId] = true;
          syncMultiChoice(slotId);
        });
    }

    function getTextRuleTarget(attributeName, slotId) {
      var targets = widget.querySelectorAll("[" + attributeName + "]");

      for (
        var targetIndex = 0;
        targetIndex < targets.length;
        targetIndex += 1
      ) {
        if (targets[targetIndex].getAttribute(attributeName) === slotId) {
          return targets[targetIndex];
        }
      }

      return null;
    }

    function textMatchesCharacterMode(control, value) {
      var mode = control.dataset.textCharacterMode || "all";

      if (mode === "letters") {
        return /^[\p{L}\p{M}\s.'-]*$/u.test(value);
      }
      if (mode === "letters_numbers") {
        return /^[\p{L}\p{M}\p{N}\s.'-]*$/u.test(value);
      }
      if (mode === "numbers") {
        return /^[\p{N}\s.,+-]*$/u.test(value);
      }
      if (mode === "custom") {
        var allowedCharacters = Array.from(
          control.dataset.textAllowedCharacters || "",
        );
        return (
          allowedCharacters.length > 0 &&
          Array.from(value).every(function (character) {
            return allowedCharacters.indexOf(character) >= 0;
          })
        );
      }

      return true;
    }

    function updateTextFieldState(control) {
      var slotId = control.dataset.textRuleInput || "";
      var value = String(control.value || "");
      var minimum = Math.max(0, Number(control.dataset.textMinimum || 0));
      var maximum = Math.max(
        1,
        Number(control.dataset.textMaximum || control.maxLength || 1),
      );
      var forbiddenCharacters = Array.from(
        control.dataset.textForbiddenCharacters || "",
      );
      var customMessage = String(control.dataset.textValidationMessage || "");
      var message = "";

      if (!control.disabled && value.trim() && value.length < minimum) {
        message = getMessage(
          widget,
          "messageTextMinimum",
          "Please enter at least {min} characters.",
        ).replace("{min}", String(minimum));
      } else if (!control.disabled && value.length > maximum) {
        message = getMessage(
          widget,
          "messageTextMaximum",
          "Please use no more than {max} characters.",
        ).replace("{max}", String(maximum));
      } else if (
        !control.disabled &&
        value &&
        (!textMatchesCharacterMode(control, value) ||
          forbiddenCharacters.some(function (character) {
            return value.indexOf(character) >= 0;
          }))
      ) {
        message = getMessage(
          widget,
          "messageTextCharacters",
          "This entry contains unsupported characters.",
        );
      }

      if (message && customMessage) {
        message = customMessage;
      }

      control.setCustomValidity(message);
      control.setAttribute("aria-invalid", message ? "true" : "false");

      var errorTarget = getTextRuleTarget("data-text-validation-error", slotId);
      if (errorTarget) {
        errorTarget.textContent = message;
        errorTarget.hidden = !message;
      }

      var countTarget = getTextRuleTarget("data-text-character-count", slotId);
      if (countTarget) {
        countTarget.textContent = value.length + " / " + maximum;
        countTarget.classList.toggle("is-warning", Boolean(message));
      }
    }

    function syncAllTextFields() {
      widget
        .querySelectorAll("[data-text-rule-input]")
        .forEach(function (control) {
          updateTextFieldState(control);
        });
    }

    function syncConditionalFields() {
      var conditionalFields = widget.querySelectorAll(
        "[data-conditional-depends-on], [data-conditional-rules]",
      );

      syncAllMultiChoices();

      // Repeated passes resolve dependency chains while the editor prevents cycles.
      for (var pass = 0; pass <= conditionalFields.length; pass += 1) {
        conditionalFields.forEach(function (field) {
          setConditionalFieldVisibility(field, conditionMatches(field));
        });
      }

      syncAllMultiChoices();
      syncAllTextFields();
      syncOptionalImageAreas();
      if (!isPersonalizationEnabled()) {
        setPersonalizationControlsEnabled(false);
      }
      refreshMainImageMode();
    }

    function prepareAllSurfaceFieldsForSubmission() {
      if (!isPersonalizationEnabled()) {
        setPersonalizationControlsEnabled(false);
        return;
      }
      widget
        .querySelectorAll("[data-personalize-field]")
        .forEach(function (field) {
          var isAvailable =
            !selectedVariantDisabled &&
            field.dataset.templateExclusiveSuppressed !== "true" &&
            conditionMatches(field);

          field
            .querySelectorAll("input, select, textarea")
            .forEach(function (control) {
              var nestedHiddenAncestor = control.closest("[hidden]");
              var nestedControlIsHidden =
                nestedHiddenAncestor && nestedHiddenAncestor !== field;
              control.disabled = !isAvailable || Boolean(nestedControlIsHidden);

              if (control.dataset.multiOption !== undefined) {
                control.required = false;
              } else if (control.type !== "hidden") {
                control.required =
                  isAvailable && field.dataset.fieldRequired === "true";
              }
            });
        });
    }

    function renderDefinitionParagraph(target, value) {
      var slotId = target.dataset.mainPreviewTextSlot || target.dataset.previewTextSlot || "";
      if (!/^definition-(subtitle|line-[123]|synonyms)$/.test(slotId) ||
          !form || !form.querySelector("definition-editor")) return false;
      function fitTarget(candidate, text) {
        var styles = window.getComputedStyle(candidate);
        var width = parseFloat(styles.width) || candidate.clientWidth;
        var height = parseFloat(styles.height) || candidate.clientHeight;
        if (!(width > 0 && height > 0)) return null;
        var maximum = getStorefrontFontSizePx({fontSizeMm:Number(candidate.dataset.previewFontSizeMm || 3),autoFitText:false},candidate,candidate.dataset.personalizationSurface);
        // Body peers are fitted together on every edit. Reuse unchanged fits
        // instead of repeating 24 metric searches per peer and preview clone.
        // A real glyph sample invalidates the cache when a web font finishes
        // loading, even if its CSS family name has not changed.
        var fontProbe=measureTextMetrics(styles,"MmßgyW.",maximum);
        var fitKey=JSON.stringify([String(text),width,height,maximum,styles.fontFamily,
          styles.fontWeight,styles.fontStyle,styles.letterSpacing,
          fontProbe.width,fontProbe.height,fontProbe.left,fontProbe.right]);
        if (candidate.personalizePilotDefinitionFit && candidate.personalizePilotDefinitionFit.key===fitKey) {
          return candidate.personalizePilotDefinitionFit.value;
        }
        var measure = function(content,size) { return measureTextMetrics(styles,content,size).width; };
        var wrap = function(size) {
        var lines = [];
        String(text).replace(/\r\n?/g,"\n").split("\n").forEach(function(paragraph) {
          var line = "";
          paragraph.trim().split(/\s+/).filter(Boolean).forEach(function(word) {
            if (line && measure(line+" "+word,size) <= width*.94) { line += " "+word; return; }
            if (line) lines.push(line);
            line = "";
            Array.from(word).forEach(function(character) {
              if (line && measure(line+character,size) > width*.94) { lines.push(line); line=""; }
              line+=character;
            });
          });
          lines.push(line);
        });
        return lines;
        };
        var low=Math.min(.2,maximum),high=maximum;
        for(var step=0;step<24;step++) {
          var size=(low+high)/2,lines=wrap(size);
          if(lines.length*size*1.25<=height*.94 && lines.every(function(line){return measure(line,size)<=width*.94;})) low=size;
          else high=size;
        }
        var fittedTarget={styles:styles,width:width,height:height,maximum:maximum,size:low,wrap:wrap};
        candidate.personalizePilotDefinitionFit={key:fitKey,value:fittedTarget};
        return fittedTarget;
      }
      var fitted=fitTarget(target,value);
      if (!fitted) return false;
      var styles=fitted.styles,width=fitted.width,height=fitted.height,low=fitted.size;
      if (/^definition-line-[123]$/.test(slotId)) {
        var ownMm=Number(target.dataset.previewFontSizeMm || 3);
        var commonMm=ownMm*low/fitted.maximum;
        ["definition-line-1","definition-line-2","definition-line-3"].forEach(function(id) {
          var input=widget.querySelector('[data-preview-slot="'+id+'"]');
          if (!input || !String(input.value || "").trim()) return;
          var peer=getTextTargets(id).find(function(candidate) {
            return Boolean(candidate.dataset.mainPreviewTextSlot) === Boolean(target.dataset.mainPreviewTextSlot);
          });
          if (!peer) return;
          var peerFit=fitTarget(peer,input.value);
          if (peerFit) commonMm=Math.min(commonMm,Number(peer.dataset.previewFontSizeMm || 3)*peerFit.size/peerFit.maximum);
        });
        low=fitted.maximum*commonMm/ownMm;
      }
      var result=fitted.wrap(low),ns="http://www.w3.org/2000/svg";
      var definitionEditor=form.querySelector("definition-editor");
      var marieLayout=definitionEditor.dataset.design==="marie-reference-v1";
      var alignment=styles.getPropertyValue("--slot-align").trim() || styles.textAlign;
      var svg=document.createElementNS(ns,"svg");
      svg.dataset.definitionParagraph="true";svg.setAttribute("viewBox","0 0 "+width+" "+height);
      svg.setAttribute("preserveAspectRatio","xMinYMin meet");
      svg.style.cssText="position:absolute;inset:0;width:100%;height:100%;overflow:visible;pointer-events:none";
      result.forEach(function(line,index){
        var metrics=measureTextMetrics(styles,line,low),label=document.createElementNS(ns,"text");
        label.setAttribute("x",String(alignment==="left" ? width*.03+metrics.left : alignment==="right" ? width*.97-metrics.right : width/2+(metrics.left-metrics.right)/2));
        label.setAttribute("y",String((marieLayout ? height*.03+low*.95 : height/2-(result.length-1)*low*1.25/2+low*.34)+index*low*1.25));
        label.setAttribute("fill","currentColor");label.setAttribute("font-size",String(low));
        label.textContent=line;svg.appendChild(label);
      });
      if(marieLayout && slotId==="definition-subtitle") {
        var divider=document.createElementNS(ns,"path");
        divider.dataset.definitionDivider="true";
        var dividerGapEndRatio=Number(definitionEditor.dataset.dividerGapEndRatio);
        var lastLineBottom=height*.03+low*.95+(result.length-1)*low*1.25+measureTextMetrics(styles,result[result.length-1]||"",low).descent;
        var gapEnd=height*dividerGapEndRatio;
        var dividerY=Number.isFinite(dividerGapEndRatio)&&dividerGapEndRatio>1&&dividerGapEndRatio<3&&gapEnd>lastLineBottom
          ? (lastLineBottom+gapEnd)/2-width*.0015 : height*1.4;
        divider.setAttribute("d","M "+width*.03+" "+dividerY+" h "+width*.4+" v "+width*.003+" h "+(-width*.4)+" Z");
        divider.setAttribute("fill","currentColor");svg.appendChild(divider);
      }
      target.replaceChildren(svg);return true;
    }

    function updatePreviewText(target, value, showWhenEmpty) {
      if (!target) {
        return;
      }

      var hasValue = String(value || "").trim().length > 0;
      var nextText = hasValue ? value : "Dein Text";
      var belongsToInactiveSurface = Boolean(
        target.dataset.personalizationSurface &&
        target.dataset.personalizationSurface !== activeSurfaceId,
      );
      if (typeof showWhenEmpty === "boolean") {
        target.dataset.previewHasValue =
          hasValue || showWhenEmpty ? "true" : "false";
        target.hidden =
          belongsToInactiveSurface ||
          !(hasValue || showWhenEmpty) ||
          target.classList.contains("is-conditionally-hidden");
      } else if (belongsToInactiveSurface) {
        target.hidden = true;
      }
      target.dataset.previewTextValue = nextText;
      if (renderDefinitionParagraph(target, nextText)) return;
      target.textContent = nextText;
      target.style.fontSize =
        getAutoFitFontSize(widget, nextText, target) + "px";
      renderGuidedTextCurve(target, nextText);
      renderWarpedTextTarget(target, nextText);
    }

    function renderGuidedTextCurve(target, value) {
      var curve = clampFreeformNumber(
        Number(target.dataset.textCurve || 0),
        -100,
        100,
      );
      target.classList.toggle("is-guided-curved", Math.abs(curve) > 1);
      if (Math.abs(curve) <= 1 || isCurvedSurface(target)) return;

      var svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
      var path = document.createElementNS("http://www.w3.org/2000/svg", "path");
      var textNode = document.createElementNS(
        "http://www.w3.org/2000/svg",
        "text",
      );
      var textPath = document.createElementNS(
        "http://www.w3.org/2000/svg",
        "textPath",
      );
      var rawId =
        target.dataset.mainPreviewTextSlot ||
        target.dataset.previewTextSlot ||
        "text";
      var pathId =
        "personalize-guided-curve-" +
        rawId.replace(/[^a-z0-9_-]/gi, "-") +
        "-" +
        Math.random().toString(36).slice(2, 8);

      svg.setAttribute("viewBox", "0 0 100 44");
      svg.setAttribute("preserveAspectRatio", "xMidYMid meet");
      svg.dataset.guidedCurveSvg = "true";
      path.id = pathId;
      path.setAttribute("d", "M 4 22 Q 50 22 96 22");
      path.setAttribute("fill", "none");
      path.setAttribute("stroke", "none");
      textPath.setAttribute("href", "#" + pathId);
      textPath.setAttribute("startOffset", "50%");
      textPath.setAttribute("text-anchor", "middle");
      textPath.textContent = value;
      textNode.appendChild(textPath);
      svg.appendChild(path);
      svg.appendChild(textNode);
      target.textContent = "";
      target.appendChild(svg);
      updateGuidedCurvedTextSvg(svg, target, value, curve);
    }

    function updatePreviewTextTargets(targets, value, showWhenEmpty) {
      targets.forEach(function (target) {
        updatePreviewText(target, value, showWhenEmpty);
      });
    }

    function getTemplateControl(attributeName, slotId) {
      var controls = widget.querySelectorAll("[" + attributeName + "]");

      for (var index = 0; index < controls.length; index += 1) {
        if (controls[index].getAttribute(attributeName) === slotId) {
          return controls[index];
        }
      }

      return null;
    }

    function getTemplateTextInputs(slotId) {
      return Array.from(widget.querySelectorAll("[data-template-name-input]"))
        .filter(function (input) {
          return input.dataset.templateOwnerSlot === slotId;
        })
        .sort(function (left, right) {
          return (
            Number(left.dataset.templateTextIndex || 0) -
            Number(right.dataset.templateTextIndex || 0)
          );
        });
    }

    function ensureCustomerModeSwitch(picker) {
      if (!picker || picker.dataset.templateExclusiveMode === "false") return;
      var slotId = picker.dataset.templatePicker || "";
      var templateCount = Array.from(templateOptionButtons).filter(
        function (button) {
          return button.dataset.templateOption === slotId;
        },
      ).length;
      var hasCustomerImageSlot = Array.from(
        widget.querySelectorAll("[data-personalization-slot-container]"),
      ).some(function (container) {
        return (
          container.dataset.personalizationSlotContainer !== slotId &&
          Boolean(
            container.querySelector('input[type="file"][data-file-input]'),
          )
        );
      });
      if (templateCount <= 1 || !hasCustomerImageSlot) return;

      var fieldset = document.createElement("fieldset");
      var legend = document.createElement("legend");
      var buttonGroup = document.createElement("div");
      var templateButton = document.createElement("button");
      var customButton = document.createElement("button");
      var help = document.createElement("small");
      var input = document.createElement("input");

      fieldset.className = "personalize-pilot-widget__customer-mode";
      fieldset.dataset.personalizationModeSwitch = slotId;
      legend.textContent = getMessage(
        widget,
        "messageCustomerModeLegend",
        "Wie möchtest du gestalten?",
      );
      templateButton.type = "button";
      templateButton.dataset.personalizationModeOption = "template";
      templateButton.setAttribute("aria-pressed", "true");
      templateButton.textContent = getMessage(
        widget,
        "messageCustomerModeTemplate",
        "Vorlage verwenden",
      );
      customButton.type = "button";
      customButton.dataset.personalizationModeOption = "custom";
      customButton.setAttribute("aria-pressed", "false");
      customButton.textContent = getMessage(
        widget,
        "messageCustomerModeCustom",
        "Eigenes Foto",
      );
      help.dataset.personalizationModeHelp = "true";
      help.textContent = getMessage(
        widget,
        "messageCustomerModeTemplateHelp",
        "Wähle ein Design und ergänze nur die vorgesehenen Texte.",
      );
      input.type = "hidden";
      input.name = "properties[_personalize_pilot_customer_mode]";
      input.value = "template";
      input.dataset.personalizationModeInput = slotId;
      buttonGroup.appendChild(templateButton);
      buttonGroup.appendChild(customButton);
      fieldset.appendChild(legend);
      fieldset.appendChild(buttonGroup);
      fieldset.appendChild(help);
      fieldset.appendChild(input);
      picker.insertBefore(fieldset, picker.firstChild);

      Array.from(picker.children).some(function (child) {
        if (child.tagName !== "SPAN") return false;
        child.dataset.templatePickerLabel = "true";
        return true;
      });
    }

    function getTemplateTextFields(button, fallbackLayout, nameEnabled) {
      if (!nameEnabled) return [];

      var fields = [];
      try {
        var parsed = JSON.parse(button.dataset.templateTextFields || "null");
        if (Array.isArray(parsed)) fields = parsed.slice(0, 3);
      } catch (error) {
        fields = [];
      }

      if (fields.length === 0 && nameEnabled) {
        fields = [
          {
            id: "template-text-1",
            label: button.dataset.templateLegacyLabel || "Dein Name",
            placeholder:
              button.dataset.templateLegacyPlaceholder || "Name eingeben",
            helpText: button.dataset.templateLegacyHelp || "",
            required: button.dataset.templateLegacyRequired === "true",
            maxCharacters: Number(button.dataset.templateLegacyMax || 30) || 30,
            layout: fallbackLayout,
          },
        ];
      }

      return fields.map(function (field, index) {
        return {
          id: field.id || "template-text-" + (index + 1),
          label: field.label || "Text " + (index + 1),
          placeholder: field.placeholder || "Text " + (index + 1) + " eingeben",
          helpText: field.helpText || "",
          required: field.required === true,
          maxCharacters: Math.max(
            1,
            Math.min(120, Number(field.maxCharacters) || 30),
          ),
          layout: field.layout || fallbackLayout || {},
          font: field.font || button.dataset.templateFont || "",
          textColor:
            field.textColor || button.dataset.templateColor || "#111827",
        };
      });
    }

    function rememberTemplateExclusiveState(control) {
      if (control.dataset.templateExclusiveOriginalDisabled === undefined) {
        control.dataset.templateExclusiveOriginalDisabled = control.disabled
          ? "true"
          : "false";
      }
      if (control.dataset.templateExclusiveOriginalRequired === undefined) {
        control.dataset.templateExclusiveOriginalRequired = control.required
          ? "true"
          : "false";
      }
    }

    function restoreTemplateExclusiveState(control) {
      control.disabled =
        control.dataset.templateExclusiveOriginalDisabled === "true";
      control.required =
        control.dataset.templateExclusiveOriginalRequired === "true";
      delete control.dataset.customerModeRequired;
    }

    function setTemplateSubmissionEnabled(slotId, enabled) {
      [
        "data-template-label-input",
        "data-template-value-input",
        "data-template-preview-input",
        "data-template-source-input",
        "data-template-layout-input",
        "data-template-price-input",
      ].forEach(function (attributeName) {
        var control = getTemplateControl(attributeName, slotId);
        if (!control) return;
        rememberTemplateExclusiveState(control);
        control.disabled = !enabled;
        if (!enabled) control.value = "";
      });

      getTemplateTextInputs(slotId).forEach(function (input) {
        rememberTemplateExclusiveState(input);
        input.disabled = !enabled;
        input.required =
          enabled && input.dataset.templateNameRequired === "true";
        if (!enabled) input.value = "";
      });
    }

    function updateCustomerModeUi(picker, mode) {
      if (!picker) return;
      var slotId = picker.dataset.templatePicker || "";
      var customMode = mode === "custom";
      var modeSwitch = getTemplateControl(
        "data-personalization-mode-switch",
        slotId,
      );
      var modeInput = getTemplateControl(
        "data-personalization-mode-input",
        slotId,
      );
      var templateGrid = picker.querySelector(
        ".personalize-pilot-widget__template-grid",
      );
      var templateLabel = picker.querySelector("[data-template-picker-label]");
      var templateTextContainer = picker.querySelector(
        "[data-template-text-fields-container]",
      );

      picker.dataset.customerMode = customMode ? "custom" : "template";
      if (modeInput) modeInput.value = customMode ? "custom" : "template";
      if (modeSwitch) {
        modeSwitch
          .querySelectorAll("[data-personalization-mode-option]")
          .forEach(function (button) {
            button.setAttribute(
              "aria-pressed",
              button.dataset.personalizationModeOption ===
                (customMode ? "custom" : "template")
                ? "true"
                : "false",
            );
          });
        var help = modeSwitch.querySelector("[data-personalization-mode-help]");
        if (help) {
          help.textContent = customMode
            ? getMessage(
                widget,
                "messageCustomerModeCustomHelp",
                "Lade dein eigenes Foto hoch. Es wird vollständig und proportional in die vorgesehene Fläche eingepasst.",
              )
            : getMessage(
                widget,
                "messageCustomerModeTemplateHelp",
                "Wähle ein Design und ergänze nur die vorgesehenen Texte.",
              );
        }
      }
      if (templateGrid) templateGrid.hidden = customMode;
      if (templateLabel) templateLabel.hidden = customMode;
      if (templateTextContainer) templateTextContainer.hidden = customMode;
      setTemplateSubmissionEnabled(slotId, !customMode);
    }

    function restoreNonTemplateSlots(slotId) {
      var firstImageInput = null;

      widget
        .querySelectorAll("[data-personalization-slot-container]")
        .forEach(function (container) {
          var otherSlotId =
            container.dataset.personalizationSlotContainer || "";
          if (otherSlotId === slotId) return;

          delete container.dataset.templateExclusiveSuppressed;
          container.hidden =
            container.dataset.templateExclusiveOriginalHidden === "true";
          container
            .querySelectorAll("input, select, textarea")
            .forEach(function (control) {
              restoreTemplateExclusiveState(control);
              if (
                !firstImageInput &&
                control.type === "file" &&
                !control.disabled
              ) {
                firstImageInput = control;
              }
            });

          getTextTargets(otherSlotId)
            .concat(getImageTargets(otherSlotId))
            .forEach(function (target) {
              delete target.dataset.templateExclusiveSuppressed;
            });
        });

      if (firstImageInput) {
        firstImageInput.required = true;
        firstImageInput.dataset.customerModeRequired = "true";
      }

      var freeformEditor = widget.querySelector("[data-freeform-editor]");
      if (freeformEditor) {
        freeformEditor.hidden =
          freeformEditor.dataset.templateExclusiveOriginalHidden === "true";
      }
    }

    function activateCustomMode(slotId, picker) {
      if (!picker || picker.dataset.templateExclusiveMode === "false") return;
      var selectedButton = Array.from(templateOptionButtons).find(
        function (button) {
          return (
            button.dataset.templateOption === slotId &&
            button.getAttribute("aria-pressed") === "true"
          );
        },
      );
      if (selectedButton) {
        picker.dataset.templateLastValue =
          selectedButton.dataset.templateValue || "";
      }

      updateCustomerModeUi(picker, "custom");
      templateOptionButtons.forEach(function (button) {
        if (button.dataset.templateOption === slotId) {
          button.setAttribute("aria-pressed", "false");
        }
      });
      getTemplateTextInputs(slotId).forEach(function (input) {
        input.dispatchEvent(new Event("input", { bubbles: true }));
      });
      getImageTargets(slotId).forEach(function (target) {
        target.dataset.templateExclusiveSuppressed = "true";
        updateImagePreviewTarget(target, "");
        target.hidden = true;
      });
      restoreNonTemplateSlots(slotId);
      syncConditionalFields();
      refreshMainImageMode();
      scheduleMainImagePreviewRefresh();
    }

    function activateTemplateMode(slotId, picker) {
      if (!picker) return;
      updateCustomerModeUi(picker, "template");
      var lastValue = picker.dataset.templateLastValue || "";
      var candidates = Array.from(templateOptionButtons).filter(
        function (button) {
          return button.dataset.templateOption === slotId;
        },
      );
      var selectedButton =
        candidates.find(function (button) {
          return button.dataset.templateValue === lastValue;
        }) ||
        candidates.find(function (button) {
          return button.dataset.templateDefault === "true";
        }) ||
        candidates[0];
      if (selectedButton) applyTemplateOption(selectedButton, true);
      syncConditionalFields();
      refreshMainImageMode();
      scheduleMainImagePreviewRefresh();
    }

    function activateTemplateExclusiveMode(slotId, picker) {
      if (!picker || picker.dataset.templateExclusiveMode === "false") return;

      updateCustomerModeUi(picker, "template");

      widget
        .querySelectorAll("[data-personalization-slot-container]")
        .forEach(function (container) {
          var otherSlotId =
            container.dataset.personalizationSlotContainer || "";
          if (otherSlotId === slotId) {
            delete container.dataset.templateExclusiveSuppressed;
            getTextTargets(otherSlotId)
              .concat(getImageTargets(otherSlotId))
              .forEach(function (target) {
                delete target.dataset.templateExclusiveSuppressed;
              });
            return;
          }

          if (container.dataset.templateExclusiveOriginalHidden === undefined) {
            container.dataset.templateExclusiveOriginalHidden = container.hidden
              ? "true"
              : "false";
          }
          container.dataset.templateExclusiveSuppressed = "true";
          container.hidden = true;
          container
            .querySelectorAll("input, select, textarea")
            .forEach(function (control) {
              rememberTemplateExclusiveState(control);
              if (control.dataset.customerModeRequired === "true") {
                control.required = false;
                delete control.dataset.customerModeRequired;
              }
              if (control.type === "file") {
                control.value = "";
                control.dispatchEvent(new Event("change", { bubbles: true }));
              } else if (
                control.type === "checkbox" ||
                control.type === "radio"
              ) {
                control.checked = false;
              } else if (control.tagName === "SELECT") {
                control.selectedIndex = 0;
              } else {
                control.value = "";
              }
              control.disabled = true;
            });

          getTextTargets(otherSlotId).forEach(function (target) {
            target.dataset.templateExclusiveSuppressed = "true";
            updatePreviewText(target, "", false);
            target.hidden = true;
          });
          getImageTargets(otherSlotId).forEach(function (target) {
            target.dataset.templateExclusiveSuppressed = "true";
            updateImagePreviewTarget(target, "");
            target.hidden = true;
          });
        });

      freeformItems = [];
      resetFreeformHistory();
      renderFreeformEditor();
      var freeformEditor = widget.querySelector("[data-freeform-editor]");
      if (freeformEditor) {
        if (
          freeformEditor.dataset.templateExclusiveOriginalHidden === undefined
        ) {
          freeformEditor.dataset.templateExclusiveOriginalHidden =
            freeformEditor.hidden ? "true" : "false";
        }
        freeformEditor.hidden = true;
      }
    }

    function syncMirroredTemplateSlots(sourceSlotId, templateValue) {
      if (!sourceSlotId || !templateValue) return;

      widget
        .querySelectorAll(
          '[data-template-mirror]:not([data-template-mirror=""])',
        )
        .forEach(function (mirrorPicker) {
          if (mirrorPicker.dataset.templateMirror !== sourceSlotId) {
            return;
          }

          var mirrorSlotId = mirrorPicker.dataset.templatePicker || "";
          var mirrorButton = Array.from(templateOptionButtons).find(
            function (candidate) {
              return (
                candidate.dataset.templateOption === mirrorSlotId &&
                candidate.dataset.templateValue === templateValue
              );
            },
          );
          if (!mirrorButton) return;

          applyTemplateOption(mirrorButton, false);
        });
    }

    function applyTemplateOption(button, markInteraction) {
      var slotId = button.dataset.templateOption || "";
      var imageUrl = button.dataset.templateImage || "";
      var sourceUrl = button.dataset.templateSource || imageUrl;
      var nameEnabled = button.dataset.templateNameEnabled !== "false";
      var layout = {};
      var designLayout = {};
      var labelInput = getTemplateControl("data-template-label-input", slotId);
      var valueInput = getTemplateControl("data-template-value-input", slotId);
      var previewInput = getTemplateControl(
        "data-template-preview-input",
        slotId,
      );
      var sourceInput = getTemplateControl(
        "data-template-source-input",
        slotId,
      );
      var unpersonalizedInput = getTemplateControl(
        "data-template-unpersonalized-input",
        slotId,
      );
      var layoutInput = getTemplateControl(
        "data-template-layout-input",
        slotId,
      );
      var priceInput = getTemplateControl("data-template-price-input", slotId);
      var priceDisplay = getTemplateControl(
        "data-template-price-display",
        slotId,
      );
      var picker = getTemplateControl("data-template-picker", slotId);

      if (picker)
        picker.dataset.templateLastValue = button.dataset.templateValue || "";

      try {
        layout = JSON.parse(button.dataset.templateLayout || "{}");
      } catch (error) {
        layout = {};
      }

      try {
        designLayout = JSON.parse(button.dataset.templateDesignLayout || "{}");
      } catch (error) {
        designLayout = {};
      }

      var templateTextFields = getTemplateTextFields(
        button,
        layout,
        nameEnabled,
      );
      var templateTextInputs = getTemplateTextInputs(slotId);

      templateOptionButtons.forEach(function (optionButton) {
        if (optionButton.dataset.templateOption === slotId) {
          optionButton.setAttribute(
            "aria-pressed",
            optionButton === button ? "true" : "false",
          );
        }
      });

      if (labelInput) labelInput.value = button.dataset.templateLabel || "";
      if (valueInput) valueInput.value = button.dataset.templateValue || "";
      if (previewInput) previewInput.value = imageUrl;
      if (sourceInput) sourceInput.value = sourceUrl;
      if (unpersonalizedInput) {
        unpersonalizedInput.value =
          button.dataset.templateUnpersonalizedImage || "";
      }
      if (layoutInput) layoutInput.value = JSON.stringify(designLayout);
      if (priceInput) priceInput.value = button.dataset.templatePrice || "0";
      if (picker && markInteraction)
        picker.dataset.templateUserSelected = "true";
      activateTemplateExclusiveMode(slotId, picker);

      var designSurfaceId = button.dataset.templateSurfaceId || activeSurfaceId;
      var canonicalStageAspectRatio =
        getCanonicalProductPreviewStageAspectRatio();
      var previewDesignLayout = getCanonicalTemplateArtworkLayout(
        designLayout,
        designSurfaceId,
        canonicalStageAspectRatio,
      );
      var persistedDesignLayout = previewDesignLayout;
      getImageTargets(slotId).forEach(function (target) {
        target.dataset.templateSourceLayout = JSON.stringify(designLayout);
        target.dataset.templateSourceSurface = designSurfaceId;
        applyCanonicalTemplateArtworkBaseGeometry(
          target,
          previewDesignLayout,
          canonicalStageAspectRatio,
        );
        target.dataset.templateArtworkAspectRatio = String(
          Number(button.dataset.templateArtworkAspectRatio) || 0,
        );
        target.dataset.templateProductionFitMode =
          button.dataset.templateProductionFitMode === "stretch"
            ? "stretch"
            : "contain";
        target.dataset.templateLockAspectRatio =
          button.dataset.templateLockAspectRatio || "legacy";
        target.dataset.templatePersonalizedImage = imageUrl;
        target.dataset.templateUnpersonalizedImage =
          button.dataset.templateUnpersonalizedImage || "";
        target.dataset.imageFit =
          target.dataset.templateProductionFitMode === "stretch"
            ? "stretch"
            : "contain";
        target.dataset.imageScalePercent = "100";
        target.dataset.imageShapeSafeFactor = "100";
        target.dataset.surfaceMode = previewDesignLayout.surfaceMode || "flat";
        target.dataset.surfaceIntensity = String(
          Number(previewDesignLayout.surfaceIntensity) || 0,
        );
        target.dataset.previewTone = getMaterialPreviewTone(
          previewDesignLayout.previewTone,
        );
        target.style.setProperty(
          "--slot-image-fit",
          target.dataset.imageFit === "stretch" ? "fill" : "contain",
        );
        target.style.setProperty("--slot-image-scale", "100%");
        target.style.setProperty("--slot-image-scale-factor", "1");
        applyConfiguredImageFit(target);
        updateImagePreviewTarget(
          target,
          isPersonalizationEnabled()
            ? imageUrl
            : button.dataset.templateUnpersonalizedImage || imageUrl,
        );
      });
      if (layoutInput) {
        layoutInput.value = JSON.stringify(persistedDesignLayout);
      }

      for (var textIndex = 0; textIndex < 3; textIndex += 1) {
        var field = templateTextFields[textIndex];
        var textInput = templateTextInputs[textIndex];
        var previewSlotId = slotId + "::" + textIndex;
        var textTargets = getTextTargets(previewSlotId);
        var wrapper = textInput
          ? textInput.closest("[data-template-text-wrapper]")
          : null;

        if (!field) {
          if (wrapper) wrapper.hidden = true;
          if (textInput) {
            textInput.value = "";
            textInput.disabled = true;
            textInput.required = false;
          }
          textTargets.forEach(function (target) {
            updatePreviewText(target, "", false);
            target.dataset.templateNameEnabled = "false";
            target.hidden = true;
          });
          continue;
        }

        var fieldLayout = field.layout || {};
        if (wrapper) {
          wrapper.hidden = false;
          var fieldLabel = wrapper.querySelector("[data-template-text-label]");
          var fieldHelp = wrapper.querySelector("[data-template-text-help]");
          if (fieldLabel) {
            fieldLabel.textContent = field.label + (field.required ? " *" : "");
          }
          if (fieldHelp) {
            fieldHelp.textContent = field.helpText || "";
            fieldHelp.hidden = !field.helpText;
          }
        }
        if (textInput) {
          if (markInteraction) textInput.value = "";
          textInput.disabled = false;
          textInput.required = field.required;
          textInput.dataset.templateNameRequired = field.required
            ? "true"
            : "false";
          textInput.name = "properties[" + field.label + "]";
          textInput.placeholder = field.placeholder;
          textInput.maxLength = field.maxCharacters;
        }

        textTargets.forEach(function (target) {
          var targetSurfaceId =
            target.dataset.personalizationSurface ||
            button.dataset.templateSurfaceId ||
            activeSurfaceId;
          target.dataset.templateOwnedText = "true";
          target.dataset.templateArtworkAspectRatio = String(
            Number(button.dataset.templateArtworkAspectRatio) || 0,
          );
          target.dataset.templateProductionFitMode =
            button.dataset.templateProductionFitMode === "stretch"
              ? "stretch"
              : "contain";
          target.dataset.templateArtworkLayout = JSON.stringify(designLayout);
          var previewFieldLayout = applyResolvedTextLayout(
            target,
            fieldLayout,
            targetSurfaceId,
          );
          target.dataset.autoFitText =
            fieldLayout.autoFitText === false ? "false" : "true";
          target.dataset.allowLineBreaks =
            fieldLayout.allowLineBreaks === true ? "true" : "false";
          target.dataset.textCurve = String(
            clampFreeformNumber(Number(fieldLayout.textCurve || 0), -100, 100),
          );
          target.dataset.surfaceMode = fieldLayout.surfaceMode || "flat";
          target.dataset.surfaceIntensity = String(
            Number(fieldLayout.surfaceIntensity) || 0,
          );
          target.dataset.previewTone = getMaterialPreviewTone(
            fieldLayout.previewTone,
          );
          target.dataset.templateNameEnabled = "true";
          target.dataset.textWidth = String(
            Number(previewFieldLayout.width) || 70,
          );
          var selectedFieldFont =
            (fontInput && fontInput.value) || field.font || "";
          target.style.fontFamily = getPreviewFontFamily(selectedFieldFont);
          target.style.fontWeight = getPreviewFontWeight(selectedFieldFont);
          target.style.color =
            target.dataset.previewTone === "acrylic-light"
              ? "#fff7df"
              : field.textColor || "#111827";
          updatePreviewText(target, textInput ? textInput.value : "", false);
        });
        resetCustomerSlotBaseLayout(
          previewSlotId,
          fieldLayout,
          button.dataset.templateSurfaceId || activeSurfaceId,
        );
      }

      if (priceDisplay) {
        var price = Number(button.dataset.templatePrice || "0");
        priceDisplay.hidden = !(price > 0);
        priceDisplay.replaceChildren();
        if (price > 0) {
          var priceLabel = document.createTextNode(
            "Kalkulationsaufschlag dieses Designs: ",
          );
          var priceAmount = document.createElement("span");
          priceAmount.className = "personalize-pilot-widget__money-amount";
          priceAmount.textContent =
            "+" + formatStorefrontMoney(Math.round(price * 100));
          priceDisplay.append(priceLabel, priceAmount);
        }
      }

      refreshMainImageMode();
      syncMirroredTemplateSlots(slotId, button.dataset.templateValue || "");
    }

    function updateImagePreviewTarget(target, src) {
      var image = target ? target.querySelector("img") : null;
      var label = target ? target.querySelector("span") : null;

      if (!image) {
        return;
      }

      if (!src) {
        image.hidden = true;
        image.removeAttribute("src");
        if (label) {
          label.hidden = false;
        }
        renderWarpedImageTarget(target);
        return;
      }

      target.dataset.previewImageRequest = src;
      image.hidden = false;
      if (label) {
        label.hidden = true;
      }

      function applyImageSource(nextSource) {
        var refreshGeometry = function () {
          syncTemplateArtworkGeometry(target);
          renderWarpedImageTarget(target);
        };

        image.addEventListener("load", refreshGeometry, { once: true });
        image.src = nextSource;
        if (image.complete && image.naturalWidth) {
          refreshGeometry();
        }
      }

      applyImageSource(src);

      if (target.dataset.templateArtworkPreview === "true") {
        getTransparentTemplatePreviewUrl(src).then(function (previewUrl) {
          if (!previewUrl || target.dataset.previewImageRequest !== src) {
            return;
          }
          applyImageSource(previewUrl);
        });
      }
    }

    function applySelectedPreviewFont(fontValue, requestId) {
      if (requestId !== fontUpdateRequest || !fontInput) {
        return;
      }

      var fontFamily = getPreviewFontFamily(fontValue);
      var fontWeight = getPreviewFontWeight(fontValue);

      delete widget.dataset.previewFontLoading;
      widget.dataset.previewFontValue = fontValue;

      Object.keys(textPreviewTargets).forEach(function (slotId) {
        getTextTargets(slotId).forEach(function (target) {
          if (
            target.dataset.templatePreview === "true" &&
            target.dataset.templateNameEnabled !== "true"
          ) {
            return;
          }
          target.dataset.previewFontValue = fontValue;
          target.style.fontFamily = fontFamily;
          target.style.fontWeight = fontWeight;
          updatePreviewText(
            target,
            target.dataset.previewTextValue || target.textContent,
          );
        });
      });

      if (previewText) {
        [previewText, mainImagePreview.previewText]
          .filter(Boolean)
          .forEach(function (target) {
            target.dataset.previewFontValue = fontValue;
            target.style.fontFamily = fontFamily;
            target.style.fontWeight = fontWeight;
            updatePreviewText(
              target,
              primaryTextInput
                ? primaryTextInput.value
                : target.dataset.previewTextValue || target.textContent,
            );
          });
      }
      freeformItems.forEach(syncFreeformItem);
      if (typeof widget.personalizePilotSyncFollowers === "function") {
        widget.personalizePilotSyncFollowers();
      }
      if (!syncCurrentMobilePreviewText()) {
        scheduleMobileLivePreviewRefresh();
      }
    }

    function updatePreviewFont() {
      if (!fontInput) {
        return;
      }

      var fontValue = String(fontInput.value || "");
      var requestId = ++fontUpdateRequest;
      var applyFont = function () {
        applySelectedPreviewFont(fontValue, requestId);
      };

      // Reflect the customer's selection immediately. Loading the webfont is a
      // second, metric-stabilising pass and must never block the visible change.
      applyFont();

      if (document.fonts && typeof document.fonts.load === "function") {
        widget.dataset.previewFontLoading = "true";
        document.fonts
          .load("16px " + getPreviewFontFamily(fontValue), "Oma Aa 123")
          .then(applyFont, applyFont);
      }
    }

    function updateFontSamples() {
      var sampleText =
        String((customerNameInput && customerNameInput.value) || "").trim() ||
        widget.dataset.fontSampleDefault ||
        "Dein Name";
      var sampleSize =
        sampleText.length > 24
          ? "13px"
          : sampleText.length > 18
            ? "15px"
            : sampleText.length > 12
              ? "18px"
              : "22px";

      fontOptionButtons.forEach(function (button) {
        var fontValue = button.dataset.fontValue || "";
        var sample = button.querySelector("[data-font-sample]");

        if (!sample) return;
        sample.textContent = sampleText;
        sample.style.fontFamily = getPreviewFontFamily(fontValue);
        sample.style.fontWeight = getPreviewFontWeight(fontValue);
        sample.style.fontSize = sampleSize;
      });
    }

    function updateUploadCount() {
      if (!uploadCountInput) {
        return;
      }

      var count = 0;
      widget.querySelectorAll('input[type="file"]').forEach(function (input) {
        if (!input.disabled && input.files && input.files.length > 0) {
          count += input.files.length;
        }
      });
      uploadCountInput.value = String(count);
    }

    function syncTextInputsToPreview() {
      widget.querySelectorAll("[data-preview-slot]").forEach(function (input) {
        var slotId = input.dataset.previewSlot;
        var targets = getTextTargets(slotId);

        if (targets.length === 0) {
          return;
        }

        updatePreviewTextTargets(targets, input.value, false);
      });

      if (primaryTextInput && previewText) {
        updatePreviewTextTargets(
          [previewText, mainImagePreview.previewText].filter(Boolean),
          primaryTextInput.value,
          false,
        );
      }

      updateFontSamples();
    }

    function syncImageInputsToPreview() {
      widget
        .querySelectorAll("[data-file-preview-slot]")
        .forEach(function (input) {
          var slotId = input.dataset.filePreviewSlot;
          var previewUrl =
            input.dataset.previewPrivateUrl ||
            input.dataset.previewObjectUrl ||
            "";

          getImageTargets(slotId).forEach(function (target) {
            applyConfiguredImageFit(target);
            updateImagePreviewTarget(target, previewUrl);
          });
        });

      if (
        primaryImageInput &&
        (primaryImageInput.dataset.previewPrivateUrl ||
          primaryImageInput.dataset.previewObjectUrl) &&
        mainImagePreview.previewImage
      ) {
        mainImagePreview.previewImage.src =
          primaryImageInput.dataset.previewPrivateUrl ||
          primaryImageInput.dataset.previewObjectUrl;
        mainImagePreview.previewImage.hidden = false;
      }

      syncImageScaleControlsToPreview();
    }

    function refreshMainImageMode() {
      // Variant initialization runs before the preview surface exists.
      // The regular final synchronization renders the preview once it is ready.
      if (!mainImagePreview) return;
      var isPersonalizing =
        isPersonalizationEnabled() && hasActivePersonalizationInput(widget);
      var showsComposedPreview = shouldShowComposedProductPreview(widget);
      var gallery = mainImagePreview.surface
        ? mainImagePreview.surface.closest(
            "[data-product-gallery], .product-gallery, media-gallery",
          )
        : null;
      var status = gallery
        ? gallery.querySelector("[data-personalize-pilot-preview-status]")
        : null;

      widget.classList.toggle("is-personalizing", isPersonalizing);
      widget.dataset.personalizePilotPreviewMode = showsComposedPreview
        ? isPersonalizationEnabled()
          ? "blank"
          : "standard"
        : "finished";

      if (mainImagePreview.overlay) {
        mainImagePreview.overlay.hidden = !showsComposedPreview;
        mainImagePreview.overlay.classList.toggle(
          "is-active",
          showsComposedPreview,
        );
        syncMainPreviewSurfaceVisibility();
      }

      if (mainImagePreview.surface) {
        mainImagePreview.surface.dataset.personalizePilotPreviewMode =
          showsComposedPreview
            ? isPersonalizationEnabled()
              ? "blank"
              : "standard"
            : "finished";
        applyMainImageToProductMedia(
          widget,
          mainImagePreview.surface,
          showsComposedPreview,
        );

        if (mainImagePreview.overlay) {
          scheduleMainImagePreviewOverlayPosition(
            mainImagePreview.surface,
            mainImagePreview.overlay,
            widget,
          );
        }
      }

      if (gallery) {
        gallery.classList.toggle("is-personalizing", showsComposedPreview);
        gallery
          .querySelectorAll("[data-product-gallery-thumb]")
          .forEach(function (thumb) {
            thumb.setAttribute(
              "aria-disabled",
              showsComposedPreview ? "true" : "false",
            );
          });
      }

      if (status) {
        status.hidden = !isPersonalizing;
        status.textContent = isPersonalizing
          ? "Live-Vorschau · deine Eingabe"
          : "";
      }

      scheduleMobileLivePreviewRefresh();
    }

    function refreshWarpedPreviewTargets() {
      Object.keys(textPreviewTargets).forEach(function (slotId) {
        getTextTargets(slotId).forEach(renderWarpedPreviewTarget);
      });
      Object.keys(imagePreviewTargets).forEach(function (slotId) {
        getImageTargets(slotId).forEach(renderWarpedPreviewTarget);
      });
    }

    function refreshMainImagePreview() {
      var nextMainImagePreview = createMainImagePreview(
        widget,
        textPreviewTargets,
        imagePreviewTargets,
        previewText,
        previewImage,
      );

      if (!nextMainImagePreview.overlay) {
        return;
      }

      mainImagePreview = nextMainImagePreview;
      previewRefreshAttempts = 0;
      syncConfiguredTextLayouts();
      syncAllPreviewTextFontSizes();
      syncMainPreviewSurfaceVisibility();
      syncTextInputsToPreview();
      syncImageInputsToPreview();
      refreshPhotoCrops();
      updatePreviewFont();
      refreshWarpedPreviewTargets();
      refreshFreeformPreviewTargets();
      refreshCustomerSlotLayouts();
      syncConditionalFields();
      applyMaterialPreview();
      applyLightingPreview();
      refreshMainImageMode();
    }

    function scheduleMainImagePreviewRefresh() {
      window.clearTimeout(previewRefreshTimer);
      previewRefreshTimer = window.setTimeout(
        function () {
          previewRefreshAttempts += 1;
          refreshMainImagePreview();

          if (
            (!mainImagePreview.overlay ||
              !mainImagePreview.overlay.isConnected) &&
            previewRefreshAttempts < 12
          ) {
            scheduleMainImagePreviewRefresh();
          }
        },
        previewRefreshAttempts < 4 ? 250 : 700,
      );
    }

    widget.personalizePilotRefresh = scheduleMainImagePreviewRefresh;

    widget
      .querySelectorAll("[data-personalization-surface-button]")
      .forEach(function (button) {
        button.addEventListener("click", function () {
          applySurfaceConfiguration(
            button.dataset.personalizationSurfaceButton || "front",
          );
          renderFreeformEditor();
          syncConditionalFields();
          refreshMainImageMode();
          scheduleMainImagePreviewRefresh();
        });
      });

    widget
      .querySelectorAll("[data-template-picker]")
      .forEach(function (picker) {
        ensureCustomerModeSwitch(picker);
      });

    templateOptionButtons.forEach(function (button) {
      button.addEventListener("click", function () {
        applyTemplateOption(button, true);
        button.dispatchEvent(new Event("change", { bubbles: true }));
        syncConditionalFields();
      });
    });

    widget
      .querySelectorAll("[data-personalization-mode-switch]")
      .forEach(function (modeSwitch) {
        var slotId = modeSwitch.dataset.personalizationModeSwitch || "";
        var picker = getTemplateControl("data-template-picker", slotId);
        var modeInput = getTemplateControl(
          "data-personalization-mode-input",
          slotId,
        );

        modeSwitch
          .querySelectorAll("[data-personalization-mode-option]")
          .forEach(function (button) {
            button.addEventListener("click", function () {
              if (button.dataset.personalizationModeOption === "custom") {
                activateCustomMode(slotId, picker);
              } else {
                activateTemplateMode(slotId, picker);
              }
            });
          });

        if (modeInput) {
          modeInput.addEventListener("change", function () {
            if (modeInput.value === "custom") {
              activateCustomMode(slotId, picker);
            } else if (picker && picker.dataset.customerMode !== "template") {
              activateTemplateMode(slotId, picker);
            }
          });
        }
      });

    widget
      .querySelectorAll("[data-template-categories]")
      .forEach(function (categoryBar) {
        var slotId = categoryBar.dataset.templateCategories || "";
        var seenCategories = new Set();
        var categoryButtons = categoryBar.querySelectorAll(
          "[data-template-category-filter]",
        );

        categoryButtons.forEach(function (button) {
          var category = button.dataset.templateCategoryFilter || "Allgemein";
          var normalized = category.toLocaleLowerCase();
          if (seenCategories.has(normalized)) {
            button.remove();
          } else {
            seenCategories.add(normalized);
          }
        });

        categoryBar
          .querySelectorAll("[data-template-category-filter]")
          .forEach(function (button) {
            button.addEventListener("click", function () {
              var category = button.dataset.templateCategoryFilter || "all";
              categoryBar
                .querySelectorAll("[data-template-category-filter]")
                .forEach(function (candidate) {
                  candidate.setAttribute(
                    "aria-pressed",
                    candidate === button ? "true" : "false",
                  );
                });
              templateOptionButtons.forEach(function (optionButton) {
                if (optionButton.dataset.templateOption !== slotId) return;
                optionButton.hidden =
                  category !== "all" &&
                  optionButton.dataset.templateCategory !== category;
              });
            });
          });

        var optionCount = Array.from(templateOptionButtons).filter(
          function (button) {
            return button.dataset.templateOption === slotId;
          },
        ).length;
        if (
          optionCount <= 2 ||
          categoryBar.querySelectorAll("[data-template-category-filter]")
            .length <= 2
        ) {
          categoryBar.hidden = true;
        }
      });

    templateOptionButtons.forEach(function (button) {
      if (button.getAttribute("aria-pressed") === "true") {
        applyTemplateOption(button, false);
      }
    });

    widget
      .querySelectorAll("[data-template-name-input]")
      .forEach(function (input) {
        var slotId = input.dataset.templateNameInput || "";
        var characterCount = getTemplateControl(
          "data-template-character-count",
          slotId,
        );

        function updateTemplateNameCount() {
          if (!characterCount) return;
          characterCount.textContent =
            Math.max(
              0,
              Number(input.maxLength || 0) - String(input.value || "").length,
            ) + " Zeichen übrig";
        }

        input.addEventListener("input", updateTemplateNameCount);
        input.addEventListener("blur", function () {
          var trimmedValue = String(input.value || "").trim();
          if (trimmedValue !== input.value) {
            input.value = trimmedValue;
            input.dispatchEvent(new Event("input", { bubbles: true }));
          }
          updateTemplateNameCount();
        });
        updateTemplateNameCount();
      });

    widget.querySelectorAll("[data-symbol-option]").forEach(function (button) {
      button.addEventListener("click", function () {
        var slotId = button.dataset.symbolOption || "";
        var symbolValue = button.dataset.symbolValue || "";
        var symbolImage = button.dataset.symbolImage || "";
        var symbolInput = null;

        widget
          .querySelectorAll("[data-symbol-input]")
          .forEach(function (input) {
            if (input.dataset.symbolInput === slotId) symbolInput = input;
          });
        if (!symbolInput) return;

        symbolInput.value = symbolValue;
        widget
          .querySelectorAll("[data-symbol-option]")
          .forEach(function (optionButton) {
            if (optionButton.dataset.symbolOption === slotId) {
              optionButton.setAttribute(
                "aria-pressed",
                optionButton === button ? "true" : "false",
              );
            }
          });
        getImageTargets(slotId).forEach(function (target) {
          updateImagePreviewTarget(target, symbolImage);
        });
        symbolInput.dispatchEvent(new Event("change", { bubbles: true }));
        syncConditionalFields();
        refreshMainImageMode();
      });
    });

    var finalReviewModal = null;
    var finalReviewSubmitter = null;
    var finalReviewPreviousFocus = null;
    var finalReviewConfirmed = false;
    var finalReviewDelegationInstalled = false;

    function closeFinalReview() {
      if (!finalReviewModal) return;
      finalReviewModal.hidden = true;
      document.documentElement.classList.remove(
        "personalize-pilot-final-review-open",
      );
      if (
        finalReviewPreviousFocus &&
        typeof finalReviewPreviousFocus.focus === "function"
      ) {
        finalReviewPreviousFocus.focus();
      }
      finalReviewPreviousFocus = null;
    }

    function copyReviewCanvases(source, clone) {
      var sourceCanvases = source.querySelectorAll("canvas");
      var cloneCanvases = clone.querySelectorAll("canvas");

      function getCanvasOwnerKey(canvas) {
        var owner = canvas.closest(
          "[data-main-preview-text-slot], [data-main-preview-image-slot], [data-freeform-preview]",
        );
        if (!owner) return "";
        return (
          owner.dataset.mainPreviewTextSlot ||
          owner.dataset.mainPreviewImageSlot ||
          owner.dataset.freeformPreview ||
          ""
        );
      }

      sourceCanvases.forEach(function (sourceCanvas, index) {
        var ownerKey = getCanvasOwnerKey(sourceCanvas);
        var cloneCanvas = Array.prototype.find.call(
          cloneCanvases,
          function (candidate) {
            return ownerKey && getCanvasOwnerKey(candidate) === ownerKey;
          },
        );
        if (!cloneCanvas && !ownerKey) cloneCanvas = cloneCanvases[index];
        if (!cloneCanvas) return;
        try {
          var canvasImage = document.createElement("img");
          canvasImage.src = sourceCanvas.toDataURL("image/png");
          canvasImage.alt = "";
          canvasImage.className = cloneCanvas.className;
          canvasImage.setAttribute("aria-hidden", "true");
          cloneCanvas.replaceWith(canvasImage);
        } catch (error) {
          cloneCanvas.width = sourceCanvas.width;
          cloneCanvas.height = sourceCanvas.height;
          var context = cloneCanvas.getContext("2d");
          if (context) context.drawImage(sourceCanvas, 0, 0);
        }
      });
    }

    function syncFinalReviewOverlayGeometry(source, clone, sourceRect) {
      // Never mix a rectangle captured while cloning with a later viewport
      // rectangle. Fast scrolling or a mobile toolbar resize can move the
      // source between animation frames without changing its local geometry.
      // Read both source and overlays together in this synchronous operation.
      sourceRect = source.getBoundingClientRect();
      if (!sourceRect.width || !sourceRect.height) return;

      var sourceOverlays = source.querySelectorAll(
        ".personalize-pilot-main-preview",
      );
      var cloneOverlays = clone.querySelectorAll(
        ".personalize-pilot-main-preview",
      );

      sourceOverlays.forEach(function (sourceOverlay, index) {
        var cloneOverlay = cloneOverlays[index];
        if (!cloneOverlay) return;

        var overlayRect = sourceOverlay.getBoundingClientRect();
        var leftPercent =
          ((overlayRect.left - sourceRect.left) / sourceRect.width) * 100;
        var topPercent =
          ((overlayRect.top - sourceRect.top) / sourceRect.height) * 100;
        var widthPercent = (overlayRect.width / sourceRect.width) * 100;
        var heightPercent = (overlayRect.height / sourceRect.height) * 100;

        cloneOverlay.style.inset = "auto";
        cloneOverlay.style.left = leftPercent.toFixed(5) + "%";
        cloneOverlay.style.top = topPercent.toFixed(5) + "%";
        cloneOverlay.style.right = "auto";
        cloneOverlay.style.bottom = "auto";
        cloneOverlay.style.width = widthPercent.toFixed(5) + "%";
        cloneOverlay.style.height = heightPercent.toFixed(5) + "%";
      });
    }

    function refitFinalReviewText(source, clone) {
      syncClonedPreviewTextGeometry(source, clone);
    }

    function buildFinalReviewPreview() {
      if (!finalReviewModal) return false;
      var previewHost = finalReviewModal.querySelector(
        "[data-final-review-preview]",
      );
      var source = mainImagePreview.surface;
      if (!previewHost || !source) return false;

      syncTextInputsToPreview();
      freeformItems.forEach(syncFreeformItem);
      refreshMainImageMode();

      var sourceRect = source.getBoundingClientRect();
      var clone = source.cloneNode(true);
      var emptyTextSlots = {};
      widget.querySelectorAll("[data-preview-slot]").forEach(function (input) {
        if (!String(input.value || "").trim()) {
          emptyTextSlots[input.dataset.previewSlot || ""] = true;
        }
      });

      clone.removeAttribute("id");
      clone.classList.add("personalize-pilot-final-review__product");
      clone.classList.remove("is-active", "is-selected");
      clone.querySelectorAll("[id]").forEach(function (element) {
        element.removeAttribute("id");
      });
      clone
        .querySelectorAll(
          "button, input, select, textarea, .personalize-pilot-main-preview__design-area, .personalize-pilot-widget__freeform-handle, [data-personalize-pilot-preview-status], [data-preview-has-value='false'], [hidden]",
        )
        .forEach(function (element) {
          element.remove();
        });
      clone
        .querySelectorAll("[data-main-preview-image-slot]")
        .forEach(function (target) {
          var hasRenderedImage = Boolean(
            target.querySelector("img[src], canvas, svg"),
          );
          if (!hasRenderedImage) target.remove();
        });
      clone
        .querySelectorAll("[data-main-preview-text-slot]")
        .forEach(function (target) {
          if (emptyTextSlots[target.dataset.mainPreviewTextSlot || ""]) {
            target.remove();
          }
        });
      clone
        .querySelectorAll(".personalize-pilot-main-preview")
        .forEach(function (overlay) {
          overlay.hidden = false;
          overlay.classList.remove("is-customer-editing");
        });
      clone
        .querySelectorAll(
          ".is-customer-editable, .is-selected, .is-dragging, .is-conditionally-hidden",
        )
        .forEach(function (element) {
          element.classList.remove(
            "is-customer-editable",
            "is-selected",
            "is-dragging",
            "is-conditionally-hidden",
          );
          element.removeAttribute("tabindex");
        });
      clone.setAttribute("aria-hidden", "true");
      syncFinalReviewOverlayGeometry(source, clone, sourceRect);
      previewHost.replaceChildren(clone);
      previewHost.style.aspectRatio =
        sourceRect.width > 0 && sourceRect.height > 0
          ? sourceRect.width + " / " + sourceRect.height
          : "1 / 1";
      copyReviewCanvases(source, clone);
      return true;
    }

    function ensureFinalReviewModal() {
      if (finalReviewModal) return finalReviewModal;

      var finalReviewCloseLabel = getMessage(
        widget,
        "messageFinalReviewClose",
        "Endkontrolle schließen",
      );
      var finalReviewEyebrow = getMessage(
        widget,
        "messageFinalReviewEyebrow",
        "Endkontrolle",
      );
      var finalReviewTitle = getMessage(
        widget,
        "messageFinalReviewTitle",
        "Deine fertige Personalisierung",
      );
      var finalReviewEdit = getMessage(
        widget,
        "messageFinalReviewEdit",
        "Noch einmal bearbeiten",
      );
      var finalReviewConfirm = getMessage(
        widget,
        "messageFinalReviewConfirm",
        "So in den Warenkorb",
      );

      finalReviewModal = document.createElement("div");
      finalReviewModal.className = "personalize-pilot-final-review";
      finalReviewModal.hidden = true;
      finalReviewModal.setAttribute("role", "dialog");
      finalReviewModal.setAttribute("aria-modal", "true");
      finalReviewModal.setAttribute(
        "aria-labelledby",
        "personalize-pilot-final-review-title",
      );
      finalReviewModal.innerHTML =
        '<button type="button" class="personalize-pilot-final-review__backdrop" data-final-review-close></button>' +
        '<div class="personalize-pilot-final-review__dialog">' +
        '<div class="personalize-pilot-final-review__heading">' +
        "<span data-final-review-eyebrow></span>" +
        '<h2 id="personalize-pilot-final-review-title" data-final-review-title></h2>' +
        '<button type="button" class="personalize-pilot-final-review__close" data-final-review-close></button>' +
        "</div>" +
        '<div class="personalize-pilot-final-review__preview" data-final-review-preview></div>' +
        '<div class="personalize-pilot-final-review__actions">' +
        '<button type="button" class="personalize-pilot-final-review__edit" data-final-review-close></button>' +
        '<button type="button" class="personalize-pilot-final-review__confirm" data-final-review-confirm></button>' +
        "</div>" +
        "</div>";
      finalReviewModal
        .querySelector(".personalize-pilot-final-review__backdrop")
        .setAttribute("aria-label", finalReviewCloseLabel);
      var finalReviewCloseButton = finalReviewModal.querySelector(
        ".personalize-pilot-final-review__close",
      );
      finalReviewCloseButton.setAttribute("aria-label", finalReviewCloseLabel);
      finalReviewCloseButton.textContent = "×";
      finalReviewModal.querySelector(
        "[data-final-review-eyebrow]",
      ).textContent = finalReviewEyebrow;
      finalReviewModal.querySelector("[data-final-review-title]").textContent =
        finalReviewTitle;
      finalReviewModal.querySelector(
        ".personalize-pilot-final-review__edit",
      ).textContent = finalReviewEdit;
      finalReviewModal.querySelector(
        "[data-final-review-confirm]",
      ).textContent = finalReviewConfirm;

      if (!finalReviewDelegationInstalled) {
        document.addEventListener(
          "click",
          function (event) {
            if (
              !finalReviewModal ||
              finalReviewModal.hidden ||
              !finalReviewModal.contains(event.target)
            ) {
              return;
            }

            var closeTarget = event.target.closest("[data-final-review-close]");
            if (closeTarget) {
              event.preventDefault();
              event.stopImmediatePropagation();
              closeFinalReview();
              return;
            }

            var confirmTarget = event.target.closest(
              "[data-final-review-confirm]",
            );
            if (!confirmTarget) return;

            event.preventDefault();
            event.stopImmediatePropagation();
            var proofInput =
              widget.querySelector("[data-final-review-proof]") ||
              form.querySelector("[data-final-review-proof]");
            if (proofInput) proofInput.disabled = false;
            finalReviewConfirmed = true;
            form.dataset.personalizePilotReviewApproved = "true";
            var submitter = finalReviewSubmitter;
            closeFinalReview();
            var approvedSubmitEvent;
            if (typeof SubmitEvent === "function") {
              approvedSubmitEvent = new SubmitEvent("submit", {
                bubbles: true,
                cancelable: true,
                submitter:
                  submitter && submitter.form === form && !submitter.disabled
                    ? submitter
                    : null,
              });
            } else {
              approvedSubmitEvent = new Event("submit", {
                bubbles: true,
                cancelable: true,
              });
            }
            form.dispatchEvent(approvedSubmitEvent);
          },
          true,
        );
        document.addEventListener(
          "keydown",
          function (event) {
            if (
              event.key === "Escape" &&
              finalReviewModal &&
              !finalReviewModal.hidden
            ) {
              event.preventDefault();
              closeFinalReview();
            }
          },
          true,
        );
        finalReviewDelegationInstalled = true;
      }
      document.body.appendChild(finalReviewModal);
      return finalReviewModal;
    }

    function openFinalReview(submitter) {
      ensureFinalReviewModal();
      if (!buildFinalReviewPreview()) return false;
      var standardDesignOnly = !isPersonalizationEnabled();
      var reviewTitle = finalReviewModal.querySelector(
        "[data-final-review-title]",
      );
      var reviewEdit = finalReviewModal.querySelector(
        ".personalize-pilot-final-review__edit",
      );
      if (reviewTitle) {
        reviewTitle.textContent = standardDesignOnly
          ? getMessage(
              widget,
              "messageFinalReviewStandardTitle",
              "Dein ausgewähltes Design",
            )
          : getMessage(
              widget,
              "messageFinalReviewTitle",
              "Deine fertige Personalisierung",
            );
      }
      if (reviewEdit) {
        reviewEdit.textContent = standardDesignOnly
          ? getMessage(
              widget,
              "messageFinalReviewStandardEdit",
              "Auswahl ändern",
            )
          : getMessage(
              widget,
              "messageFinalReviewEdit",
              "Noch einmal bearbeiten",
            );
      }
      finalReviewConfirmed = false;
      delete form.dataset.personalizePilotReviewApproved;
      var proofInput =
        widget.querySelector("[data-final-review-proof]") ||
        form.querySelector("[data-final-review-proof]");
      if (proofInput) proofInput.disabled = true;
      finalReviewSubmitter = submitter || null;
      finalReviewPreviousFocus = document.activeElement;
      finalReviewModal.hidden = false;
      document.documentElement.classList.add(
        "personalize-pilot-final-review-open",
      );
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          var product = finalReviewModal.querySelector(
            ".personalize-pilot-final-review__product",
          );
          if (product) refitFinalReviewText(mainImagePreview.surface, product);
        });
      });
      var confirmButton = finalReviewModal.querySelector(
        "[data-final-review-confirm]",
      );
      if (confirmButton) confirmButton.focus();
      return true;
    }

    if (form) {
      var productFormId = form.getAttribute("id");
      var submitLabel = getMessage(
        widget,
        "messageSubmitLabel",
        "Personalisierung prüfen",
      );
      var validationNotice = widget.querySelector(
        "[data-personalization-validation-notice]",
      );

      form.enctype = "multipart/form-data";

      // Shopify forms contain an input named "id". Reading form.id can return
      // that input through HTMLFormElement's named-property lookup.
      if (!productFormId) {
        productFormId =
          "personalize-pilot-product-form-" +
          String(
            widget.dataset.personalizePilotBlockId ||
              widget.dataset.productId ||
              "main",
          ).replace(/[^a-zA-Z0-9_-]+/g, "-");
        form.setAttribute("id", productFormId);
      }

      form.addEventListener(
        "invalid",
        function (event) {
          var invalidTarget = event.target;
          if (
            !invalidTarget ||
            invalidTarget.matches("[data-personalize-pilot-runtime-proof]")
          ) {
            return;
          }
          invalidTarget.setAttribute("aria-invalid", "true");
          var invalidField = invalidTarget.closest(
            ".personalize-pilot-widget__field, .personalize-pilot-widget__choice-field",
          );
          if (invalidField) invalidField.classList.add("is-invalid");
          if (validationNotice) {
            validationNotice.textContent = getMessage(
              widget,
              "messageRequiredError",
              "Bitte ergänze das markierte Pflichtfeld.",
            );
            validationNotice.hidden = false;
          }
        },
        true,
      );

      form.addEventListener("input", function (event) {
        var target = event.target;
        if (!target || !target.validity || !target.validity.valid) return;
        target.removeAttribute("aria-invalid");
        var field = target.closest(
          ".personalize-pilot-widget__field, .personalize-pilot-widget__choice-field",
        );
        if (field) field.classList.remove("is-invalid");
        if (validationNotice) validationNotice.hidden = true;
      });

      form
        .querySelectorAll(
          'button[name="add"], button[type="submit"], input[type="submit"]',
        )
        .forEach(function (button) {
          if (button.tagName === "INPUT") {
            button.value = submitLabel;
            return;
          }

          var label =
            button.querySelector("[data-add-to-cart-text]") ||
            button.querySelector("span:not(.loading-overlay__spinner)");
          if (label) {
            label.textContent = submitLabel;
          } else {
            Array.prototype.some.call(button.childNodes, function (node) {
              if (
                node.nodeType !== Node.TEXT_NODE ||
                !node.textContent.trim()
              ) {
                return false;
              }
              node.textContent = submitLabel;
              return true;
            });
          }
          button.setAttribute("aria-label", submitLabel);
        });

      widget
        .querySelectorAll(
          "input[name], select[name], textarea[name], [data-multi-option]",
        )
        .forEach(function (input) {
          if (!input.closest("form")) {
            input.setAttribute("form", productFormId);
          }
        });

      form.addEventListener("change", function (event) {
        var target = event.target;
        var targetName = String((target && target.name) || "").toLowerCase();

        if (
          targetName.indexOf("option") >= 0 ||
          targetName === "id" ||
          (target &&
            target.closest &&
            target.closest("variant-selects, variant-radios"))
        ) {
          applySelectedVariantConfiguration();
          applySurfaceConfiguration(activeSurfaceId);
          scheduleMainImagePreviewRefresh();
        }
      });

      form.addEventListener(
        "submit",
        function (event) {
          widget
            .querySelectorAll("[data-template-name-input]")
            .forEach(function (input) {
              input.value = String(input.value || "").trim();
            });

          // Surface tabs are a presentation detail. Before validation and
          // FormData creation, restore every logically active field so a
          // two-sided design is submitted as one complete configuration.
          prepareAllSurfaceFieldsForSubmission();
          var invalidControl = Array.from(
            form.querySelectorAll("input, select, textarea"),
          ).find(function (control) {
            return (
              !control.disabled &&
              control.willValidate &&
              !control.checkValidity()
            );
          });
          if (invalidControl) {
            event.preventDefault();
            event.stopImmediatePropagation();
            var invalidSurfaceField = invalidControl.closest(
              "[data-personalization-surface]",
            );
            if (invalidSurfaceField) {
              applySurfaceConfiguration(
                invalidSurfaceField.dataset.personalizationSurface || "front",
              );
              syncConditionalFields();
            }
            invalidControl.focus({ preventScroll: true });
            invalidControl.reportValidity();
            invalidControl.scrollIntoView({
              behavior: "smooth",
              block: "center",
            });
            return;
          }

          var counts = getChargeableFreeformCounts();
          var missingVariant =
            (counts.text > 0 &&
              Number(customerDesignSettings.extraTextPrice || 0) > 0 &&
              !customerDesignSettings.extraTextVariantId) ||
            (counts.image > 0 &&
              Number(customerDesignSettings.extraImagePrice || 0) > 0 &&
              !customerDesignSettings.extraImageVariantId) ||
            (counts.symbol > 0 &&
              Number(customerDesignSettings.extraSymbolPrice || 0) > 0 &&
              !customerDesignSettings.extraSymbolVariantId);
          var incompleteImageUpload = freeformItems.some(function (item) {
            return (
              isPersonalizationEnabled() &&
              item.kind === "image" &&
              Boolean(item.fileName) &&
              (!item.assetId || item.uploadState !== "ready")
            );
          });

          if (incompleteImageUpload) {
            event.preventDefault();
            event.stopImmediatePropagation();
            var uploadWarning = widget.querySelector(
              "[data-freeform-price-warning]",
            );
            if (uploadWarning) {
              uploadWarning.textContent =
                "Bitte warte, bis alle Bilder sicher gespeichert wurden.";
              uploadWarning.hidden = false;
              uploadWarning.scrollIntoView({
                behavior: "smooth",
                block: "center",
              });
            }
            return;
          }

          if (missingVariant) {
            event.preventDefault();
            event.stopImmediatePropagation();
            var warning = widget.querySelector("[data-freeform-price-warning]");
            if (warning) {
              warning.hidden = false;
              warning.scrollIntoView({ behavior: "smooth", block: "center" });
            }
            return;
          }
          if (form.dataset.personalizePilotFeeSubmitting === "true") {
            event.preventDefault();
            event.stopImmediatePropagation();
            return;
          }

          if (
            !finalReviewConfirmed &&
            form.dataset.personalizePilotReviewApproved !== "true"
          ) {
            event.preventDefault();
            event.stopImmediatePropagation();
            if (openFinalReview(event.submitter)) return;
          }

          var nativeUploadFallbackInputs = Array.from(
            form.querySelectorAll(
              'input[type="file"][data-native-upload-fallback="true"]',
            ),
          ).filter(function (input) {
            return Boolean(!input.disabled && input.files && input.files[0]);
          });

          if (nativeUploadFallbackInputs.length > 0) {
            nativeUploadFallbackInputs.forEach(function (input) {
              if (input.dataset.originalPropertyName) {
                input.setAttribute("name", input.dataset.originalPropertyName);
              }
            });
            form.dataset.personalizePilotFeeSubmitting = "true";
            setDesignSaveStatus(
              "Gestaltung und Bild werden sicher an den Warenkorb übertragen ...",
              false,
            );
            return;
          }

          event.preventDefault();
          event.stopImmediatePropagation();
          form.dataset.personalizePilotFeeSubmitting = "true";
          var formData = new FormData(form);
          var variantId = String(formData.get("id") || "")
            .split("/")
            .filter(Boolean)
            .pop();
          var quantity = Math.max(1, Number(formData.get("quantity") || 1));
          var properties = {};
          var sellingPlan = formData.get("selling_plan");

          formData.forEach(function (value, name) {
            var match = name.match(/^properties\[(.*)\]$/);
            if (match && typeof value === "string" && value) {
              properties[match[1]] = value;
            }
          });
          form.querySelectorAll('[type="submit"]').forEach(function (button) {
            button.disabled = true;
            button.setAttribute("aria-busy", "true");
          });
          var root =
            (window.Shopify &&
              window.Shopify.routes &&
              window.Shopify.routes.root) ||
            "/";
          var editState = widget.personalizePilotEditState || {};
          var designEndpoint =
            widget.dataset.designEndpoint || "/apps/personalize-pilot/design";
          setDesignSaveStatus("Gestaltung wird sicher gespeichert ...", false);

          fetch(designEndpoint, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            body: JSON.stringify({
              designId: editState.designId || undefined,
              accessToken: editState.accessToken || undefined,
              expectedVersion: editState.version || undefined,
              templateId: widget.dataset.templateId || "",
              templateVersion: Number(widget.dataset.templateVersion || 0),
              productId: widget.dataset.productId || "",
              variantId: variantId,
              quantity: quantity,
              currency: widget.dataset.currency || "EUR",
              properties: properties,
            }),
          })
            .then(function (response) {
              return readProxyJson(response).then(function (payload) {
                if (!response.ok || !payload || !payload.ok) {
                  throw new Error(
                    (payload && payload.error) ||
                      "Die Gestaltung konnte nicht sicher gespeichert werden.",
                  );
                }
                return payload;
              });
            })
            .then(function (savedDesign) {
              properties._personalize_pilot_design_token = savedDesign.designId;
              properties._personalize_pilot_design_id = savedDesign.designId;
              properties._personalize_pilot_design_access =
                savedDesign.accessToken;
              properties._personalize_pilot_design_version = String(
                savedDesign.version,
              );
              properties._personalize_pilot_price_attestation =
                savedDesign.pricing.attestation;
              properties._personalize_pilot_expected_fee_cents = String(
                savedDesign.pricing.expectedSurchargeCents,
              );

              var items = [
                {
                  id: variantId,
                  quantity: quantity,
                  properties: properties,
                },
              ];
              if (sellingPlan) items[0].selling_plan = sellingPlan;
              (savedDesign.pricing.feeLines || []).forEach(function (line) {
                items.push({
                  id: line.id,
                  quantity: Number(line.quantity || 0) * quantity,
                  properties: {
                    _personalize_pilot_fee_for:
                      widget.dataset.templateId ||
                      widget.dataset.productId ||
                      "product",
                    _personalize_pilot_fee_kind: line.kind,
                    _personalize_pilot_design_token: savedDesign.designId,
                    _personalize_pilot_design_id: savedDesign.designId,
                    _personalize_pilot_design_version: String(
                      savedDesign.version,
                    ),
                    _personalize_pilot_price_attestation:
                      savedDesign.pricing.attestation,
                  },
                });
              });

              widget.personalizePilotEditState = {
                designId: savedDesign.designId,
                accessToken: savedDesign.accessToken,
                version: savedDesign.version,
              };
              setDesignSaveStatus("Gestaltung gespeichert.", false);

              return fetch(root + "cart/add.js", {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  Accept: "application/json",
                },
                body: JSON.stringify({ items: items }),
              }).then(function (response) {
                if (!response.ok) {
                  throw new Error(
                    "Die Gestaltung konnte nicht in den Warenkorb gelegt werden.",
                  );
                }
                return savedDesign;
              });
            })
            .then(function (savedDesign) {
              if (!editState.designId) return savedDesign;

              return fetch(root + "cart.js", {
                headers: { Accept: "application/json" },
              })
                .then(function (response) {
                  if (!response.ok)
                    throw new Error("Warenkorb konnte nicht gelesen werden.");
                  return response.json();
                })
                .then(function (cart) {
                  var updates = {};
                  (cart.items || []).forEach(function (item) {
                    var itemProperties = item.properties || {};
                    var itemDesignId =
                      itemProperties._personalize_pilot_design_id ||
                      itemProperties._personalize_pilot_design_token;
                    var itemVersion = String(
                      itemProperties._personalize_pilot_design_version || "",
                    );
                    if (
                      itemDesignId === savedDesign.designId &&
                      itemVersion !== String(savedDesign.version)
                    ) {
                      updates[item.key] = 0;
                    }
                  });
                  if (Object.keys(updates).length === 0) return savedDesign;
                  return fetch(root + "cart/update.js", {
                    method: "POST",
                    headers: {
                      "Content-Type": "application/json",
                      Accept: "application/json",
                    },
                    body: JSON.stringify({ updates: updates }),
                  }).then(function (response) {
                    if (!response.ok) {
                      throw new Error(
                        "Die alte Warenkorbgestaltung konnte nicht ersetzt werden.",
                      );
                    }
                    return savedDesign;
                  });
                });
            })
            .then(function () {
              window.location.assign(root + "cart");
            })
            .catch(function (error) {
              delete form.dataset.personalizePilotFeeSubmitting;
              delete form.dataset.personalizePilotReviewApproved;
              finalReviewConfirmed = false;
              form
                .querySelectorAll('[type="submit"]')
                .forEach(function (button) {
                  button.disabled = false;
                  button.removeAttribute("aria-busy");
                });
              var warning = widget.querySelector(
                "[data-freeform-price-warning]",
              );
              if (warning) {
                warning.textContent =
                  error.message ||
                  "Warenkorb konnte nicht aktualisiert werden.";
                warning.hidden = false;
              }
              setDesignSaveStatus(
                error.message || "Gestaltung konnte nicht gespeichert werden.",
                true,
              );
            });
        },
        true,
      );
    }

    initializeFreeformEditor();
    initializeCustomerSlotLayouts();
    initializePhotoCrops();

    function restoreFreeformItems(properties, assetPreviews) {
      var restoredItems = [];
      Object.keys(properties || {})
        .filter(function (name) {
          return name.indexOf("_personalize_pilot_freeform_") === 0;
        })
        .slice(0, 30)
        .forEach(function (name) {
          try {
            var parsed = JSON.parse(properties[name]);
            var layout = parsed.layout || {};
            var kind =
              ["text", "image", "symbol", "shape", "clipart"].indexOf(
                parsed.objectKind,
              ) >= 0
                ? parsed.objectKind
                : parsed.type === "text"
                  ? "text"
                  : parsed.type === "image"
                    ? "image"
                    : "symbol";
            var surfaceId = parsed.surfaceId || "front";
            var area = getFreeformDesignArea(surfaceId);
            var localCenter = rotateDesignPoint(
              Number(layout.x || area.x),
              Number(layout.y || area.y),
              area.x,
              area.y,
              -Number(area.rotation || 0),
            );
            var baseRelativeWidth =
              kind === "text"
                ? 56
                : kind === "image" || kind === "clipart"
                  ? 36
                  : 18;
            var baseWidth = (area.width * baseRelativeWidth) / 100;
            var sequenceMatch = String(parsed.slotId || name).match(/(\d+)$/);
            var sequence = sequenceMatch
              ? Number(sequenceMatch[1])
              : restoredItems.length + 1;
            var symbol = freeformSymbolLibrary.find(function (candidate) {
              return candidate.value === parsed.selectedValue;
            });
            var shape = freeformShapeLibrary.find(function (candidate) {
              return candidate.value === parsed.shapeType;
            });
            var clipart = (customerDesignSettings.clipartAssets || []).find(
              function (candidate) {
                return candidate.id === parsed.clipartAssetId;
              },
            );
            restoredItems.push({
              id: String(parsed.slotId || "free-" + kind + "-" + sequence),
              sequence: sequence,
              kind: kind,
              text: parsed.textValue || "",
              fileName: parsed.fileName || "",
              fileType: parsed.fileType || "",
              fileSize: Number(parsed.fileSize || 0),
              fileWidthPx: Number(parsed.fileWidthPx || 0),
              fileHeightPx: Number(parsed.fileHeightPx || 0),
              assetId: parsed.assetId || "",
              previewUrl:
                (assetPreviews && assetPreviews[parsed.assetId]) || "",
              uploadState: parsed.assetId ? "ready" : "",
              symbolLabel: (symbol && symbol.label) || parsed.label || "Symbol",
              symbolValue: parsed.selectedValue || "",
              symbolPath: (symbol && symbol.path) || parsed.symbolPath || "",
              shapeType:
                (shape && shape.value) || parsed.shapeType || "rectangle",
              shapeLabel: (shape && shape.label) || parsed.label || "Form",
              clipartAssetId:
                (clipart && clipart.id) || parsed.clipartAssetId || "",
              clipartName: (clipart && clipart.name) || parsed.label || "Motiv",
              clipartImageUrl:
                (clipart && clipart.imageUrl) || parsed.clipartImageUrl || "",
              priceAdjustment:
                kind === "clipart" && clipart
                  ? Number(clipart.priceAdjustment || 0)
                  : Number(parsed.priceAdjustment || 0),
              shopifyVariantId:
                kind === "clipart" && clipart
                  ? clipart.shopifyVariantId || ""
                  : "",
              fillColor: parsed.fillColor || "#111111",
              strokeColor: parsed.strokeColor || "#111111",
              strokeWidth: Number(parsed.strokeWidth || 1),
              opacity: Number(parsed.opacity || 100),
              zIndex: Number(parsed.zIndex || sequence),
              imageMask: parsed.imageMask || "none",
              brightness: Number(parsed.brightness ?? 100),
              contrast: Number(parsed.contrast ?? 100),
              saturation: Number(parsed.saturation ?? 100),
              grayscale: Number(parsed.grayscale || 0),
              flipX: parsed.flipX === true,
              flipY: parsed.flipY === true,
              textCurve: Number(parsed.textCurve || 0),
              letterSpacing: Number(parsed.letterSpacing || 0),
              x:
                50 + ((localCenter.x - area.x) / Math.max(area.width, 1)) * 100,
              y:
                50 +
                ((localCenter.y - area.y) / Math.max(area.height, 1)) * 100,
              scale: Math.max(
                Number(customerDesignSettings.minScalePercent || 40),
                Math.min(
                  Number(customerDesignSettings.maxScalePercent || 160),
                  (Number(layout.width || baseWidth) / Math.max(baseWidth, 1)) *
                    100,
                ),
              ),
              rotation:
                Number(layout.rotation || 0) - Number(area.rotation || 0),
              surfaceId: surfaceId,
            });
          } catch (error) {
            // Invalid legacy freeform properties are ignored during restore.
          }
        });

      freeformItems = restoredItems;
      freeformSequence = restoredItems.reduce(function (maximum, item) {
        return Math.max(maximum, Number(item.sequence || 0));
      }, 0);
      freeformUndoStack = [];
      freeformRedoStack = [];
      selectedFreeformItemId = restoredItems[0] ? restoredItems[0].id : "";
      renderFreeformEditor();
    }

    function restoreCustomerImageLayouts(properties) {
      Object.keys(customerSlotLayouts).forEach(function (slotId) {
        var state = customerSlotLayouts[slotId];
        if (state.kind !== "image" && !/^definition-line-[123]$/.test(slotId)) return;
        var serialized = properties["_personalize_pilot_layout_" + slotId];
        if (!serialized) return;
        try {
          var layout = JSON.parse(serialized);
          if (
            !layout ||
            ![layout.x, layout.y, layout.width, layout.height].every(function (value) {
              return typeof value === "number" && Number.isFinite(value);
            }) ||
            layout.width <= 0 || layout.height <= 0
          ) return;
          // Restore editor state as well as the hidden property. Otherwise the
          // next preview refresh replaces the saved frame with default bounds.
          state.x = layout.x;
          state.y = layout.y;
          state.scale = 100;
          state.widthScale = clampFreeformNumber(layout.width / Math.max(state.base.width, 1) * 100, 25, 250);
          state.heightScale = clampFreeformNumber(layout.height / Math.max(state.base.height, 1) * 100, 25, 250);
          state.rotation = clampFreeformNumber(Number(layout.rotation || 0), -180, 180);
          syncCustomerSlotLayout(slotId);
          widget.querySelectorAll('[data-customer-layout-control="' + slotId + '"]').forEach(function (control) {
            var key = control.dataset.layoutKey || "";
            if (!(key in state) || typeof state[key] !== "number") return;
            control.value = String(state[key]);
            updateCustomerLayoutOutput(slotId, key, state[key]);
          });
        } catch (error) {
          // Malformed legacy data must not override the configured safe frame.
        }
      });
    }

    function restoreCustomerDesign(savedDesign) {
      var properties = savedDesign.properties || {};
      restoreFreeformItems(properties, savedDesign.assetPreviews || {});

      // Theme-owned extras (wood-base text/font) belong to the same product
      // form but sit outside the app block. Restore them with the saved design.
      var restoreForm = widget.closest("form") || widget;
      restoreForm.querySelectorAll("[name]").forEach(function (control) {
        var match = String(control.name || "").match(/^properties\[(.*)\]$/);
        if (!match || !(match[1] in properties)) return;
        var value = String(properties[match[1]] || "");
        if (control.type === "file") return;
        if (control.type === "checkbox" || control.type === "radio") {
          control.checked = String(control.value || "") === value;
        } else {
          control.value = value;
        }
        control.dispatchEvent(new Event("input", { bubbles: true }));
        control.dispatchEvent(new Event("change", { bubbles: true }));
      });

      var restoredLightingMode = String(
        properties._personalize_pilot_lighting_mode || "",
      ).toLowerCase();
      if (restoredLightingMode === "warm" || restoredLightingMode === "cool") {
        lightingInputs.forEach(function (input) {
          input.checked = input.dataset.lightingMode === restoredLightingMode;
        });
        if (lightingModeInput) {
          lightingModeInput.value = restoredLightingMode;
        }
        applyLightingPreview();
      }

      var restoredChoice = String(
        properties._personalize_pilot_personalization_mode || "",
      ).toLowerCase();
      if (!restoredChoice) {
        var restoredChoiceLabel = String(
          properties.Personalisierung || "",
        ).toLowerCase();
        restoredChoice = /ohne|without|sin personal|sans personnal/.test(
          restoredChoiceLabel,
        )
          ? "standard"
          : "personalized";
      }
      personalizationChoiceInputs.forEach(function (input) {
        input.checked = input.value === restoredChoice;
      });
      applyPersonalizationChoice();

      restoreCustomerImageLayouts(properties);
      (savedDesign.snapshot.personalizationItems || []).forEach(
        function (item) {
          var previewUrl =
            item.assetId && savedDesign.assetPreviews
              ? savedDesign.assetPreviews[item.assetId]
              : "";
          if (previewUrl) {
            var restoredInput = widget.querySelector('[data-file-preview-slot="' + item.slotId + '"]');
            if (restoredInput) restoredInput.dataset.previewPrivateUrl = previewUrl;
            var restoredImageToggle = widget.querySelector('[data-optional-image-toggle="' + item.slotId + '"]');
            if (restoredImageToggle) restoredImageToggle.checked = true;
            syncOptionalImageAreas();
            setImageToolsVisible(item.slotId, true);
            getImageTargets(item.slotId).forEach(function (target) {
              updateImagePreviewTarget(target, previewUrl);
            });
          }
        },
      );
      syncConditionalFields();
      refreshMainImageMode();
      scheduleMainImagePreviewRefresh();
      setDesignSaveStatus("Gespeicherte Gestaltung geladen.", false);
      widget.dispatchEvent(new CustomEvent("personalize-pilot:design-restored", { bubbles: true }));
    }

    function loadCustomerDesignFromLocation() {
      var url = new URL(window.location.href);
      var designId = url.searchParams.get("personalize_design") || "";
      var accessToken = url.searchParams.get("personalize_token") || "";
      if (!designId || !accessToken) return;
      var requestedVersion = Number(
        url.searchParams.get("personalize_version") || 0,
      );

      setDesignSaveStatus("Gespeicherte Gestaltung wird geladen ...", false);
      fetch(
        (widget.dataset.designEndpoint || "/apps/personalize-pilot/design") +
          "?designId=" +
          encodeURIComponent(designId) +
          "&accessToken=" +
          encodeURIComponent(accessToken) +
          (requestedVersion > 0
            ? "&version=" + encodeURIComponent(requestedVersion)
            : ""),
        { headers: { Accept: "application/json" } },
      )
        .then(function (response) {
          return readProxyJson(response).then(function (payload) {
            if (!response.ok || !payload || !payload.ok) {
              throw new Error(
                (payload && payload.error) ||
                  "Gespeicherte Gestaltung konnte nicht geladen werden.",
              );
            }
            return payload;
          });
        })
        .then(function (savedDesign) {
          var expectedProduct = String(widget.dataset.productId || "")
            .split("/")
            .filter(Boolean)
            .pop();
          var designProduct = String(
            savedDesign.snapshot.shopifyProductId || "",
          )
            .split("/")
            .filter(Boolean)
            .pop();
          if (expectedProduct !== designProduct) {
            throw new Error("Die Gestaltung gehört zu einem anderen Produkt.");
          }
          widget.personalizePilotEditState = {
            designId: savedDesign.designId,
            accessToken: savedDesign.accessToken,
            version: savedDesign.version,
          };
          restoreCustomerDesign(savedDesign);
        })
        .catch(function (error) {
          setDesignSaveStatus(error.message, true);
        });
    }

    loadCustomerDesignFromLocation();

    scheduleMainImagePreviewRefresh();
    window.addEventListener("load", scheduleMainImagePreviewRefresh);
    window.addEventListener("resize", scheduleMainImagePreviewRefresh);
    document.addEventListener(
      "shopify:section:load",
      scheduleMainImagePreviewRefresh,
    );
    document.addEventListener(
      "shopify:section:select",
      scheduleMainImagePreviewRefresh,
    );
    document.addEventListener(
      "variant:change",
      scheduleMainImagePreviewRefresh,
    );
    document.addEventListener(
      "product:variant-change",
      scheduleMainImagePreviewRefresh,
    );

    if (window.MutationObserver) {
      var productMutationRoot =
        widget.closest(
          '[id*="MainProduct"], [id*="main-product"], [data-section*="product"]',
        ) || document.body;
      var productMediaObserver = new MutationObserver(function (mutations) {
        if (!widget.isConnected) {
          productMediaObserver.disconnect();
          return;
        }

        var overlayMissing =
          !mainImagePreview.overlay || !mainImagePreview.overlay.isConnected;
        var productMediaChanged = mutations.some(function (mutation) {
          return Array.prototype.some.call(
            mutation.addedNodes,
            function (node) {
              if (!node || node.nodeType !== 1 || widget.contains(node))
                return false;
              if (
                node.classList &&
                node.classList.contains("personalize-pilot-main-preview")
              ) {
                return false;
              }
              return (
                node.matches?.(
                  "img, picture, media-gallery, [data-media-id], .product-gallery",
                ) ||
                Boolean(
                  node.querySelector?.(
                    "img, media-gallery, [data-media-id], .product-gallery",
                  ),
                )
              );
            },
          );
        });

        if (overlayMissing || productMediaChanged) {
          scheduleMainImagePreviewRefresh();
        }
      });
      productMediaObserver.observe(productMutationRoot, {
        childList: true,
        subtree: true,
      });
    }

    function mirrorGuidedSurfaceText(source) {
      var sourceSlotId = source.dataset.previewSlot || "";
      if (sourceSlotId.indexOf("guided-name-") !== 0) return;

      widget.querySelectorAll("[data-preview-slot]").forEach(function (target) {
        var targetSlotId = target.dataset.previewSlot || "";
        if (
          target === source ||
          targetSlotId.indexOf("guided-name-") !== 0 ||
          target.name !== source.name
        ) {
          return;
        }
        target.value = source.value;
        updatePreviewTextTargets(
          getTextTargets(targetSlotId),
          target.value,
          false,
        );
        updateTextFieldState(target);
      });
    }

    widget.querySelectorAll("[data-preview-slot]").forEach(function (input) {
      var slotId = input.dataset.previewSlot;

      input.addEventListener("input", function (event) {
        var wasPersonalizing = widget.classList.contains("is-personalizing");
        if (
          !mainImagePreview.overlay ||
          !mainImagePreview.overlay.isConnected
        ) {
          refreshMainImagePreview();
          scheduleMainImagePreviewRefresh();
        }
        mirrorGuidedSurfaceText(input);
        if (/^definition-line-[123]$/.test(slotId) && form.querySelector("definition-editor")) {
          ["definition-line-1","definition-line-2","definition-line-3"].forEach(function(id) {
            var peer=widget.querySelector('[data-preview-slot="'+id+'"]');
            if (peer) updatePreviewTextTargets(getTextTargets(id),peer.value,false);
          });
        } else {
          updatePreviewTextTargets(getTextTargets(slotId),event.target.value,false);
        }
        // Update the source text before cloning the main preview. Previously
        // refreshMainImageMode scheduled both follower previews first, so they
        // copied the previous input value and only caught up on the later
        // 250/700 ms recovery refresh. That visible lag looked like a wobble.
        if (typeof widget.personalizePilotSyncFollowers === "function") {
          widget.personalizePilotSyncFollowers();
        }
        var isNowPersonalizing =
          isPersonalizationEnabled() && hasActivePersonalizationInput(widget);
        if (wasPersonalizing !== isNowPersonalizing) {
          refreshMainImageMode();
        } else if (!syncCurrentMobilePreviewText()) {
          scheduleMobileLivePreviewRefresh();
        }
      });
      updatePreviewTextTargets(getTextTargets(slotId), input.value, false);
    });

    widget
      .querySelectorAll("[data-text-rule-input]")
      .forEach(function (control) {
        control.addEventListener("input", function () {
          updateTextFieldState(control);
        });
        control.addEventListener("blur", function () {
          var trimmedValue = String(control.value || "").trim();
          if (trimmedValue !== control.value) {
            control.value = trimmedValue;
            control.dispatchEvent(new Event("input", { bubbles: true }));
          }
          updateTextFieldState(control);
        });
        updateTextFieldState(control);
      });

    if (primaryTextInput && previewText) {
      primaryTextInput.addEventListener("input", function (event) {
        refreshMainImageMode();
        updatePreviewTextTargets(
          [previewText, mainImagePreview.previewText].filter(Boolean),
          event.target.value,
          false,
        );
      });
      updatePreviewTextTargets(
        [previewText, mainImagePreview.previewText].filter(Boolean),
        primaryTextInput.value,
        false,
      );
    }

    colorInputs.forEach(function (colorInput) {
      colorInput.addEventListener("input", function (event) {
        widget.style.setProperty(
          "--personalize-pilot-accent",
          event.target.value,
        );
        if (mainImagePreview.overlay) {
          mainImagePreview.overlay.style.setProperty(
            "--personalize-pilot-accent",
            event.target.value,
          );
        }
        Object.keys(textPreviewTargets).forEach(function (slotId) {
          getTextTargets(slotId).forEach(function (target) {
            target.style.color = event.target.value;
          });
        });
        if (previewText) {
          [previewText, mainImagePreview.previewText]
            .filter(Boolean)
            .forEach(function (target) {
              target.style.color = event.target.value;
            });
        }
        freeformItems.forEach(syncFreeformItem);
      });
    });

    function syncSelectedFontOption(fontValue) {
      widget.querySelectorAll("[data-font-option]").forEach(function (button) {
        button.setAttribute(
          "aria-pressed",
          String(button.dataset.fontValue || "") === fontValue
            ? "true"
            : "false",
        );
      });
    }

    function commitFontOption(button) {
      if (!fontInput || !button || button.disabled) return;
      var fontValue = String(button.dataset.fontValue || "");

      // Commit the cart property and the observable widget state in the same
      // synchronous click turn. The preview refresh below may wait for font
      // metrics, but a customer's selection must never depend on that promise.
      fontInput.value = fontValue;
      widget.dataset.previewFontValue = fontValue;
      syncSelectedFontOption(fontValue);
      fontInput.dispatchEvent(new Event("change", { bubbles: true }));
    }

    fontOptionButtons.forEach(function (button) {
      var fontValue = button.dataset.fontValue || "";
      var sample = button.querySelector("[data-font-sample]");

      if (sample) {
        sample.style.fontFamily = getPreviewFontFamily(fontValue);
        sample.style.fontWeight = getPreviewFontWeight(fontValue);
      }
    });

    // Listen on the stable widget instead of the initially rendered NodeList.
    // Shopify sections and template choices can replace controls after the
    // extension has attached; delegated clicks still update the live button.
    widget.addEventListener("click", function (event) {
      var eventTarget = event.target;
      var button =
        eventTarget && typeof eventTarget.closest === "function"
          ? eventTarget.closest("[data-font-option]")
          : null;
      if (!button || !widget.contains(button)) return;
      commitFontOption(button);
    });

    if (fontInput) {
      fontInput.addEventListener("change", function () {
        var fontValue = String(fontInput.value || "");
        widget.dataset.previewFontValue = fontValue;
        syncSelectedFontOption(fontValue);
        updatePreviewFont();
      });
      updatePreviewFont();
      updateFontSamples();
    }

    if (customerNameInput) {
      customerNameInput.addEventListener("input", updateFontSamples);
    }

    widget
      .querySelectorAll("[data-personalization-slot-id]")
      .forEach(function (control) {
        control.addEventListener("input", syncConditionalFields);
        control.addEventListener("change", syncConditionalFields);
      });

    personalizationChoiceInputs.forEach(function (input) {
      input.addEventListener("change", function () {
        if (!input.checked) return;
        applyPersonalizationChoice();
      });
    });

    widget.querySelectorAll("[data-multi-option]").forEach(function (control) {
      control.addEventListener("change", function () {
        syncMultiChoice(control.dataset.multiOption || "");
        syncConditionalFields();
      });
    });
    syncAllMultiChoices();

    widget.querySelectorAll('input[type="file"]').forEach(function (input) {
      var hiddenTarget = input.parentElement.querySelector(
        "[data-file-name-target]",
      );
      var privateAssetTarget = input.parentElement.querySelector(
        "[data-private-asset-target]",
      );
      var fileDimensionsTarget = input.parentElement.querySelector(
        "[data-file-dimensions-target]",
      );
      var photoEngravingSourceTarget = input.parentElement.querySelector(
        "[data-photo-engraving-source-target]",
      );
      var photoEngravingRecipeTarget = input.parentElement.querySelector(
        "[data-photo-engraving-recipe-target]",
      );
      var photoEngravingQualityTarget = input.parentElement.querySelector(
        "[data-photo-engraving-quality-target]",
      );
      var photoEngravingEnabled =
        input.dataset.photoEngravingEnabled === "true";
      var fileErrorTarget =
        input.parentElement.querySelector("[data-file-error]");
      var fileStatusTarget =
        input.parentElement.querySelector("[data-file-status]");
      var imagePreviewSlot =
        input.dataset.filePreviewSlot &&
        imagePreviewTargets[input.dataset.filePreviewSlot];
      var imagePreviewSlotImage = imagePreviewSlot
        ? imagePreviewSlot.querySelector("img")
        : null;
      var imagePreviewSlotLabel = imagePreviewSlot
        ? imagePreviewSlot.querySelector("span")
        : null;

      if (!fileErrorTarget) {
        fileErrorTarget = document.createElement("small");
        fileErrorTarget.className = "personalize-pilot-widget__field-error";
        fileErrorTarget.dataset.fileError = "true";
        fileErrorTarget.setAttribute("role", "status");
        fileErrorTarget.setAttribute("aria-live", "polite");
        fileErrorTarget.hidden = true;
        input.parentElement.appendChild(fileErrorTarget);
      }

      if (!fileStatusTarget) {
        fileStatusTarget = document.createElement("small");
        fileStatusTarget.dataset.fileStatus = "true";
        fileStatusTarget.setAttribute("role", "status");
        fileStatusTarget.setAttribute("aria-live", "polite");
        fileStatusTarget.hidden = true;
        input.parentElement.appendChild(fileStatusTarget);
      }

      if (!input.dataset.originalPropertyName && input.name) {
        input.dataset.originalPropertyName = input.name;
      }

      function setFileError(message) {
        fileErrorTarget.textContent = message || "";
        fileErrorTarget.hidden = !message;
        input.setAttribute("aria-invalid", message ? "true" : "false");
      }

      function setFileStatus(message) {
        fileStatusTarget.textContent = message || "";
        fileStatusTarget.hidden = !message;
      }

      function resetPrivateUploadFields() {
        var privateValueTarget = input.parentElement.querySelector(
          "[data-private-value-target]",
        );
        delete input.dataset.nativeUploadFallback;
        if (privateAssetTarget) privateAssetTarget.value = "";
        if (photoEngravingSourceTarget) photoEngravingSourceTarget.value = "";
        if (photoEngravingRecipeTarget) photoEngravingRecipeTarget.value = "";
        if (photoEngravingQualityTarget) photoEngravingQualityTarget.value = "";
        if (privateValueTarget) privateValueTarget.remove();
        if (input.dataset.originalPropertyName) {
          input.setAttribute("name", input.dataset.originalPropertyName);
        }
        input.setCustomValidity("");
        setFileStatus("");
      }

      function revokePreviousPreviewUrl() {
        if (input.dataset.previewObjectUrl) {
          URL.revokeObjectURL(input.dataset.previewObjectUrl);
          delete input.dataset.previewObjectUrl;
        }
        delete input.dataset.previewPrivateUrl;
      }

      function applyFilePreviewUrl(previewUrl) {
        setImageToolsVisible(input.dataset.filePreviewSlot, true);
        if (imagePreviewSlotImage) {
          imagePreviewSlotImage.src = previewUrl;
          imagePreviewSlotImage.hidden = false;
          if (imagePreviewSlotLabel) imagePreviewSlotLabel.hidden = true;
        }
        if (input.dataset.filePreviewSlot) {
          getImageTargets(input.dataset.filePreviewSlot).forEach(
            function (target) {
              applyConfiguredImageFit(target);
              updateImagePreviewTarget(target, previewUrl);
            },
          );
        }
        if (input === primaryImageInput && previewImage) {
          previewImage.src = previewUrl;
          previewImage.hidden = false;
          if (mainImagePreview.previewImage) {
            mainImagePreview.previewImage.src = previewUrl;
            mainImagePreview.previewImage.hidden = false;
          }
        }
        syncConditionalFields();
        refreshMainImageMode();
      }

      async function startPrivateUpload(file, uploadGeneration) {
        if (!file) return null;

        input.setCustomValidity(
          getMessage(
            widget,
            "messageUploadPending",
            "The file is still uploading.",
          ),
        );
        setFileStatus(
          getMessage(
            widget,
            "messageUploadPending",
            "Securely uploading and checking the file ...",
          ),
        );
        try {
          var privateUpload = await uploadFileToPrivateStorage(
            widget,
            file,
            input.parentElement.querySelector("label")?.textContent ||
              "Kundendatei",
            input,
          );
          if (input.dataset.uploadGeneration !== uploadGeneration) return null;
          if (!privateUpload) {
            if (photoEngravingEnabled) {
              throw new Error(
                "Die automatische Gravuraufbereitung ist momentan nicht erreichbar. Bitte versuche es erneut.",
              );
            }
            input.dataset.nativeUploadFallback = "true";
            input.setCustomValidity("");
            setFileStatus(
              "Das Bild wird beim Hinzufügen zum Warenkorb sicher an Shopify übertragen.",
            );
            return null;
          }
          if (
            photoEngravingEnabled &&
            (!privateUpload.processedAsPhotoEngraving ||
              !privateUpload.previewUrl ||
              !privateUpload.sourceAssetId ||
              !privateUpload.recipe)
          ) {
            throw new Error(
              "Das Foto konnte nicht als geprüftes Gravurbild bereitgestellt werden.",
            );
          }

          delete input.dataset.nativeUploadFallback;
          var privateValueTarget = document.createElement("input");
          privateValueTarget.type = "hidden";
          privateValueTarget.dataset.privateValueTarget = "true";
          privateValueTarget.name = input.dataset.originalPropertyName || "";
          privateValueTarget.value =
            "PersonalizePilot Upload " + privateUpload.assetId;
          input.parentElement.appendChild(privateValueTarget);
          input.removeAttribute("name");
          if (privateAssetTarget)
            privateAssetTarget.value = privateUpload.assetId;
          if (photoEngravingSourceTarget)
            photoEngravingSourceTarget.value =
              privateUpload.sourceAssetId || "";
          if (photoEngravingRecipeTarget)
            photoEngravingRecipeTarget.value = privateUpload.recipe || "";
          if (photoEngravingQualityTarget)
            photoEngravingQualityTarget.value = String(
              privateUpload.qualityScore || "",
            );
          if (
            fileDimensionsTarget &&
            privateUpload.width &&
            privateUpload.height
          ) {
            fileDimensionsTarget.value =
              privateUpload.width + "x" + privateUpload.height + " px";
          }
          input.setCustomValidity("");
          if (photoEngravingEnabled) {
            input.dataset.previewPrivateUrl = privateUpload.previewUrl;
            applyFilePreviewUrl(privateUpload.previewUrl);
            setFileStatus(
              privateUpload.qualityWarnings &&
                privateUpload.qualityWarnings.length > 0
                ? getMessage(
                    widget,
                    "messagePhotoCreatedCheck",
                    "Engraving preview created. Please check the visible crop.",
                  )
                : getMessage(
                    widget,
                    "messagePhotoCreated",
                    "Engraving preview created and fitted to fill the area.",
                  ),
            );
          } else {
            setFileStatus(
              getMessage(
                widget,
                "messageUploadComplete",
                "File securely saved and checked.",
              ),
            );
          }
          return privateUpload;
        } catch (error) {
          if (input.dataset.uploadGeneration !== uploadGeneration) return null;
          var message =
            error && error.message
              ? error.message
              : getMessage(
                  widget,
                  "messageUploadFailed",
                  "The secure upload failed.",
                );
          setFileError(message);
          setFileStatus("");
          input.setCustomValidity(message);
          return null;
        }
      }

      input.addEventListener("change", async function (event) {
        var file = event.target.files && event.target.files[0];
        var fileError = getFileError(widget, file, input);
        var imageInspection = { error: "", width: 0, height: 0 };
        var imagePreviewObjectUrl = "";
        var uploadGeneration = String(
          Number(input.dataset.uploadGeneration || "0") + 1,
        );

        input.dataset.uploadGeneration = uploadGeneration;

        resetPrivateUploadFields();

        setImageToolsVisible(input.dataset.filePreviewSlot, false);

        if (!fileError) {
          imageInspection = await inspectRasterImage(widget, file, input);
          fileError = imageInspection.error;
        }
        if (input.dataset.uploadGeneration !== uploadGeneration) return;

        if (fileError) {
          setFileError(fileError);
          input.value = "";
          revokePreviousPreviewUrl();
          if (hiddenTarget) {
            hiddenTarget.value = "";
          }
          if (fileDimensionsTarget) {
            fileDimensionsTarget.value = "";
          }
          if (imagePreviewSlotImage) {
            imagePreviewSlotImage.hidden = true;
            imagePreviewSlotImage.removeAttribute("src");
          }
          if (imagePreviewSlotLabel) {
            imagePreviewSlotLabel.hidden = false;
          }
          if (input === primaryImageInput && previewImage) {
            previewImage.hidden = true;
            previewImage.removeAttribute("src");
          }
          if (input.dataset.filePreviewSlot) {
            getImageTargets(input.dataset.filePreviewSlot).forEach(
              function (target) {
                updateImagePreviewTarget(target, "");
              },
            );
          }
          if (input === primaryImageInput && mainImagePreview.previewImage) {
            mainImagePreview.previewImage.hidden = true;
            mainImagePreview.previewImage.removeAttribute("src");
          }
          updateUploadCount();
          syncConditionalFields();
          refreshMainImageMode();
          return;
        }

        setFileError("");

        if (hiddenTarget) {
          hiddenTarget.value = file
            ? file.name + " (" + Math.round(file.size / 1024) + " KB)"
            : "";
        }
        if (fileDimensionsTarget) {
          fileDimensionsTarget.value =
            imageInspection.width > 0
              ? imageInspection.width + "x" + imageInspection.height + " px"
              : "";
        }
        updateUploadCount();
        if (photoEngravingEnabled) {
          revokePreviousPreviewUrl();
          if (imagePreviewSlotImage) {
            imagePreviewSlotImage.hidden = true;
            imagePreviewSlotImage.removeAttribute("src");
          }
          if (imagePreviewSlotLabel) imagePreviewSlotLabel.hidden = false;
          if (input.dataset.filePreviewSlot) {
            getImageTargets(input.dataset.filePreviewSlot).forEach(
              function (target) {
                updateImagePreviewTarget(target, "");
              },
            );
          }
          if (input === primaryImageInput && previewImage) {
            previewImage.hidden = true;
            previewImage.removeAttribute("src");
          }
          await startPrivateUpload(file, uploadGeneration);
          return;
        }
        startPrivateUpload(file, uploadGeneration);

        if (!file || !file.type.startsWith("image/")) {
          revokePreviousPreviewUrl();
          if (imagePreviewSlotImage) {
            imagePreviewSlotImage.hidden = true;
            imagePreviewSlotImage.removeAttribute("src");
          }
          if (imagePreviewSlotLabel) {
            imagePreviewSlotLabel.hidden = false;
          }
          if (input.dataset.filePreviewSlot) {
            getImageTargets(input.dataset.filePreviewSlot).forEach(
              function (target) {
                updateImagePreviewTarget(target, "");
              },
            );
          }
          if (input === primaryImageInput && previewImage) {
            previewImage.hidden = true;
            previewImage.removeAttribute("src");
          }
          if (input === primaryImageInput && mainImagePreview.previewImage) {
            mainImagePreview.previewImage.hidden = true;
            mainImagePreview.previewImage.removeAttribute("src");
          }
          syncConditionalFields();
          refreshMainImageMode();
          return;
        }

        revokePreviousPreviewUrl();
        try {
          imagePreviewObjectUrl =
            (await createTransparentWhitePreviewObjectUrl(file)) ||
            URL.createObjectURL(file);
        } catch (error) {
          imagePreviewObjectUrl = URL.createObjectURL(file);
        }
        if (input.dataset.uploadGeneration !== uploadGeneration) {
          URL.revokeObjectURL(imagePreviewObjectUrl);
          return;
        }
        input.dataset.previewObjectUrl = imagePreviewObjectUrl;

        applyFilePreviewUrl(imagePreviewObjectUrl);
      });
    });

    var resetButton = widget.querySelector("[data-personalization-reset]");
    if (resetButton) {
      resetButton.addEventListener("click", function () {
        freeformItems = [];
        resetFreeformHistory();
        renderFreeformEditor();
        widget
          .querySelectorAll('input:not([type="hidden"]), select, textarea')
          .forEach(function (control) {
            if (control.type === "file") {
              control.value = "";
              control.dispatchEvent(new Event("change", { bubbles: true }));
              return;
            }

            if (control.type === "checkbox") {
              control.checked = false;
            } else if (control.type === "radio") {
              control.checked = control.dataset.choiceDefault === "true";
            } else if (control.tagName === "SELECT") {
              control.selectedIndex = 0;
            } else if (control.type === "color") {
              control.value = control.defaultValue;
            } else if (control.type === "range") {
              control.value =
                control.dataset.imageScaleDefault || control.defaultValue;
            } else {
              control.value = "";
            }

            control.setCustomValidity("");
            control.removeAttribute("aria-invalid");
            control.dispatchEvent(new Event("input", { bubbles: true }));
            control.dispatchEvent(new Event("change", { bubbles: true }));
          });

        widget
          .querySelectorAll("[data-symbol-input]")
          .forEach(function (input) {
            input.value = "";
            getImageTargets(input.dataset.symbolInput || "").forEach(
              function (target) {
                updateImagePreviewTarget(target, "");
              },
            );
          });
        widget
          .querySelectorAll("[data-symbol-option]")
          .forEach(function (button) {
            button.setAttribute(
              "aria-pressed",
              button.dataset.symbolValue ? "false" : "true",
            );
          });
        widget
          .querySelectorAll("[data-template-picker]")
          .forEach(function (picker) {
            delete picker.dataset.templateUserSelected;
          });
        templateOptionButtons.forEach(function (button) {
          if (button.dataset.templateDefault === "true") {
            applyTemplateOption(button, false);
          }
        });
        if (fontInput && fontOptionButtons.length > 0) {
          fontInput.value = fontOptionButtons[0].dataset.fontValue || "";
          fontOptionButtons.forEach(function (button, index) {
            button.setAttribute("aria-pressed", index === 0 ? "true" : "false");
          });
        }

        if (personalizationSurfaces.length > 0) {
          applySurfaceConfiguration(personalizationSurfaces[0].id || "front");
        }
        applyPersonalizationChoice();
        updateUploadCount();
        syncConditionalFields();
        updatePreviewFont();
        refreshMainImageMode();
        scheduleMainImagePreviewRefresh();
      });
    }

    updateUploadCount();
    syncImageScaleControlsToPreview();
    refreshPhotoCrops();
    applyPersonalizationChoice();

    var runtimeProof = widget.querySelector(
      "[data-personalize-pilot-runtime-proof]",
    );
    if (
      runtimeProof &&
      form &&
      widget.dataset.personalizePilotFormConnected === "true"
    ) {
      runtimeProof.checked = true;
      widget.dataset.personalizePilotRuntimeReady = "true";
    }

    // Font metrics can change after the storefront web fonts finish loading.
    // Re-fit the text once with the final font so preview and production use
    // the same visual bounds instead of keeping measurements from a fallback.
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () {
        if (!widget.isConnected) return;
        syncTextInputsToPreview();
        updateFontSamples();
        refreshMainImageMode();
        scheduleMainImagePreviewRefresh();
      });
    }

    [250, 1000, 2500].forEach(function (delay) {
      window.setTimeout(function () {
        refreshMainImagePreview();
      }, delay);
    });
  }

  function attachAllWidgets(event) {
    var editorRefreshEvents = [
      "shopify:section:load",
      "shopify:section:select",
      "shopify:section:deselect",
      "shopify:section:reorder",
      "shopify:block:select",
      "shopify:block:deselect",
    ];
    var isShopifyEditorRefresh = Boolean(
      event &&
      event.target !== document &&
      editorRefreshEvents.indexOf(event.type) !== -1,
    );
    var eventWidgets = [];

    if (isShopifyEditorRefresh && event.target) {
      if (
        event.target.matches &&
        event.target.matches("[data-personalize-pilot-widget]")
      ) {
        eventWidgets.push(event.target);
      }
      if (event.target.querySelectorAll) {
        eventWidgets = eventWidgets.concat(
          Array.prototype.slice.call(
            event.target.querySelectorAll("[data-personalize-pilot-widget]"),
          ),
        );
      }
    }

    if (eventWidgets.length > 0) {
      eventWidgets.forEach(function (widget) {
        try {
          attachWidget(widget, true);
        } catch (error) {
          widget.dataset.personalizePilotRuntimeError =
            (error && error.message) || "Widget initialization failed";
          console.error("PersonalizePilot initialization failed", error);
        }
      });
      return;
    }

    document
      .querySelectorAll("[data-personalize-pilot-widget]")
      .forEach(function (widget) {
        try {
          attachWidget(widget, false);
        } catch (error) {
          widget.dataset.personalizePilotRuntimeError =
            (error && error.message) || "Widget initialization failed";
          console.error("PersonalizePilot initialization failed", error);
        }
      });
  }

  window.PersonalizePilotAttachAllWidgets = attachAllWidgets;

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", attachAllWidgets);
  } else {
    attachAllWidgets();
  }

  [
    "shopify:section:load",
    "shopify:section:select",
    "shopify:section:deselect",
    "shopify:section:reorder",
    "shopify:block:select",
    "shopify:block:deselect",
  ].forEach(function (eventName) {
    document.addEventListener(eventName, attachAllWidgets);
  });

  if (window.MutationObserver && document.documentElement) {
    var widgetLifecycleObserver = new MutationObserver(function (mutations) {
      var widgetAdded = mutations.some(function (mutation) {
        return Array.prototype.some.call(mutation.addedNodes, function (node) {
          if (!node || node.nodeType !== 1) return false;
          return (
            (node.matches && node.matches("[data-personalize-pilot-widget]")) ||
            Boolean(
              node.querySelector &&
              node.querySelector("[data-personalize-pilot-widget]"),
            )
          );
        });
      });

      if (widgetAdded) {
        window.requestAnimationFrame(function () {
          attachAllWidgets();
        });
      }
    });

    widgetLifecycleObserver.observe(document.documentElement, {
      childList: true,
      subtree: true,
    });
  }
})();
